
export const PAGE_CONFIG = {
  title: 'Performance Monitoring',
  titleCN: '性能监控',
  subTitle: '',
  subTitleCN: '',
  showTimeZone: true,
  timeZone: '+0',
  path: '/performance/overall',
  defaultTab: 'android',
  tabList: [
    {
      id: 'android',
      tabName: 'Android',
      tabNameCN: '安卓',
      isHaveNotification: false,
      path: '/performance/overall',
      logConfig: {
        pageId: '210201',
        pageName: 'performanceOverallAndroid',
        extInfo: 'performanceOverallAndroid',
        pagePath: '/performance/overall',
      },
      children: [
        {
          name: 'PerformanceOverviewService',
          type: 'view',
          props: {
            platform: 'android',
            requestParams: {
              platform: 0,
              version: '1.0.0_11200.426',
              projectId: 5120,
              projVersionIds: [1545314],
              dateRangeDays: 14,
              userName: 'judymao',
              timezoneOffset: 0,
            },
            formatBeforeRequest: "function(data) {\n  data = data || {};\n  var gameCode = data.gameCode;\n  var platform = data.platform;\n  var requestParams = data.requestParams || {};\n  var tz;\n  if (typeof data.timeZone === 'number' && isFinite(data.timeZone)) {\n    tz = data.timeZone;\n  } else {\n    tz = Number(requestParams.timezoneOffset);\n    if (!isFinite(tz)) {\n      var matched = String(data.timeZone || '').match(/([+-]?\\d+)/);\n      tz = matched ? Number(matched[1]) : 0;\n    }\n  }\n  var days = Number(requestParams.dateRangeDays);\n  var dateRangeDays = isFinite(days) && days > 0 ? days : 14;\n  var pad = function(n) { return n < 10 ? '0' + n : '' + n; };\n  var formatDateTime = function(date) {\n    return date.getUTCFullYear() + '-' + pad(date.getUTCMonth() + 1) + '-' + pad(date.getUTCDate()) + ' ' + pad(date.getUTCHours()) + ':' + pad(date.getUTCMinutes()) + ':' + pad(date.getUTCSeconds());\n  };\n  var shifted = new Date(Date.now() + tz * 3600000);\n  shifted.setUTCMinutes(0, 0, 0);\n  var startTime = new Date(shifted.getTime() - dateRangeDays * 86400000);\n  var resolvedPlatform = typeof requestParams.platform === 'number'\n    ? requestParams.platform\n    : (typeof platform === 'number' ? platform : ({ android: 0, ios: 1, windows: 5 }[String(platform || '').toLowerCase()] || 0));\n  var version = requestParams.version\n    ? String(requestParams.version)\n    : (Array.isArray(requestParams.app_version) && requestParams.app_version[0] ? String(requestParams.app_version[0]) : '');\n  return Object.assign({}, requestParams, {\n    game_code: gameCode,\n    platform: resolvedPlatform,\n    version: version,\n    end_time: formatDateTime(shifted),\n    start_time: formatDateTime(startTime)\n  });\n}",
            formatData: "function(response) {\n  var payload = (response && response.data && response.data.ret) || (response && response.data) || (response && response.ret) || response || {};\n  return {\n    last24h: payload.last24h || {},\n    lastWeek: payload.lastWeek || {},\n    msg: payload.msg,\n    requestid: payload.requestid,\n    endTime: (response && response.req && response.req.end_time) || payload.end_time || ''\n  };\n}",
          },
          children: [
            {
              name: 'PerformanceOverview',
              type: 'view',
              props: {
                platform: 'android',
                config: {
                  titleEn: 'Performance Overview',
                  titleCn: '性能总览',
                  updateTimeLabelCn: '数据更新处理时间：',
                  dayRateLabelCn: '日环比',
                  weekRateLabelCn: '上周同期',
                  wowRateLabelCn: '周环比',
                  showRadar: false,
                  radarHeight: 270,
                  periodOptions: [
                    { text: '近24小时', value: 'day' },
                    { text: '近一周', value: 'week' },
                  ],
                  componentMetrics: [
                    {
                      metricKey: 'avg_fps',
                      nameCn: 'FPS均值',
                      nameEn: 'Average FPS',
                      unitCn: '帧/秒',
                      unitEn: 'FPS',
                      formatRule: 'twoDecimal',
                      rateFormatRule: 'percent2Decimal',
                      betterDirection: 'up',
                    },
                    {
                      metricKey: 'fps_jitter',
                      nameCn: 'FPS抖动',
                      nameEn: 'FPS Jitter',
                      unitCn: '次/小时',
                      unitEn: 'times/hour',
                      formatRule: 'twoDecimal',
                      rateFormatRule: 'percent2Decimal',
                      betterDirection: 'down',
                    },
                    {
                      metricKey: 'fps_stutter',
                      nameCn: 'FPS卡顿',
                      nameEn: 'FPS Stutter',
                      unitCn: '次/小时',
                      unitEn: 'times/hour',
                      formatRule: 'twoDecimal',
                      rateFormatRule: 'percent2Decimal',
                      betterDirection: 'down',
                    },
                    {
                      metricKey: 'jank',
                      nameCn: 'Jank卡顿',
                      nameEn: 'Jank',
                      unitCn: '次/10分钟',
                      unitEn: 'times/10min',
                      formatRule: 'twoDecimal',
                      rateFormatRule: 'percent2Decimal',
                      betterDirection: 'down',
                    },
                    {
                      metricKey: 'big_jank',
                      nameCn: 'BigJank卡顿',
                      nameEn: 'Big Jank',
                      unitCn: '次/10分钟',
                      unitEn: 'times/10min',
                      formatRule: 'twoDecimal',
                      rateFormatRule: 'percent2Decimal',
                      betterDirection: 'down',
                    },
                    {
                      metricKey: 'pss_peak',
                      nameCn: 'PSS内存峰值均值',
                      nameEn: 'Average PSS Peak',
                      unitCn: 'MB',
                      unitEn: 'MB',
                      formatRule: 'thousands2Decimal',
                      rateFormatRule: 'percent2Decimal',
                      betterDirection: 'down',
                    },
                    {
                      metricKey: 'avg_power',
                      nameCn: '平均功耗',
                      nameEn: 'Average Power',
                      unitCn: 'mW',
                      unitEn: 'mW',
                      formatRule: 'thousands2Decimal',
                      rateFormatRule: 'percent2Decimal',
                      betterDirection: 'down',
                    },
                  ],
                  matchMetric: {
                    metricKey: 'matches',
                    nameCn: '对局数',
                    nameEn: 'Matches',
                    unitCn: '',
                    unitEn: '',
                    formatRule: 'thousandsInit',
                  },
                },
              },
            },
          ],
        },
      ],
      filters: [
        {
          name: 'PerformanceFilter',
          type: 'view',
          isOpenSticky: false,
          isHaveFilterSave: false,
          platform: 'android',
          filterPath: '/performance/overall',
          countryRegionOptions: [
            {
              "country_code": -1,
              "country_name_ch": "全部",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "",
              "cityIds": [],
              "provinces": []
            },
            {
              "country_code": 77,
              "country_name_ch": "菲律宾",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Philippines.svg",
              "cityIds": [
                785,
                786,
                787,
                788,
                789,
                790,
                791,
                792,
                793,
                794,
                795,
                796,
                797,
                798,
                799,
                800,
                801,
                802,
                803,
                804,
                805,
                806
              ],
              "provinces": [
                {
                  "label": "马尼拉都会区",
                  "value": 785
                },
                {
                  "label": "吕宋岛",
                  "value": 786
                },
                {
                  "label": "棉兰老岛",
                  "value": 787
                },
                {
                  "label": "中央吕宋大区",
                  "value": 788
                },
                {
                  "label": "达沃大区",
                  "value": 789
                },
                {
                  "label": "北棉兰老大区",
                  "value": 790
                },
                {
                  "label": "卡加延河谷大区",
                  "value": 791
                },
                {
                  "label": "南哥苏库萨将大区",
                  "value": 792
                },
                {
                  "label": "卡拉巴松大区",
                  "value": 793
                },
                {
                  "label": "中米沙鄢大区",
                  "value": 794
                },
                {
                  "label": "菲律宾",
                  "value": 795
                },
                {
                  "label": "米沙鄢群岛",
                  "value": 796
                },
                {
                  "label": "内格罗斯岛大区",
                  "value": 797
                },
                {
                  "label": "民马罗巴大区",
                  "value": 798
                },
                {
                  "label": "东米沙鄢大区",
                  "value": 799
                },
                {
                  "label": "卡拉加大区",
                  "value": 800
                },
                {
                  "label": "科迪勒拉大区",
                  "value": 801
                },
                {
                  "label": "三宝颜半岛区",
                  "value": 802
                },
                {
                  "label": "伊罗戈大区",
                  "value": 803
                },
                {
                  "label": "比科尔大区",
                  "value": 804
                },
                {
                  "label": "西米沙鄢大区",
                  "value": 805
                },
                {
                  "label": "棉兰老穆斯林自治区",
                  "value": 806
                }
              ]
            },
            {
              "country_code": 1,
              "country_name_ch": "中国",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/China.svg",
              "cityIds": [
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23,
                24
              ],
              "provinces": [
                {
                  "label": "陕西",
                  "value": 1
                },
                {
                  "label": "北京",
                  "value": 2
                },
                {
                  "label": "辽宁",
                  "value": 3
                },
                {
                  "label": "湖南",
                  "value": 4
                },
                {
                  "label": "重庆",
                  "value": 5
                },
                {
                  "label": "安徽",
                  "value": 6
                },
                {
                  "label": "江苏",
                  "value": 7
                },
                {
                  "label": "浙江",
                  "value": 8
                },
                {
                  "label": "中国",
                  "value": 9
                },
                {
                  "label": "内蒙古",
                  "value": 10
                },
                {
                  "label": "新疆",
                  "value": 11
                },
                {
                  "label": "澳门",
                  "value": 12
                },
                {
                  "label": "河南",
                  "value": 13
                },
                {
                  "label": "香港",
                  "value": 14
                },
                {
                  "label": "上海",
                  "value": 15
                },
                {
                  "label": "台湾",
                  "value": 16
                },
                {
                  "label": "四川",
                  "value": 17
                },
                {
                  "label": "广西",
                  "value": 18
                },
                {
                  "label": "福建",
                  "value": 19
                },
                {
                  "label": "海南",
                  "value": 20
                },
                {
                  "label": "广东",
                  "value": 21
                },
                {
                  "label": "云南",
                  "value": 22
                },
                {
                  "label": "山东",
                  "value": 23
                },
                {
                  "label": "湖北",
                  "value": 24
                }
              ]
            },
            {
              "country_code": 109,
              "country_name_ch": "印度尼西亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Indonesia.svg",
              "cityIds": [
                1033,
                1034,
                1035,
                1036,
                1037,
                1038,
                1039,
                1040,
                1041,
                1042,
                1043,
                1044,
                1045,
                1046,
                1047,
                1048,
                1049,
                1050,
                1051,
                1052,
                1053,
                1054,
                1055,
                1056,
                1057,
                1058,
                1059,
                1060,
                1061,
                1062,
                1063,
                1064,
                1065,
                1066,
                1067,
                1068,
                1069,
                1070,
                1071,
                1072,
                1073,
                1074,
                1075
              ],
              "provinces": [
                {
                  "label": "苏拉威西岛",
                  "value": 1033
                },
                {
                  "label": "南苏拉威西省",
                  "value": 1034
                },
                {
                  "label": "明古鲁省",
                  "value": 1035
                },
                {
                  "label": "小巽他群岛",
                  "value": 1036
                },
                {
                  "label": "苏门答腊岛",
                  "value": 1037
                },
                {
                  "label": "哥伦打洛省",
                  "value": 1038
                },
                {
                  "label": "印度尼西亚",
                  "value": 1039
                },
                {
                  "label": "东爪哇省",
                  "value": 1040
                },
                {
                  "label": "楠榜省",
                  "value": 1041
                },
                {
                  "label": "东南苏拉威西省",
                  "value": 1042
                },
                {
                  "label": "邦加－勿里洞省",
                  "value": 1043
                },
                {
                  "label": "爪哇岛",
                  "value": 1044
                },
                {
                  "label": "亚齐特区",
                  "value": 1045
                },
                {
                  "label": "中加里曼丹省",
                  "value": 1046
                },
                {
                  "label": "巴布亚省",
                  "value": 1047
                },
                {
                  "label": "中巴布亚省",
                  "value": 1048
                },
                {
                  "label": "西苏拉威西省",
                  "value": 1049
                },
                {
                  "label": "西努沙登加拉省",
                  "value": 1050
                },
                {
                  "label": "日惹特区",
                  "value": 1051
                },
                {
                  "label": "西巴布亚岛",
                  "value": 1052
                },
                {
                  "label": "西巴布亚省",
                  "value": 1053
                },
                {
                  "label": "中爪哇省",
                  "value": 1054
                },
                {
                  "label": "西苏门答腊省",
                  "value": 1055
                },
                {
                  "label": "南苏门答腊省",
                  "value": 1056
                },
                {
                  "label": "东加里曼丹省",
                  "value": 1057
                },
                {
                  "label": "巴厘省",
                  "value": 1058
                },
                {
                  "label": "万丹省",
                  "value": 1059
                },
                {
                  "label": "北马鲁古省",
                  "value": 1060
                },
                {
                  "label": "雅加达",
                  "value": 1061
                },
                {
                  "label": "加里曼丹岛",
                  "value": 1062
                },
                {
                  "label": "廖内群岛省",
                  "value": 1063
                },
                {
                  "label": "中苏拉威西省",
                  "value": 1064
                },
                {
                  "label": "西加里曼丹省",
                  "value": 1065
                },
                {
                  "label": "马鲁古省",
                  "value": 1066
                },
                {
                  "label": "西爪哇省",
                  "value": 1067
                },
                {
                  "label": "南加里曼丹省",
                  "value": 1068
                },
                {
                  "label": "占碑省",
                  "value": 1069
                },
                {
                  "label": "北加里曼丹省",
                  "value": 1070
                },
                {
                  "label": "北苏拉威西省",
                  "value": 1071
                },
                {
                  "label": "东努沙登加拉省",
                  "value": 1072
                },
                {
                  "label": "北苏门答腊省",
                  "value": 1073
                },
                {
                  "label": "廖内省",
                  "value": 1074
                },
                {
                  "label": "南巴布亚省",
                  "value": 1075
                }
              ]
            },
            {
              "country_code": 174,
              "country_name_ch": "美国",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/USA.svg",
              "cityIds": [
                259,
                260,
                261,
                262,
                263,
                264,
                265,
                266,
                267,
                268,
                269,
                270,
                271,
                272,
                273,
                274,
                275,
                276,
                277,
                278,
                279,
                280,
                281,
                282,
                283,
                284,
                285,
                286,
                287,
                288,
                289,
                290,
                291,
                292,
                293,
                294
              ],
              "provinces": [
                {
                  "label": "马里兰州",
                  "value": 259
                },
                {
                  "label": "密苏里州",
                  "value": 260
                },
                {
                  "label": "怀俄明州",
                  "value": 261
                },
                {
                  "label": "亚利桑那州",
                  "value": 262
                },
                {
                  "label": "西弗吉尼亚州",
                  "value": 263
                },
                {
                  "label": "俄亥俄州",
                  "value": 264
                },
                {
                  "label": "明尼苏达州",
                  "value": 265
                },
                {
                  "label": "内华达州",
                  "value": 266
                },
                {
                  "label": "华盛顿州",
                  "value": 267
                },
                {
                  "label": "德克萨斯州",
                  "value": 268
                },
                {
                  "label": "新泽西州",
                  "value": 269
                },
                {
                  "label": "北卡罗来纳州",
                  "value": 270
                },
                {
                  "label": "堪萨斯州",
                  "value": 271
                },
                {
                  "label": "纽约州",
                  "value": 272
                },
                {
                  "label": "马萨诸塞州",
                  "value": 273
                },
                {
                  "label": "俄勒冈州",
                  "value": 274
                },
                {
                  "label": "缅因州",
                  "value": 275
                },
                {
                  "label": "新墨西哥州",
                  "value": 276
                },
                {
                  "label": "犹他州",
                  "value": 277
                },
                {
                  "label": "路易斯安那州",
                  "value": 278
                },
                {
                  "label": "佛罗里达州",
                  "value": 279
                },
                {
                  "label": "宾夕法尼亚州",
                  "value": 280
                },
                {
                  "label": "科罗拉多州",
                  "value": 281
                },
                {
                  "label": "亚拉巴马州",
                  "value": 282
                },
                {
                  "label": "加利福尼亚州",
                  "value": 283
                },
                {
                  "label": "康涅狄格州",
                  "value": 284
                },
                {
                  "label": "田纳西州",
                  "value": 285
                },
                {
                  "label": "南卡罗来纳州",
                  "value": 286
                },
                {
                  "label": "华盛顿",
                  "value": 287
                },
                {
                  "label": "俄克拉荷马州",
                  "value": 288
                },
                {
                  "label": "弗吉尼亚州",
                  "value": 289
                },
                {
                  "label": "乔治亚州",
                  "value": 290
                },
                {
                  "label": "密歇根州",
                  "value": 291
                },
                {
                  "label": "美国",
                  "value": 292
                },
                {
                  "label": "伊利诺伊州",
                  "value": 293
                },
                {
                  "label": "威斯康星州",
                  "value": 294
                }
              ]
            },
            {
              "country_code": 102,
              "country_name_ch": "印度",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/India.svg",
              "cityIds": [
                978,
                979,
                980,
                981,
                982,
                983,
                984,
                985,
                986,
                987,
                988,
                989,
                990,
                991,
                992,
                993,
                994,
                995,
                996,
                997,
                998,
                999,
                1000,
                1001,
                1002,
                1003,
                1004,
                1005,
                1006,
                1007,
                1008,
                1009,
                1010,
                1011,
                1012,
                1013,
                1014,
                1015,
                1016
              ],
              "provinces": [
                {
                  "label": "本地冶里联邦直辖区",
                  "value": 978
                },
                {
                  "label": "东北部地区",
                  "value": 979
                },
                {
                  "label": "古吉拉特邦",
                  "value": 980
                },
                {
                  "label": "锡金邦",
                  "value": 981
                },
                {
                  "label": "达德拉－纳加尔哈维利和达曼－第乌",
                  "value": 982
                },
                {
                  "label": "奥里萨邦",
                  "value": 983
                },
                {
                  "label": "贾坎德邦",
                  "value": 984
                },
                {
                  "label": "哈里亚纳邦",
                  "value": 985
                },
                {
                  "label": "旁遮普邦",
                  "value": 986
                },
                {
                  "label": "安达曼－尼科巴群岛",
                  "value": 987
                },
                {
                  "label": "曼尼普尔邦",
                  "value": 988
                },
                {
                  "label": "喜马偕尔邦",
                  "value": 989
                },
                {
                  "label": "安得拉邦",
                  "value": 990
                },
                {
                  "label": "昌迪加尔",
                  "value": 991
                },
                {
                  "label": "马哈拉施特拉邦",
                  "value": 992
                },
                {
                  "label": "德里",
                  "value": 993
                },
                {
                  "label": "西孟加拉邦",
                  "value": 994
                },
                {
                  "label": "拉贾斯坦邦",
                  "value": 995
                },
                {
                  "label": "果阿邦",
                  "value": 996
                },
                {
                  "label": "印度",
                  "value": 997
                },
                {
                  "label": "北部地区",
                  "value": 998
                },
                {
                  "label": "比哈尔邦",
                  "value": 999
                },
                {
                  "label": "阿萨姆邦",
                  "value": 1000
                },
                {
                  "label": "中央邦",
                  "value": 1001
                },
                {
                  "label": "米佐拉姆邦",
                  "value": 1002
                },
                {
                  "label": "北方邦",
                  "value": 1003
                },
                {
                  "label": "恰蒂斯加尔邦",
                  "value": 1004
                },
                {
                  "label": "查谟和克什米尔邦",
                  "value": 1005
                },
                {
                  "label": "东部地区",
                  "value": 1006
                },
                {
                  "label": "拉克沙群岛",
                  "value": 1007
                },
                {
                  "label": "梅加拉亚邦",
                  "value": 1008
                },
                {
                  "label": "泰米尔纳德邦",
                  "value": 1009
                },
                {
                  "label": "中部地区",
                  "value": 1010
                },
                {
                  "label": "那加兰邦",
                  "value": 1011
                },
                {
                  "label": "喀拉拉邦",
                  "value": 1012
                },
                {
                  "label": "卡纳塔克邦",
                  "value": 1013
                },
                {
                  "label": "特伦甘纳邦",
                  "value": 1014
                },
                {
                  "label": "北阿坎德邦",
                  "value": 1015
                },
                {
                  "label": "特里普拉邦",
                  "value": 1016
                }
              ]
            },
            {
              "country_code": 65,
              "country_name_ch": "土耳其",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Turkey.svg",
              "cityIds": [
                625,
                626,
                627,
                628,
                629,
                630,
                631,
                632,
                633,
                634,
                635,
                636,
                637,
                638,
                639,
                640,
                641,
                642,
                643,
                644,
                645,
                646,
                647,
                648,
                649,
                650,
                651,
                652,
                653,
                654,
                655,
                656,
                657,
                658,
                659,
                660,
                661,
                662,
                663,
                664,
                665,
                666,
                667,
                668,
                669,
                670,
                671,
                672,
                673,
                674,
                675,
                676,
                677,
                678,
                679,
                680,
                681,
                682,
                683,
                684,
                685,
                686,
                687,
                688,
                689,
                690,
                691,
                692,
                693,
                694,
                695,
                696,
                697,
                698,
                699,
                700,
                701,
                702,
                703,
                704
              ],
              "provinces": [
                {
                  "label": "泰基尔达省",
                  "value": 625
                },
                {
                  "label": "埃尔津詹省",
                  "value": 626
                },
                {
                  "label": "亚洛瓦省",
                  "value": 627
                },
                {
                  "label": "乌沙克省",
                  "value": 628
                },
                {
                  "label": "穆什省",
                  "value": 629
                },
                {
                  "label": "阿克萨赖省",
                  "value": 630
                },
                {
                  "label": "卡拉比克省",
                  "value": 631
                },
                {
                  "label": "马尔马拉地区",
                  "value": 632
                },
                {
                  "label": "宗古尔达克省",
                  "value": 633
                },
                {
                  "label": "巴特曼省",
                  "value": 634
                },
                {
                  "label": "尚勒乌尔法省",
                  "value": 635
                },
                {
                  "label": "哈塔伊省",
                  "value": 636
                },
                {
                  "label": "乔鲁姆省",
                  "value": 637
                },
                {
                  "label": "代尼兹利省",
                  "value": 638
                },
                {
                  "label": "舍尔纳克省",
                  "value": 639
                },
                {
                  "label": "梅尔辛省",
                  "value": 640
                },
                {
                  "label": "特拉布宗省",
                  "value": 641
                },
                {
                  "label": "迪兹杰省",
                  "value": 642
                },
                {
                  "label": "克勒克卡莱省",
                  "value": 643
                },
                {
                  "label": "穆拉省",
                  "value": 644
                },
                {
                  "label": "东部安那托利亚地区",
                  "value": 645
                },
                {
                  "label": "中部安那托利亚地区",
                  "value": 646
                },
                {
                  "label": "托卡特省",
                  "value": 647
                },
                {
                  "label": "萨卡里亚省",
                  "value": 648
                },
                {
                  "label": "埃尔祖鲁姆省",
                  "value": 649
                },
                {
                  "label": "安塔利亚省",
                  "value": 650
                },
                {
                  "label": "基利斯省",
                  "value": 651
                },
                {
                  "label": "奥尔杜省",
                  "value": 652
                },
                {
                  "label": "埃斯基谢希尔省",
                  "value": 653
                },
                {
                  "label": "萨姆松省",
                  "value": 654
                },
                {
                  "label": "艾登省",
                  "value": 655
                },
                {
                  "label": "克尔克拉雷利省",
                  "value": 656
                },
                {
                  "label": "巴勒克埃西尔省",
                  "value": 657
                },
                {
                  "label": "布尔杜尔省",
                  "value": 658
                },
                {
                  "label": "阿尔特温省",
                  "value": 659
                },
                {
                  "label": "爱琴海地区",
                  "value": 660
                },
                {
                  "label": "开塞利省",
                  "value": 661
                },
                {
                  "label": "卡赫拉曼马拉什省",
                  "value": 662
                },
                {
                  "label": "博卢省",
                  "value": 663
                },
                {
                  "label": "巴尔滕省",
                  "value": 664
                },
                {
                  "label": "卡尔斯省",
                  "value": 665
                },
                {
                  "label": "土耳其",
                  "value": 666
                },
                {
                  "label": "迪亚巴克尔省",
                  "value": 667
                },
                {
                  "label": "科尼亚省",
                  "value": 668
                },
                {
                  "label": "尼代省",
                  "value": 669
                },
                {
                  "label": "埃拉泽省",
                  "value": 670
                },
                {
                  "label": "科加厄利省",
                  "value": 671
                },
                {
                  "label": "内夫谢希尔省",
                  "value": 672
                },
                {
                  "label": "卡拉曼省",
                  "value": 673
                },
                {
                  "label": "东南安那托利亚地区",
                  "value": 674
                },
                {
                  "label": "比莱吉克省",
                  "value": 675
                },
                {
                  "label": "安卡拉省",
                  "value": 676
                },
                {
                  "label": "马尔丁省",
                  "value": 677
                },
                {
                  "label": "阿达纳省",
                  "value": 678
                },
                {
                  "label": "凡城省",
                  "value": 679
                },
                {
                  "label": "卡斯塔莫努省",
                  "value": 680
                },
                {
                  "label": "伊兹密尔省",
                  "value": 681
                },
                {
                  "label": "阿菲永卡拉希萨尔省",
                  "value": 682
                },
                {
                  "label": "锡瓦斯省",
                  "value": 683
                },
                {
                  "label": "昌克勒省",
                  "value": 684
                },
                {
                  "label": "埃迪尔内省",
                  "value": 685
                },
                {
                  "label": "马拉蒂亚省",
                  "value": 686
                },
                {
                  "label": "阿勒省",
                  "value": 687
                },
                {
                  "label": "黑海地区",
                  "value": 688
                },
                {
                  "label": "伊斯坦布尔省",
                  "value": 689
                },
                {
                  "label": "吉雷松省",
                  "value": 690
                },
                {
                  "label": "布尔萨省",
                  "value": 691
                },
                {
                  "label": "恰纳卡莱省",
                  "value": 692
                },
                {
                  "label": "加济安泰普省",
                  "value": 693
                },
                {
                  "label": "克尔谢希尔省",
                  "value": 694
                },
                {
                  "label": "里泽省",
                  "value": 695
                },
                {
                  "label": "锡诺普省",
                  "value": 696
                },
                {
                  "label": "奥斯曼尼耶省",
                  "value": 697
                },
                {
                  "label": "马尼萨省",
                  "value": 698
                },
                {
                  "label": "伊斯帕尔塔省",
                  "value": 699
                },
                {
                  "label": "地中海地区",
                  "value": 700
                },
                {
                  "label": "约兹加特省",
                  "value": 701
                },
                {
                  "label": "屈塔希亚省",
                  "value": 702
                },
                {
                  "label": "阿马西亚省",
                  "value": 703
                },
                {
                  "label": "锡尔特省",
                  "value": 704
                }
              ]
            },
            {
              "country_code": 136,
              "country_name_ch": "亚太地区",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "",
              "cityIds": [
                1246
              ],
              "provinces": [
                {
                  "label": "亚太地区",
                  "value": 1246
                }
              ]
            },
            {
              "country_code": 7,
              "country_name_ch": "日本",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Japan.svg",
              "cityIds": [
                68,
                69,
                70,
                71,
                72,
                73,
                74,
                75,
                76,
                77,
                78,
                79
              ],
              "provinces": [
                {
                  "label": "爱知县",
                  "value": 68
                },
                {
                  "label": "东京都",
                  "value": 69
                },
                {
                  "label": "北海道",
                  "value": 70
                },
                {
                  "label": "大阪府",
                  "value": 71
                },
                {
                  "label": "茨城县",
                  "value": 72
                },
                {
                  "label": "富山县",
                  "value": 73
                },
                {
                  "label": "日本",
                  "value": 74
                },
                {
                  "label": "京都府",
                  "value": 75
                },
                {
                  "label": "千叶县",
                  "value": 76
                },
                {
                  "label": "岐阜县",
                  "value": 77
                },
                {
                  "label": "山形县",
                  "value": 78
                },
                {
                  "label": "神奈川县",
                  "value": 79
                }
              ]
            },
            {
              "country_code": 46,
              "country_name_ch": "泰国",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Thailand.svg",
              "cityIds": [
                451,
                452,
                453,
                454,
                455,
                456,
                457,
                458,
                459,
                460,
                461,
                462,
                463,
                464,
                465,
                466,
                467,
                468,
                469,
                470,
                471,
                472,
                473,
                474,
                475,
                476,
                477,
                478,
                479,
                480,
                481,
                482,
                483,
                484,
                485,
                486,
                487,
                488,
                489,
                490,
                491,
                492,
                493,
                494,
                495,
                496,
                497,
                498,
                499,
                500,
                501,
                502,
                503,
                504,
                505,
                506,
                507,
                508,
                509,
                510,
                511,
                512
              ],
              "provinces": [
                {
                  "label": "罗勇府",
                  "value": 451
                },
                {
                  "label": "呵叻府",
                  "value": 452
                },
                {
                  "label": "北部大区",
                  "value": 453
                },
                {
                  "label": "清莱府",
                  "value": 454
                },
                {
                  "label": "北碧府",
                  "value": 455
                },
                {
                  "label": "碧差汶府",
                  "value": 456
                },
                {
                  "label": "春武里府",
                  "value": 457
                },
                {
                  "label": "普吉府",
                  "value": 458
                },
                {
                  "label": "曼谷",
                  "value": 459
                },
                {
                  "label": "龙仔厝府",
                  "value": 460
                },
                {
                  "label": "程逸府",
                  "value": 461
                },
                {
                  "label": "佛统府",
                  "value": 462
                },
                {
                  "label": "那空拍侬府",
                  "value": 463
                },
                {
                  "label": "董里府",
                  "value": 464
                },
                {
                  "label": "沙缴府",
                  "value": 465
                },
                {
                  "label": "披集府",
                  "value": 466
                },
                {
                  "label": "安纳乍能府",
                  "value": 467
                },
                {
                  "label": "东北大区",
                  "value": 468
                },
                {
                  "label": "莫拉限府",
                  "value": 469
                },
                {
                  "label": "素叻他尼府",
                  "value": 470
                },
                {
                  "label": "黎逸府",
                  "value": 471
                },
                {
                  "label": "乌汶府",
                  "value": 472
                },
                {
                  "label": "佛丕府",
                  "value": 473
                },
                {
                  "label": "北揽坡府",
                  "value": 474
                },
                {
                  "label": "色军府",
                  "value": 475
                },
                {
                  "label": "春蓬府",
                  "value": 476
                },
                {
                  "label": "南部大区",
                  "value": 477
                },
                {
                  "label": "宋卡府",
                  "value": 478
                },
                {
                  "label": "益梭通府",
                  "value": 479
                },
                {
                  "label": "暖武里府",
                  "value": 480
                },
                {
                  "label": "大城府",
                  "value": 481
                },
                {
                  "label": "玛哈沙拉堪府",
                  "value": 482
                },
                {
                  "label": "来兴府",
                  "value": 483
                },
                {
                  "label": "清迈府",
                  "value": 484
                },
                {
                  "label": "中部大区",
                  "value": 485
                },
                {
                  "label": "叻丕府",
                  "value": 486
                },
                {
                  "label": "加拉信府",
                  "value": 487
                },
                {
                  "label": "素可泰府",
                  "value": 488
                },
                {
                  "label": "博他仑府",
                  "value": 489
                },
                {
                  "label": "巴吞他尼府",
                  "value": 490
                },
                {
                  "label": "信武里府",
                  "value": 491
                },
                {
                  "label": "班武里府",
                  "value": 492
                },
                {
                  "label": "甲米府",
                  "value": 493
                },
                {
                  "label": "四色菊府",
                  "value": 494
                },
                {
                  "label": "帕夭府",
                  "value": 495
                },
                {
                  "label": "惹拉府",
                  "value": 496
                },
                {
                  "label": "红统府",
                  "value": 497
                },
                {
                  "label": "坤敬府",
                  "value": 498
                },
                {
                  "label": "华富里府",
                  "value": 499
                },
                {
                  "label": "东部大区",
                  "value": 500
                },
                {
                  "label": "廊开府",
                  "value": 501
                },
                {
                  "label": "彭世洛府",
                  "value": 502
                },
                {
                  "label": "西部大区",
                  "value": 503
                },
                {
                  "label": "北标府",
                  "value": 504
                },
                {
                  "label": "巴真府",
                  "value": 505
                },
                {
                  "label": "北榄府",
                  "value": 506
                },
                {
                  "label": "尖竹汶府",
                  "value": 507
                },
                {
                  "label": "泰国",
                  "value": 508
                },
                {
                  "label": "素辇府",
                  "value": 509
                },
                {
                  "label": "北柳府",
                  "value": 510
                },
                {
                  "label": "南邦府",
                  "value": 511
                },
                {
                  "label": "乌隆府",
                  "value": 512
                }
              ]
            },
            {
              "country_code": 131,
              "country_name_ch": "新加坡",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Singapore.svg",
              "cityIds": [
                1236
              ],
              "provinces": [
                {
                  "label": "新加坡",
                  "value": 1236
                }
              ]
            },
            {
              "country_code": 117,
              "country_name_ch": "马来西亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Malaysia.svg",
              "cityIds": [
                1097,
                1098,
                1099,
                1100,
                1101,
                1102,
                1103,
                1104,
                1105,
                1106,
                1107,
                1108,
                1109,
                1110,
                1111,
                1112,
                1113
              ],
              "provinces": [
                {
                  "label": "沙巴州",
                  "value": 1097
                },
                {
                  "label": "马六甲州",
                  "value": 1098
                },
                {
                  "label": "玻璃市州",
                  "value": 1099
                },
                {
                  "label": "吉隆坡联邦直辖区",
                  "value": 1100
                },
                {
                  "label": "马来西亚",
                  "value": 1101
                },
                {
                  "label": "霹雳州",
                  "value": 1102
                },
                {
                  "label": "森美兰州",
                  "value": 1103
                },
                {
                  "label": "吉兰丹州",
                  "value": 1104
                },
                {
                  "label": "吉打州",
                  "value": 1105
                },
                {
                  "label": "雪兰莪州",
                  "value": 1106
                },
                {
                  "label": "西马",
                  "value": 1107
                },
                {
                  "label": "槟城州",
                  "value": 1108
                },
                {
                  "label": "布城联邦直辖区",
                  "value": 1109
                },
                {
                  "label": "砂拉越州",
                  "value": 1110
                },
                {
                  "label": "彭亨州",
                  "value": 1111
                },
                {
                  "label": "登嘉楼州",
                  "value": 1112
                },
                {
                  "label": "柔佛州",
                  "value": 1113
                }
              ]
            },
            {
              "country_code": 70,
              "country_name_ch": "孟加拉",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Bangladesh.svg",
              "cityIds": [
                726,
                727,
                728,
                729,
                730,
                731,
                732,
                733
              ],
              "provinces": [
                {
                  "label": "朗布尔专区",
                  "value": 726
                },
                {
                  "label": "库尔纳专区",
                  "value": 727
                },
                {
                  "label": "锡尔赫特专区",
                  "value": 728
                },
                {
                  "label": "达卡专区",
                  "value": 729
                },
                {
                  "label": "迈门辛专区",
                  "value": 730
                },
                {
                  "label": "吉大港专区",
                  "value": 731
                },
                {
                  "label": "拉杰沙希专区",
                  "value": 732
                },
                {
                  "label": "孟加拉",
                  "value": 733
                }
              ]
            },
            {
              "country_code": 97,
              "country_name_ch": "伊拉克",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Iraq.svg",
              "cityIds": [
                936,
                937,
                938,
                939,
                940,
                941,
                942,
                943,
                944,
                945,
                946,
                947,
                948,
                949,
                950,
                951,
                952,
                953,
                954
              ],
              "provinces": [
                {
                  "label": "巴比伦省",
                  "value": 936
                },
                {
                  "label": "迪亚拉省",
                  "value": 937
                },
                {
                  "label": "杜胡克省",
                  "value": 938
                },
                {
                  "label": "埃尔比勒省",
                  "value": 939
                },
                {
                  "label": "纳杰夫省",
                  "value": 940
                },
                {
                  "label": "苏莱曼尼亚省",
                  "value": 941
                },
                {
                  "label": "米桑省",
                  "value": 942
                },
                {
                  "label": "巴士拉省",
                  "value": 943
                },
                {
                  "label": "萨拉赫丁省",
                  "value": 944
                },
                {
                  "label": "尼尼微省",
                  "value": 945
                },
                {
                  "label": "巴格达省",
                  "value": 946
                },
                {
                  "label": "伊拉克",
                  "value": 947
                },
                {
                  "label": "瓦西特省",
                  "value": 948
                },
                {
                  "label": "济加尔省",
                  "value": 949
                },
                {
                  "label": "基尔库克省",
                  "value": 950
                },
                {
                  "label": "穆萨纳省",
                  "value": 951
                },
                {
                  "label": "卡尔巴拉省",
                  "value": 952
                },
                {
                  "label": "卡迪西亚省",
                  "value": 953
                },
                {
                  "label": "安巴尔省",
                  "value": 954
                }
              ]
            },
            {
              "country_code": 13,
              "country_name_ch": "意大利",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Italy.svg",
              "cityIds": [
                124,
                125,
                126,
                127,
                128,
                129,
                130,
                131
              ],
              "provinces": [
                {
                  "label": "伦巴第大区",
                  "value": 124
                },
                {
                  "label": "托斯卡纳大区",
                  "value": 125
                },
                {
                  "label": "意大利",
                  "value": 126
                },
                {
                  "label": "西西里大区",
                  "value": 127
                },
                {
                  "label": "威尼托大区",
                  "value": 128
                },
                {
                  "label": "拉齐奥大区",
                  "value": 129
                },
                {
                  "label": "马尔凯大区",
                  "value": 130
                },
                {
                  "label": "皮埃蒙特大区",
                  "value": 131
                }
              ]
            },
            {
              "country_code": 118,
              "country_name_ch": "巴西",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Brazil.svg",
              "cityIds": [
                1114,
                1115,
                1116,
                1117,
                1118,
                1119,
                1120,
                1121,
                1122,
                1123,
                1124,
                1125,
                1126,
                1127,
                1128,
                1129,
                1130,
                1131,
                1132,
                1133,
                1134,
                1135,
                1136,
                1137,
                1138,
                1139,
                1140,
                1141,
                1142
              ],
              "provinces": [
                {
                  "label": "里约热内卢州",
                  "value": 1114
                },
                {
                  "label": "塞阿腊州",
                  "value": 1115
                },
                {
                  "label": "罗赖马州",
                  "value": 1116
                },
                {
                  "label": "东北部",
                  "value": 1117
                },
                {
                  "label": "圣卡塔琳娜州",
                  "value": 1118
                },
                {
                  "label": "米纳斯吉拉斯州",
                  "value": 1119
                },
                {
                  "label": "南里奥格兰德州",
                  "value": 1120
                },
                {
                  "label": "北里奥格兰德州",
                  "value": 1121
                },
                {
                  "label": "伯南布哥州",
                  "value": 1122
                },
                {
                  "label": "巴西",
                  "value": 1123
                },
                {
                  "label": "阿拉戈斯州",
                  "value": 1124
                },
                {
                  "label": "皮奥伊州",
                  "value": 1125
                },
                {
                  "label": "阿克雷州",
                  "value": 1126
                },
                {
                  "label": "帕拉州",
                  "value": 1127
                },
                {
                  "label": "帕拉伊巴州",
                  "value": 1128
                },
                {
                  "label": "巴伊亚州",
                  "value": 1129
                },
                {
                  "label": "亚马孙州",
                  "value": 1130
                },
                {
                  "label": "马拉尼昂州",
                  "value": 1131
                },
                {
                  "label": "马托格罗索州",
                  "value": 1132
                },
                {
                  "label": "南马托格罗索州",
                  "value": 1133
                },
                {
                  "label": "巴拉那州",
                  "value": 1134
                },
                {
                  "label": "塞尔希培州",
                  "value": 1135
                },
                {
                  "label": "圣保罗州",
                  "value": 1136
                },
                {
                  "label": "托坎廷斯州",
                  "value": 1137
                },
                {
                  "label": "圣埃斯皮里图州",
                  "value": 1138
                },
                {
                  "label": "戈亚斯州",
                  "value": 1139
                },
                {
                  "label": "朗多尼亚州",
                  "value": 1140
                },
                {
                  "label": "阿马帕州",
                  "value": 1141
                },
                {
                  "label": "联邦区",
                  "value": 1142
                }
              ]
            },
            {
              "country_code": 20,
              "country_name_ch": "多米尼加",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/DominicanRepublic.svg",
              "cityIds": [
                162,
                163,
                164,
                165,
                166,
                167,
                168,
                169,
                170,
                171,
                172,
                173,
                174,
                175,
                176,
                177,
                178,
                179,
                180,
                181,
                182,
                183,
                184,
                185,
                186,
                187,
                188,
                189,
                190
              ],
              "provinces": [
                {
                  "label": "普拉塔港省",
                  "value": 162
                },
                {
                  "label": "杜阿尔特省",
                  "value": 163
                },
                {
                  "label": "桑切斯拉米雷斯省",
                  "value": 164
                },
                {
                  "label": "阿苏阿省",
                  "value": 165
                },
                {
                  "label": "多米尼加",
                  "value": 166
                },
                {
                  "label": "玛丽亚特立尼达桑切斯省",
                  "value": 167
                },
                {
                  "label": "国家特区",
                  "value": 168
                },
                {
                  "label": "巴拉奥纳省",
                  "value": 169
                },
                {
                  "label": "主教瑙黎省",
                  "value": 170
                },
                {
                  "label": "圣胡安省",
                  "value": 171
                },
                {
                  "label": "圣佩得罗－德马科里斯省",
                  "value": 172
                },
                {
                  "label": "蒙特普拉塔省",
                  "value": 173
                },
                {
                  "label": "巴尔韦德省",
                  "value": 174
                },
                {
                  "label": "圣克里斯托瓦尔省",
                  "value": 175
                },
                {
                  "label": "圣地亚哥罗德里格斯省",
                  "value": 176
                },
                {
                  "label": "埃斯派亚省",
                  "value": 177
                },
                {
                  "label": "埃尔塞沃省",
                  "value": 178
                },
                {
                  "label": "阿托马约尔省",
                  "value": 179
                },
                {
                  "label": "佩拉维亚省",
                  "value": 180
                },
                {
                  "label": "巴奥鲁科省",
                  "value": 181
                },
                {
                  "label": "蒙特克里斯蒂省",
                  "value": 182
                },
                {
                  "label": "圣多明戈省",
                  "value": 183
                },
                {
                  "label": "拉罗马纳省",
                  "value": 184
                },
                {
                  "label": "萨马纳省",
                  "value": 185
                },
                {
                  "label": "圣地亚哥省",
                  "value": 186
                },
                {
                  "label": "米拉贝姐妹省",
                  "value": 187
                },
                {
                  "label": "达哈翁省",
                  "value": 188
                },
                {
                  "label": "拉贝加省",
                  "value": 189
                },
                {
                  "label": "阿尔塔格拉西亚省",
                  "value": 190
                }
              ]
            },
            {
              "country_code": 64,
              "country_name_ch": "捷克",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/CzechRepublic.svg",
              "cityIds": [
                612,
                613,
                614,
                615,
                616,
                617,
                618,
                619,
                620,
                621,
                622,
                623,
                624
              ],
              "provinces": [
                {
                  "label": "摩拉维亚－西里西亚州",
                  "value": 612
                },
                {
                  "label": "奥洛穆克州",
                  "value": 613
                },
                {
                  "label": "赫拉德茨－克拉洛韦州",
                  "value": 614
                },
                {
                  "label": "中波希米亚州",
                  "value": 615
                },
                {
                  "label": "维索基纳州",
                  "value": 616
                },
                {
                  "label": "布拉格",
                  "value": 617
                },
                {
                  "label": "南摩拉维亚州",
                  "value": 618
                },
                {
                  "label": "乌斯季州",
                  "value": 619
                },
                {
                  "label": "比尔森州",
                  "value": 620
                },
                {
                  "label": "卡罗维发利州",
                  "value": 621
                },
                {
                  "label": "兹林州",
                  "value": 622
                },
                {
                  "label": "帕尔杜比采州",
                  "value": 623
                },
                {
                  "label": "捷克",
                  "value": 624
                }
              ]
            },
            {
              "country_code": 80,
              "country_name_ch": "埃及",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Egypt.svg",
              "cityIds": [
                821,
                822,
                823,
                824,
                825,
                826,
                827,
                828,
                829,
                830,
                831,
                832,
                833,
                834,
                835,
                836,
                837,
                838,
                839,
                840,
                841,
                842,
                843,
                844,
                845,
                846,
                847
              ],
              "provinces": [
                {
                  "label": "开罗省",
                  "value": 821
                },
                {
                  "label": "基纳省",
                  "value": 822
                },
                {
                  "label": "米努夫省",
                  "value": 823
                },
                {
                  "label": "索哈杰省",
                  "value": 824
                },
                {
                  "label": "红海省",
                  "value": 825
                },
                {
                  "label": "北西奈省",
                  "value": 826
                },
                {
                  "label": "加比亚省",
                  "value": 827
                },
                {
                  "label": "塞得港省",
                  "value": 828
                },
                {
                  "label": "布海拉省",
                  "value": 829
                },
                {
                  "label": "埃及",
                  "value": 830
                },
                {
                  "label": "艾斯尤特省",
                  "value": 831
                },
                {
                  "label": "谢赫村省",
                  "value": 832
                },
                {
                  "label": "沙迦省",
                  "value": 833
                },
                {
                  "label": "伊斯梅利亚省",
                  "value": 834
                },
                {
                  "label": "贝尼苏韦夫省",
                  "value": 835
                },
                {
                  "label": "亚历山大省",
                  "value": 836
                },
                {
                  "label": "明亚省",
                  "value": 837
                },
                {
                  "label": "马特鲁省",
                  "value": 838
                },
                {
                  "label": "杜姆亚特省",
                  "value": 839
                },
                {
                  "label": "达卡利亚省",
                  "value": 840
                },
                {
                  "label": "苏伊士省",
                  "value": 841
                },
                {
                  "label": "阿斯旺省",
                  "value": 842
                },
                {
                  "label": "盖卢比尤省",
                  "value": 843
                },
                {
                  "label": "吉萨省",
                  "value": 844
                },
                {
                  "label": "卢克索省",
                  "value": 845
                },
                {
                  "label": "法尤姆省",
                  "value": 846
                },
                {
                  "label": "南西奈省",
                  "value": 847
                }
              ]
            },
            {
              "country_code": 86,
              "country_name_ch": "阿尔及利亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Algeria.svg",
              "cityIds": [
                875,
                876,
                877,
                878,
                879,
                880,
                881,
                882,
                883,
                884,
                885,
                886,
                887,
                888,
                889,
                890,
                891,
                892,
                893,
                894,
                895,
                896,
                897,
                898,
                899,
                900,
                901,
                902,
                903,
                904,
                905,
                906,
                907,
                908,
                909,
                910
              ],
              "provinces": [
                {
                  "label": "谢利夫省",
                  "value": 875
                },
                {
                  "label": "提塞姆西勒特省",
                  "value": 876
                },
                {
                  "label": "瓦迪省",
                  "value": 877
                },
                {
                  "label": "阿尔及利亚",
                  "value": 878
                },
                {
                  "label": "吉杰勒省",
                  "value": 879
                },
                {
                  "label": "法属时期奥尔良维尔省",
                  "value": 880
                },
                {
                  "label": "法属时期瓦哈特省",
                  "value": 881
                },
                {
                  "label": "君士坦丁省",
                  "value": 882
                },
                {
                  "label": "法属时期萨伊达省",
                  "value": 883
                },
                {
                  "label": "法属时期蒂兹乌祖省",
                  "value": 884
                },
                {
                  "label": "米拉省",
                  "value": 885
                },
                {
                  "label": "安纳巴省",
                  "value": 886
                },
                {
                  "label": "奥兰省",
                  "value": 887
                },
                {
                  "label": "特莱姆森省",
                  "value": 888
                },
                {
                  "label": "布阿拉里季堡省",
                  "value": 889
                },
                {
                  "label": "法属时期墨斯塔加那姆省",
                  "value": 890
                },
                {
                  "label": "法属时期巴塔尼亚省",
                  "value": 891
                },
                {
                  "label": "泰贝萨省",
                  "value": 892
                },
                {
                  "label": "姆西拉省",
                  "value": 893
                },
                {
                  "label": "阿德拉尔省",
                  "value": 894
                },
                {
                  "label": "提济乌祖省",
                  "value": 895
                },
                {
                  "label": "比斯克拉省",
                  "value": 896
                },
                {
                  "label": "法属时期欧兰省",
                  "value": 897
                },
                {
                  "label": "塞提夫省",
                  "value": 898
                },
                {
                  "label": "贝贾亚省",
                  "value": 899
                },
                {
                  "label": "阿尔及尔省",
                  "value": 900
                },
                {
                  "label": "法属时期萨欧拉省",
                  "value": 901
                },
                {
                  "label": "奥拉德杰拉勒省",
                  "value": 902
                },
                {
                  "label": "法属时期塞蒂夫省",
                  "value": 903
                },
                {
                  "label": "苏格艾赫拉斯省",
                  "value": 904
                },
                {
                  "label": "提亚雷特省",
                  "value": 905
                },
                {
                  "label": "法属时期伯恩省",
                  "value": 906
                },
                {
                  "label": "法属时期康斯坦丁省",
                  "value": 907
                },
                {
                  "label": "法属时期美狄亚省",
                  "value": 908
                },
                {
                  "label": "乌姆布瓦吉省",
                  "value": 909
                },
                {
                  "label": "巴特纳省",
                  "value": 910
                }
              ]
            },
            {
              "country_code": 41,
              "country_name_ch": "欧洲地区",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "",
              "cityIds": [
                435
              ],
              "provinces": [
                {
                  "label": "欧洲地区",
                  "value": 435
                }
              ]
            },
            {
              "country_code": 119,
              "country_name_ch": "瑞典",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Sweden.svg",
              "cityIds": [
                1143,
                1144,
                1145,
                1146,
                1147
              ],
              "provinces": [
                {
                  "label": "耶夫勒堡省",
                  "value": 1143
                },
                {
                  "label": "斯科讷省",
                  "value": 1144
                },
                {
                  "label": "斯德哥尔摩省",
                  "value": 1145
                },
                {
                  "label": "瑞典",
                  "value": 1146
                },
                {
                  "label": "哥特兰省",
                  "value": 1147
                }
              ]
            },
            {
              "country_code": 42,
              "country_name_ch": "约旦",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Jordan.svg",
              "cityIds": [
                436,
                437,
                438,
                439
              ],
              "provinces": [
                {
                  "label": "约旦",
                  "value": 436
                },
                {
                  "label": "安曼省",
                  "value": 437
                },
                {
                  "label": "扎尔卡省",
                  "value": 438
                },
                {
                  "label": "伊尔比德省",
                  "value": 439
                }
              ]
            },
            {
              "country_code": 33,
              "country_name_ch": "哈萨克斯坦",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Kazakhstan.svg",
              "cityIds": [
                299,
                300,
                301,
                302,
                303,
                304,
                305,
                306,
                307,
                308,
                309,
                310,
                311,
                312,
                313,
                314,
                315,
                316,
                317,
                318,
                319
              ],
              "provinces": [
                {
                  "label": "奇姆肯特",
                  "value": 299
                },
                {
                  "label": "阿拜州",
                  "value": 300
                },
                {
                  "label": "阿拉木图州",
                  "value": 301
                },
                {
                  "label": "突厥斯坦州",
                  "value": 302
                },
                {
                  "label": "杰特苏州",
                  "value": 303
                },
                {
                  "label": "江布尔州",
                  "value": 304
                },
                {
                  "label": "北哈萨克斯坦州",
                  "value": 305
                },
                {
                  "label": "克孜勒奥尔达州",
                  "value": 306
                },
                {
                  "label": "曼格斯套州",
                  "value": 307
                },
                {
                  "label": "阿克莫拉州",
                  "value": 308
                },
                {
                  "label": "西哈萨克斯坦州",
                  "value": 309
                },
                {
                  "label": "乌勒套州",
                  "value": 310
                },
                {
                  "label": "卡拉干达州",
                  "value": 311
                },
                {
                  "label": "巴甫洛达尔州",
                  "value": 312
                },
                {
                  "label": "阿斯塔纳",
                  "value": 313
                },
                {
                  "label": "东哈萨克斯坦州",
                  "value": 314
                },
                {
                  "label": "阿拉木图",
                  "value": 315
                },
                {
                  "label": "库斯塔奈州",
                  "value": 316
                },
                {
                  "label": "哈萨克斯坦",
                  "value": 317
                },
                {
                  "label": "阿特劳州",
                  "value": 318
                },
                {
                  "label": "阿克托贝州",
                  "value": 319
                }
              ]
            },
            {
              "country_code": 8,
              "country_name_ch": "巴基斯坦",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Pakistan.svg",
              "cityIds": [
                80,
                81,
                82,
                83,
                84,
                85,
                86
              ],
              "provinces": [
                {
                  "label": "旁遮普省",
                  "value": 80
                },
                {
                  "label": "信德省",
                  "value": 81
                },
                {
                  "label": "开伯尔－普赫图赫瓦省",
                  "value": 82
                },
                {
                  "label": "俾路支省",
                  "value": 83
                },
                {
                  "label": "阿扎德克什米尔",
                  "value": 84
                },
                {
                  "label": "伊斯兰堡首都区",
                  "value": 85
                },
                {
                  "label": "巴基斯坦",
                  "value": 86
                }
              ]
            },
            {
              "country_code": 21,
              "country_name_ch": "韩国",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Korea.svg",
              "cityIds": [
                191,
                192,
                193,
                194,
                195,
                196,
                197
              ],
              "provinces": [
                {
                  "label": "韩国",
                  "value": 191
                },
                {
                  "label": "庆尚北道",
                  "value": 192
                },
                {
                  "label": "京畿道",
                  "value": 193
                },
                {
                  "label": "仁川",
                  "value": 194
                },
                {
                  "label": "世宗",
                  "value": 195
                },
                {
                  "label": "江原特别自治道",
                  "value": 196
                },
                {
                  "label": "首尔",
                  "value": 197
                }
              ]
            },
            {
              "country_code": 124,
              "country_name_ch": "阿联酋",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "",
              "cityIds": [
                1177,
                1178,
                1179,
                1180,
                1181,
                1182,
                1183,
                1184
              ],
              "provinces": [
                {
                  "label": "阿治曼酋长国",
                  "value": 1177
                },
                {
                  "label": "阿布扎比酋长国",
                  "value": 1178
                },
                {
                  "label": "阿联酋",
                  "value": 1179
                },
                {
                  "label": "富查伊拉酋长国",
                  "value": 1180
                },
                {
                  "label": "拉斯海玛酋长国",
                  "value": 1181
                },
                {
                  "label": "乌姆盖万酋长国",
                  "value": 1182
                },
                {
                  "label": "迪拜酋长国",
                  "value": 1183
                },
                {
                  "label": "沙迦酋长国",
                  "value": 1184
                }
              ]
            },
            {
              "country_code": 2,
              "country_name_ch": "法国",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/France.svg",
              "cityIds": [
                25,
                26,
                27,
                28,
                29,
                30,
                31
              ],
              "provinces": [
                {
                  "label": "法国",
                  "value": 25
                },
                {
                  "label": "法兰西岛大区",
                  "value": 26
                },
                {
                  "label": "上法兰西大区",
                  "value": 27
                },
                {
                  "label": "奥克西塔尼大区",
                  "value": 28
                },
                {
                  "label": "普罗旺斯－阿尔卑斯－蓝色海岸大区",
                  "value": 29
                },
                {
                  "label": "奥弗涅－罗纳－阿尔卑斯大区",
                  "value": 30
                },
                {
                  "label": "大东部大区",
                  "value": 31
                }
              ]
            },
            {
              "country_code": 110,
              "country_name_ch": "加拿大",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Canada.svg",
              "cityIds": [
                1076,
                1077,
                1078,
                1079,
                1080,
                1081,
                1082
              ],
              "provinces": [
                {
                  "label": "魁北克省",
                  "value": 1076
                },
                {
                  "label": "曼尼托巴省",
                  "value": 1077
                },
                {
                  "label": "加拿大",
                  "value": 1078
                },
                {
                  "label": "萨斯喀彻温省",
                  "value": 1079
                },
                {
                  "label": "艾伯塔省",
                  "value": 1080
                },
                {
                  "label": "不列颠哥伦比亚省",
                  "value": 1081
                },
                {
                  "label": "安大略省",
                  "value": 1082
                }
              ]
            },
            {
              "country_code": 164,
              "country_name_ch": "俄罗斯",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/RussianFederation.svg",
              "cityIds": [
                1448,
                1449,
                1450,
                1451,
                1452,
                1453,
                1454,
                1455,
                1456,
                1457,
                1458,
                1459,
                1460,
                1461,
                1462,
                1463,
                1464,
                1465,
                1466,
                1467,
                1468,
                1469,
                1470,
                1471,
                1472,
                1473,
                1474,
                1475,
                1476,
                1477,
                1478,
                1479,
                1480,
                1481,
                1482,
                1483,
                1484,
                1485,
                1486,
                1487,
                1488,
                1489,
                1490,
                1491,
                1492,
                1493,
                1494,
                1495,
                1496,
                1497,
                1498,
                1499,
                1500,
                1501,
                1502,
                1503,
                1504,
                1505,
                1506,
                1507,
                1508
              ],
              "provinces": [
                {
                  "label": "莫尔多瓦共和国",
                  "value": 1448
                },
                {
                  "label": "阿斯特拉罕州",
                  "value": 1449
                },
                {
                  "label": "奥廖尔州",
                  "value": 1450
                },
                {
                  "label": "斯塔夫罗波尔边疆区",
                  "value": 1451
                },
                {
                  "label": "沃洛格达州",
                  "value": 1452
                },
                {
                  "label": "乌里扬诺夫斯克州",
                  "value": 1453
                },
                {
                  "label": "俄罗斯",
                  "value": 1454
                },
                {
                  "label": "托木斯克州",
                  "value": 1455
                },
                {
                  "label": "秋明州",
                  "value": 1456
                },
                {
                  "label": "莫斯科州",
                  "value": 1457
                },
                {
                  "label": "普斯科夫州",
                  "value": 1458
                },
                {
                  "label": "图瓦共和国",
                  "value": 1459
                },
                {
                  "label": "加里宁格勒州",
                  "value": 1460
                },
                {
                  "label": "罗斯托夫州",
                  "value": 1461
                },
                {
                  "label": "阿迪格共和国",
                  "value": 1462
                },
                {
                  "label": "图拉州",
                  "value": 1463
                },
                {
                  "label": "萨马拉州",
                  "value": 1464
                },
                {
                  "label": "车里雅宾斯克州",
                  "value": 1465
                },
                {
                  "label": "亚马尔－涅涅茨自治区",
                  "value": 1466
                },
                {
                  "label": "伊万诺沃州",
                  "value": 1467
                },
                {
                  "label": "库尔斯克州",
                  "value": 1468
                },
                {
                  "label": "堪察加边疆区",
                  "value": 1469
                },
                {
                  "label": "布里亚特共和国",
                  "value": 1470
                },
                {
                  "label": "鞑靼斯坦共和国",
                  "value": 1471
                },
                {
                  "label": "圣彼得堡",
                  "value": 1472
                },
                {
                  "label": "阿尔汉格尔斯克州",
                  "value": 1473
                },
                {
                  "label": "哈卡斯共和国",
                  "value": 1474
                },
                {
                  "label": "达吉斯坦共和国",
                  "value": 1475
                },
                {
                  "label": "巴什科尔托斯坦共和国",
                  "value": 1476
                },
                {
                  "label": "塞瓦斯托波尔",
                  "value": 1477
                },
                {
                  "label": "鄂木斯克州",
                  "value": 1478
                },
                {
                  "label": "哈巴罗夫斯克边疆区",
                  "value": 1479
                },
                {
                  "label": "雅罗斯拉夫尔州",
                  "value": 1480
                },
                {
                  "label": "阿尔泰边疆区",
                  "value": 1481
                },
                {
                  "label": "伏尔加格勒州",
                  "value": 1482
                },
                {
                  "label": "沃罗涅什州",
                  "value": 1483
                },
                {
                  "label": "下诺夫哥罗德州",
                  "value": 1484
                },
                {
                  "label": "梁赞州",
                  "value": 1485
                },
                {
                  "label": "莫斯科",
                  "value": 1486
                },
                {
                  "label": "克拉斯诺亚尔斯克边疆区",
                  "value": 1487
                },
                {
                  "label": "伊尔库茨克州",
                  "value": 1488
                },
                {
                  "label": "卡卢加州",
                  "value": 1489
                },
                {
                  "label": "车臣共和国",
                  "value": 1490
                },
                {
                  "label": "克拉斯诺达尔边疆区",
                  "value": 1491
                },
                {
                  "label": "科米共和国",
                  "value": 1492
                },
                {
                  "label": "萨哈林州",
                  "value": 1493
                },
                {
                  "label": "萨拉托夫州",
                  "value": 1494
                },
                {
                  "label": "楚瓦什共和国",
                  "value": 1495
                },
                {
                  "label": "特维尔州",
                  "value": 1496
                },
                {
                  "label": "克里米亚共和国",
                  "value": 1497
                },
                {
                  "label": "斯维尔德洛夫斯克州",
                  "value": 1498
                },
                {
                  "label": "卡巴尔达－巴尔卡尔共和国",
                  "value": 1499
                },
                {
                  "label": "新西伯利亚州",
                  "value": 1500
                },
                {
                  "label": "萨哈共和国",
                  "value": 1501
                },
                {
                  "label": "诺夫哥罗德州",
                  "value": 1502
                },
                {
                  "label": "列宁格勒州",
                  "value": 1503
                },
                {
                  "label": "弗拉基米尔州",
                  "value": 1504
                },
                {
                  "label": "滨海边疆区",
                  "value": 1505
                },
                {
                  "label": "彼尔姆边疆区",
                  "value": 1506
                },
                {
                  "label": "坦波夫州",
                  "value": 1507
                },
                {
                  "label": "北奥塞梯－阿兰共和国",
                  "value": 1508
                }
              ]
            },
            {
              "country_code": 34,
              "country_name_ch": "厄瓜多尔",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Ecuador.svg",
              "cityIds": [
                320,
                321,
                322,
                323,
                324,
                325,
                326,
                327,
                328,
                329,
                330,
                331,
                332,
                333,
                334,
                335,
                336,
                337,
                338,
                339,
                340,
                341,
                342,
                343,
                344
              ],
              "provinces": [
                {
                  "label": "奥雷亚纳省",
                  "value": 320
                },
                {
                  "label": "卡尼亚尔省",
                  "value": 321
                },
                {
                  "label": "埃斯梅拉达斯省",
                  "value": 322
                },
                {
                  "label": "洛哈省",
                  "value": 323
                },
                {
                  "label": "萨莫拉－钦奇佩省",
                  "value": 324
                },
                {
                  "label": "玻利瓦尔省",
                  "value": 325
                },
                {
                  "label": "加拉帕戈斯省",
                  "value": 326
                },
                {
                  "label": "因巴布拉省",
                  "value": 327
                },
                {
                  "label": "圣多明各－德洛斯查奇拉斯省",
                  "value": 328
                },
                {
                  "label": "皮钦查省",
                  "value": 329
                },
                {
                  "label": "马纳比省",
                  "value": 330
                },
                {
                  "label": "卡尔奇省",
                  "value": 331
                },
                {
                  "label": "钦博拉索省",
                  "value": 332
                },
                {
                  "label": "纳波省",
                  "value": 333
                },
                {
                  "label": "莫罗纳－圣地亚哥省",
                  "value": 334
                },
                {
                  "label": "阿苏艾省",
                  "value": 335
                },
                {
                  "label": "洛斯里奥斯省",
                  "value": 336
                },
                {
                  "label": "埃尔奥罗省",
                  "value": 337
                },
                {
                  "label": "圣埃伦娜省",
                  "value": 338
                },
                {
                  "label": "瓜亚斯省",
                  "value": 339
                },
                {
                  "label": "帕斯塔萨省",
                  "value": 340
                },
                {
                  "label": "厄瓜多尔",
                  "value": 341
                },
                {
                  "label": "通古拉瓦省",
                  "value": 342
                },
                {
                  "label": "科托帕希省",
                  "value": 343
                },
                {
                  "label": "苏昆比奥斯省",
                  "value": 344
                }
              ]
            },
            {
              "country_code": 137,
              "country_name_ch": "德国",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Germany.svg",
              "cityIds": [
                1247,
                1248,
                1249,
                1250,
                1251,
                1252,
                1253,
                1254,
                1255,
                1256,
                1257,
                1258
              ],
              "provinces": [
                {
                  "label": "萨克森自由州",
                  "value": 1247
                },
                {
                  "label": "巴伐利亚州",
                  "value": 1248
                },
                {
                  "label": "北莱茵－威斯特法伦州",
                  "value": 1249
                },
                {
                  "label": "汉堡",
                  "value": 1250
                },
                {
                  "label": "勃兰登堡州",
                  "value": 1251
                },
                {
                  "label": "巴登－符腾堡州",
                  "value": 1252
                },
                {
                  "label": "下萨克森州",
                  "value": 1253
                },
                {
                  "label": "柏林",
                  "value": 1254
                },
                {
                  "label": "莱茵兰－普法尔茨州",
                  "value": 1255
                },
                {
                  "label": "德国",
                  "value": 1256
                },
                {
                  "label": "黑森州",
                  "value": 1257
                },
                {
                  "label": "石勒苏益格－荷尔斯泰因州",
                  "value": 1258
                }
              ]
            },
            {
              "country_code": 156,
              "country_name_ch": "英国",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/UK.svg",
              "cityIds": [
                1370,
                1371,
                1372,
                1373,
                1374,
                1375,
                1376,
                1377,
                1378,
                1379,
                1380,
                1381,
                1382,
                1383,
                1384,
                1385,
                1386,
                1387,
                1388,
                1389,
                1390,
                1391,
                1392
              ],
              "provinces": [
                {
                  "label": "斯劳",
                  "value": 1370
                },
                {
                  "label": "朴茨茅斯",
                  "value": 1371
                },
                {
                  "label": "埃塞克斯郡",
                  "value": 1372
                },
                {
                  "label": "考文垂",
                  "value": 1373
                },
                {
                  "label": "德文郡",
                  "value": 1374
                },
                {
                  "label": "曼彻斯特",
                  "value": 1375
                },
                {
                  "label": "苏格兰",
                  "value": 1376
                },
                {
                  "label": "西柴郡与切斯特",
                  "value": 1377
                },
                {
                  "label": "威尔士",
                  "value": 1378
                },
                {
                  "label": "诺福克郡",
                  "value": 1379
                },
                {
                  "label": "中央贝德福",
                  "value": 1380
                },
                {
                  "label": "卡尔德达尔",
                  "value": 1381
                },
                {
                  "label": "伦敦",
                  "value": 1382
                },
                {
                  "label": "伍斯特郡",
                  "value": 1383
                },
                {
                  "label": "伯明翰",
                  "value": 1384
                },
                {
                  "label": "温莎和梅登黑德",
                  "value": 1385
                },
                {
                  "label": "米尔顿凯恩斯",
                  "value": 1386
                },
                {
                  "label": "谢菲尔德区",
                  "value": 1387
                },
                {
                  "label": "西北英格兰",
                  "value": 1388
                },
                {
                  "label": "肯特郡",
                  "value": 1389
                },
                {
                  "label": "英国",
                  "value": 1390
                },
                {
                  "label": "汉普郡",
                  "value": 1391
                },
                {
                  "label": "北林肯郡",
                  "value": 1392
                }
              ]
            },
            {
              "country_code": 125,
              "country_name_ch": "丹麦",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Denmark.svg",
              "cityIds": [
                1185,
                1186,
                1187
              ],
              "provinces": [
                {
                  "label": "首都大区",
                  "value": 1185
                },
                {
                  "label": "中日德兰大区",
                  "value": 1186
                },
                {
                  "label": "丹麦",
                  "value": 1187
                }
              ]
            },
            {
              "country_code": 157,
              "country_name_ch": "摩洛哥",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Morocco.svg",
              "cityIds": [
                1393,
                1394,
                1395,
                1396,
                1397,
                1398,
                1399,
                1400,
                1401,
                1402
              ],
              "provinces": [
                {
                  "label": "丹吉尔－得土安－胡塞马大区",
                  "value": 1393
                },
                {
                  "label": "摩洛哥",
                  "value": 1394
                },
                {
                  "label": "苏斯－马塞大区",
                  "value": 1395
                },
                {
                  "label": "卡萨布兰卡－塞塔特大区",
                  "value": 1396
                },
                {
                  "label": "贝尼迈拉勒－海尼夫拉大区",
                  "value": 1397
                },
                {
                  "label": "阿尤恩－萨基亚－阿姆拉大区",
                  "value": 1398
                },
                {
                  "label": "马拉喀什－萨菲大区",
                  "value": 1399
                },
                {
                  "label": "非斯－梅克内斯大区",
                  "value": 1400
                },
                {
                  "label": "东部大区",
                  "value": 1401
                },
                {
                  "label": "拉巴特－塞拉－盖尼特拉大区",
                  "value": 1402
                }
              ]
            },
            {
              "country_code": 81,
              "country_name_ch": "西班牙",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Spain.svg",
              "cityIds": [
                848,
                849,
                850,
                851,
                852,
                853,
                854,
                855,
                856,
                857,
                858
              ],
              "provinces": [
                {
                  "label": "卡斯蒂利亚－拉曼恰自治区",
                  "value": 848
                },
                {
                  "label": "巴斯克自治区",
                  "value": 849
                },
                {
                  "label": "拉里奥哈自治区",
                  "value": 850
                },
                {
                  "label": "阿拉贡自治区",
                  "value": 851
                },
                {
                  "label": "马德里自治区",
                  "value": 852
                },
                {
                  "label": "安达卢西亚自治区",
                  "value": 853
                },
                {
                  "label": "加泰罗尼亚自治区",
                  "value": 854
                },
                {
                  "label": "加那利群岛自治区",
                  "value": 855
                },
                {
                  "label": "加利西亚自治区",
                  "value": 856
                },
                {
                  "label": "西班牙",
                  "value": 857
                },
                {
                  "label": "瓦伦西亚自治区",
                  "value": 858
                }
              ]
            },
            {
              "country_code": 16,
              "country_name_ch": "澳大利亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Australia.svg",
              "cityIds": [
                139,
                140,
                141,
                142,
                143,
                144
              ],
              "provinces": [
                {
                  "label": "新南威尔士州",
                  "value": 139
                },
                {
                  "label": "昆士兰州",
                  "value": 140
                },
                {
                  "label": "西澳大利亚州",
                  "value": 141
                },
                {
                  "label": "南澳大利亚州",
                  "value": 142
                },
                {
                  "label": "澳大利亚",
                  "value": 143
                },
                {
                  "label": "维多利亚州",
                  "value": 144
                }
              ]
            },
            {
              "country_code": 103,
              "country_name_ch": "萨尔瓦多",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/ElSalvador.svg",
              "cityIds": [
                1017,
                1018,
                1019,
                1020,
                1021,
                1022
              ],
              "provinces": [
                {
                  "label": "乌苏卢坦省",
                  "value": 1017
                },
                {
                  "label": "拉利伯塔德省",
                  "value": 1018
                },
                {
                  "label": "圣米格尔省",
                  "value": 1019
                },
                {
                  "label": "圣萨尔瓦多省",
                  "value": 1020
                },
                {
                  "label": "萨尔瓦多",
                  "value": 1021
                },
                {
                  "label": "阿瓦查潘省",
                  "value": 1022
                }
              ]
            },
            {
              "country_code": 24,
              "country_name_ch": "墨西哥",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Mexico.svg",
              "cityIds": [
                204,
                205,
                206,
                207,
                208,
                209,
                210,
                211,
                212,
                213,
                214,
                215,
                216,
                217,
                218,
                219,
                220,
                221,
                222,
                223,
                224,
                225,
                226,
                227,
                228,
                229,
                230,
                231,
                232,
                233,
                234,
                235,
                236
              ],
              "provinces": [
                {
                  "label": "科阿韦拉州",
                  "value": 204
                },
                {
                  "label": "瓦哈卡州",
                  "value": 205
                },
                {
                  "label": "坎佩切州",
                  "value": 206
                },
                {
                  "label": "塔巴斯科州",
                  "value": 207
                },
                {
                  "label": "普埃布拉州",
                  "value": 208
                },
                {
                  "label": "伊达戈州",
                  "value": 209
                },
                {
                  "label": "科利马州",
                  "value": 210
                },
                {
                  "label": "墨西哥",
                  "value": 211
                },
                {
                  "label": "索诺拉州",
                  "value": 212
                },
                {
                  "label": "韦拉克鲁斯州",
                  "value": 213
                },
                {
                  "label": "新莱昂州",
                  "value": 214
                },
                {
                  "label": "下加利福尼亚州",
                  "value": 215
                },
                {
                  "label": "阿瓜斯卡达特斯州",
                  "value": 216
                },
                {
                  "label": "瓜纳华托州",
                  "value": 217
                },
                {
                  "label": "墨西哥联邦区",
                  "value": 218
                },
                {
                  "label": "纳亚里特州",
                  "value": 219
                },
                {
                  "label": "尤卡坦州",
                  "value": 220
                },
                {
                  "label": "西那罗阿州",
                  "value": 221
                },
                {
                  "label": "塔毛利帕斯州",
                  "value": 222
                },
                {
                  "label": "特拉斯卡拉州",
                  "value": 223
                },
                {
                  "label": "奇瓦瓦州",
                  "value": 224
                },
                {
                  "label": "恰帕斯州",
                  "value": 225
                },
                {
                  "label": "米却肯州",
                  "value": 226
                },
                {
                  "label": "墨西哥州",
                  "value": 227
                },
                {
                  "label": "萨卡特卡斯州",
                  "value": 228
                },
                {
                  "label": "圣路易斯波托西州",
                  "value": 229
                },
                {
                  "label": "金塔纳罗奥州",
                  "value": 230
                },
                {
                  "label": "哈利斯科州",
                  "value": 231
                },
                {
                  "label": "克雷塔罗州",
                  "value": 232
                },
                {
                  "label": "莫雷洛斯州",
                  "value": 233
                },
                {
                  "label": "格雷罗州",
                  "value": 234
                },
                {
                  "label": "杜兰戈州",
                  "value": 235
                },
                {
                  "label": "南下加利福尼亚州",
                  "value": 236
                }
              ]
            },
            {
              "country_code": 120,
              "country_name_ch": "突尼斯",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Tunisia.svg",
              "cityIds": [
                1148,
                1149,
                1150,
                1151,
                1152,
                1153,
                1154,
                1155,
                1156,
                1157,
                1158,
                1159,
                1160,
                1161,
                1162,
                1163,
                1164,
                1165,
                1166,
                1167
              ],
              "provinces": [
                {
                  "label": "托泽尔省",
                  "value": 1148
                },
                {
                  "label": "西迪布济德省",
                  "value": 1149
                },
                {
                  "label": "巴杰省",
                  "value": 1150
                },
                {
                  "label": "马赫迪耶省",
                  "value": 1151
                },
                {
                  "label": "艾尔亚内省",
                  "value": 1152
                },
                {
                  "label": "卡夫省",
                  "value": 1153
                },
                {
                  "label": "加贝斯省",
                  "value": 1154
                },
                {
                  "label": "突尼斯省",
                  "value": 1155
                },
                {
                  "label": "莫纳斯提尔省",
                  "value": 1156
                },
                {
                  "label": "本阿鲁斯省",
                  "value": 1157
                },
                {
                  "label": "吉比利省",
                  "value": 1158
                },
                {
                  "label": "加夫萨省",
                  "value": 1159
                },
                {
                  "label": "苏塞省",
                  "value": 1160
                },
                {
                  "label": "梅德宁省",
                  "value": 1161
                },
                {
                  "label": "比塞大省",
                  "value": 1162
                },
                {
                  "label": "凯鲁万省",
                  "value": 1163
                },
                {
                  "label": "斯法克斯省",
                  "value": 1164
                },
                {
                  "label": "坚杜拜省",
                  "value": 1165
                },
                {
                  "label": "突尼斯",
                  "value": 1166
                },
                {
                  "label": "纳布勒省",
                  "value": 1167
                }
              ]
            },
            {
              "country_code": 138,
              "country_name_ch": "安哥拉",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Angola.svg",
              "cityIds": [
                1259,
                1260
              ],
              "provinces": [
                {
                  "label": "安哥拉",
                  "value": 1259
                },
                {
                  "label": "罗安达省",
                  "value": 1260
                }
              ]
            },
            {
              "country_code": 3,
              "country_name_ch": "波兰",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Poland.svg",
              "cityIds": [
                32,
                33,
                34,
                35,
                36,
                37,
                38,
                39,
                40,
                41,
                42,
                43,
                44,
                45,
                46,
                47,
                48
              ],
              "provinces": [
                {
                  "label": "马佐夫舍省",
                  "value": 32
                },
                {
                  "label": "波兰",
                  "value": 33
                },
                {
                  "label": "西里西亚省",
                  "value": 34
                },
                {
                  "label": "大波兰省",
                  "value": 35
                },
                {
                  "label": "西波美拉尼亚省",
                  "value": 36
                },
                {
                  "label": "奥波莱省",
                  "value": 37
                },
                {
                  "label": "瓦尔米亚－马祖里省",
                  "value": 38
                },
                {
                  "label": "波德拉谢省",
                  "value": 39
                },
                {
                  "label": "罗兹省",
                  "value": 40
                },
                {
                  "label": "库亚维－波美拉尼亚省",
                  "value": 41
                },
                {
                  "label": "下西里西亚省",
                  "value": 42
                },
                {
                  "label": "小波兰省",
                  "value": 43
                },
                {
                  "label": "鲁布斯卡省",
                  "value": 44
                },
                {
                  "label": "卢布林省",
                  "value": 45
                },
                {
                  "label": "喀尔巴阡山省",
                  "value": 46
                },
                {
                  "label": "滨海省",
                  "value": 47
                },
                {
                  "label": "圣十字省",
                  "value": 48
                }
              ]
            },
            {
              "country_code": 35,
              "country_name_ch": "罗马尼亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Romania.svg",
              "cityIds": [
                345,
                346,
                347,
                348,
                349,
                350,
                351,
                352,
                353,
                354,
                355,
                356,
                357,
                358,
                359,
                360,
                361,
                362,
                363,
                364,
                365,
                366,
                367,
                368,
                369,
                370,
                371,
                372,
                373,
                374,
                375,
                376,
                377,
                378,
                379,
                380,
                381,
                382,
                383,
                384,
                385,
                386
              ],
              "provinces": [
                {
                  "label": "比斯特里察－讷瑟乌德县",
                  "value": 345
                },
                {
                  "label": "伊尔福夫县",
                  "value": 346
                },
                {
                  "label": "科瓦斯纳县",
                  "value": 347
                },
                {
                  "label": "克勒拉希县",
                  "value": 348
                },
                {
                  "label": "布加勒斯特",
                  "value": 349
                },
                {
                  "label": "瓦斯卢伊县",
                  "value": 350
                },
                {
                  "label": "博托沙尼县",
                  "value": 351
                },
                {
                  "label": "图尔恰县",
                  "value": 352
                },
                {
                  "label": "克卢日县",
                  "value": 353
                },
                {
                  "label": "布泽乌县",
                  "value": 354
                },
                {
                  "label": "雅洛米察县",
                  "value": 355
                },
                {
                  "label": "奥尔特县",
                  "value": 356
                },
                {
                  "label": "穆列什县",
                  "value": 357
                },
                {
                  "label": "登博维察县",
                  "value": 358
                },
                {
                  "label": "沃尔恰县",
                  "value": 359
                },
                {
                  "label": "加拉茨县",
                  "value": 360
                },
                {
                  "label": "哈尔吉塔县",
                  "value": 361
                },
                {
                  "label": "巴克乌县",
                  "value": 362
                },
                {
                  "label": "特列奥尔曼县",
                  "value": 363
                },
                {
                  "label": "雅西县",
                  "value": 364
                },
                {
                  "label": "胡内多阿拉县",
                  "value": 365
                },
                {
                  "label": "罗马尼亚",
                  "value": 366
                },
                {
                  "label": "布勒伊拉县",
                  "value": 367
                },
                {
                  "label": "萨图马雷县",
                  "value": 368
                },
                {
                  "label": "卡拉什－塞维林县",
                  "value": 369
                },
                {
                  "label": "阿拉德县",
                  "value": 370
                },
                {
                  "label": "布拉索夫县",
                  "value": 371
                },
                {
                  "label": "阿尔杰什县",
                  "value": 372
                },
                {
                  "label": "康斯坦察县",
                  "value": 373
                },
                {
                  "label": "弗朗恰县",
                  "value": 374
                },
                {
                  "label": "比霍尔县",
                  "value": 375
                },
                {
                  "label": "锡比乌县",
                  "value": 376
                },
                {
                  "label": "尼亚姆茨县",
                  "value": 377
                },
                {
                  "label": "马拉穆列什县",
                  "value": 378
                },
                {
                  "label": "瑟拉日县",
                  "value": 379
                },
                {
                  "label": "多尔日县",
                  "value": 380
                },
                {
                  "label": "普拉霍瓦县",
                  "value": 381
                },
                {
                  "label": "戈尔日县",
                  "value": 382
                },
                {
                  "label": "阿尔巴县",
                  "value": 383
                },
                {
                  "label": "蒂米什县",
                  "value": 384
                },
                {
                  "label": "梅赫丁茨县",
                  "value": 385
                },
                {
                  "label": "苏恰瓦县",
                  "value": 386
                }
              ]
            },
            {
              "country_code": 36,
              "country_name_ch": "阿根廷",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Argentina.svg",
              "cityIds": [
                387,
                388,
                389,
                390,
                391,
                392,
                393,
                394,
                395,
                396,
                397,
                398,
                399,
                400,
                401,
                402,
                403,
                404,
                405,
                406,
                407,
                408,
                409,
                410,
                411
              ],
              "provinces": [
                {
                  "label": "福莫萨省",
                  "value": 387
                },
                {
                  "label": "布宜诺斯艾利斯",
                  "value": 388
                },
                {
                  "label": "恩特雷里奥斯省",
                  "value": 389
                },
                {
                  "label": "圣地亚哥－德尔埃斯特罗省",
                  "value": 390
                },
                {
                  "label": "圣路易斯省",
                  "value": 391
                },
                {
                  "label": "丘布特省",
                  "value": 392
                },
                {
                  "label": "拉里奥哈省",
                  "value": 393
                },
                {
                  "label": "阿根廷",
                  "value": 394
                },
                {
                  "label": "火地省",
                  "value": 395
                },
                {
                  "label": "科尔多瓦省",
                  "value": 396
                },
                {
                  "label": "查科省",
                  "value": 397
                },
                {
                  "label": "布宜诺斯艾利斯省",
                  "value": 398
                },
                {
                  "label": "圣菲省",
                  "value": 399
                },
                {
                  "label": "图库曼省",
                  "value": 400
                },
                {
                  "label": "圣克鲁斯省",
                  "value": 401
                },
                {
                  "label": "科连特斯省",
                  "value": 402
                },
                {
                  "label": "胡胡伊省",
                  "value": 403
                },
                {
                  "label": "内乌肯省",
                  "value": 404
                },
                {
                  "label": "米西奥内斯省",
                  "value": 405
                },
                {
                  "label": "圣胡安省",
                  "value": 406
                },
                {
                  "label": "卡塔马卡省",
                  "value": 407
                },
                {
                  "label": "内格罗河省",
                  "value": 408
                },
                {
                  "label": "门多萨省",
                  "value": 409
                },
                {
                  "label": "拉潘帕省",
                  "value": 410
                },
                {
                  "label": "萨尔塔省",
                  "value": 411
                }
              ]
            },
            {
              "country_code": 47,
              "country_name_ch": "哥伦比亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Colombia.svg",
              "cityIds": [
                513,
                514,
                515,
                516,
                517,
                518,
                519,
                520,
                521,
                522,
                523,
                524,
                525,
                526,
                527,
                528,
                529,
                530,
                531,
                532,
                533,
                534,
                535,
                536,
                537,
                538,
                539,
                540,
                541,
                542,
                543
              ],
              "provinces": [
                {
                  "label": "卡尔达斯省",
                  "value": 513
                },
                {
                  "label": "考卡省",
                  "value": 514
                },
                {
                  "label": "普图马约省",
                  "value": 515
                },
                {
                  "label": "苏克雷省",
                  "value": 516
                },
                {
                  "label": "卡萨纳雷省",
                  "value": 517
                },
                {
                  "label": "波利瓦尔省",
                  "value": 518
                },
                {
                  "label": "考卡山谷省",
                  "value": 519
                },
                {
                  "label": "金迪奥省",
                  "value": 520
                },
                {
                  "label": "乌伊拉省",
                  "value": 521
                },
                {
                  "label": "马格达莱纳省",
                  "value": 522
                },
                {
                  "label": "安蒂奥基亚省",
                  "value": 523
                },
                {
                  "label": "波哥大首都区",
                  "value": 524
                },
                {
                  "label": "瓜维亚雷省",
                  "value": 525
                },
                {
                  "label": "博亚卡省",
                  "value": 526
                },
                {
                  "label": "科尔多瓦省",
                  "value": 527
                },
                {
                  "label": "乔科省",
                  "value": 528
                },
                {
                  "label": "梅塔省",
                  "value": 529
                },
                {
                  "label": "里萨拉尔达省",
                  "value": 530
                },
                {
                  "label": "圣安德列斯－普罗维登西亚和圣卡塔利娜群岛省",
                  "value": 531
                },
                {
                  "label": "卡克塔省",
                  "value": 532
                },
                {
                  "label": "阿劳卡省",
                  "value": 533
                },
                {
                  "label": "昆迪纳马卡省",
                  "value": 534
                },
                {
                  "label": "塞萨尔省",
                  "value": 535
                },
                {
                  "label": "北桑坦德省",
                  "value": 536
                },
                {
                  "label": "哥伦比亚",
                  "value": 537
                },
                {
                  "label": "纳里尼奥省",
                  "value": 538
                },
                {
                  "label": "亚马逊省",
                  "value": 539
                },
                {
                  "label": "桑坦德省",
                  "value": 540
                },
                {
                  "label": "大西洋省",
                  "value": 541
                },
                {
                  "label": "托利马省",
                  "value": 542
                },
                {
                  "label": "瓜希拉省",
                  "value": 543
                }
              ]
            },
            {
              "country_code": 54,
              "country_name_ch": "委内瑞拉",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Venezuela.svg",
              "cityIds": [
                553,
                554,
                555,
                556,
                557,
                558,
                559,
                560,
                561,
                562,
                563,
                564,
                565,
                566,
                567,
                568,
                569,
                570,
                571,
                572,
                573
              ],
              "provinces": [
                {
                  "label": "塔奇拉州",
                  "value": 553
                },
                {
                  "label": "特鲁希略州",
                  "value": 554
                },
                {
                  "label": "苏利亚州",
                  "value": 555
                },
                {
                  "label": "卡拉沃沃州",
                  "value": 556
                },
                {
                  "label": "法尔孔州",
                  "value": 557
                },
                {
                  "label": "莫纳加斯州",
                  "value": 558
                },
                {
                  "label": "阿普雷州",
                  "value": 559
                },
                {
                  "label": "瓦尔加斯州",
                  "value": 560
                },
                {
                  "label": "安索阿特吉州",
                  "value": 561
                },
                {
                  "label": "新埃斯帕塔州",
                  "value": 562
                },
                {
                  "label": "波图格萨州",
                  "value": 563
                },
                {
                  "label": "玻利瓦尔州",
                  "value": 564
                },
                {
                  "label": "阿拉瓜州",
                  "value": 565
                },
                {
                  "label": "巴里纳斯州",
                  "value": 566
                },
                {
                  "label": "瓜里科州",
                  "value": 567
                },
                {
                  "label": "米兰达州",
                  "value": 568
                },
                {
                  "label": "苏克雷州",
                  "value": 569
                },
                {
                  "label": "加拉加斯",
                  "value": 570
                },
                {
                  "label": "委内瑞拉",
                  "value": 571
                },
                {
                  "label": "拉腊州",
                  "value": 572
                },
                {
                  "label": "梅里达州",
                  "value": 573
                }
              ]
            },
            {
              "country_code": 87,
              "country_name_ch": "爱尔兰",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Ireland.svg",
              "cityIds": [
                911,
                912
              ],
              "provinces": [
                {
                  "label": "都柏林郡",
                  "value": 911
                },
                {
                  "label": "爱尔兰",
                  "value": 912
                }
              ]
            },
            {
              "country_code": 9,
              "country_name_ch": "秘鲁",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Peru.svg",
              "cityIds": [
                87,
                88,
                89,
                90,
                91,
                92,
                93,
                94,
                95,
                96,
                97,
                98,
                99,
                100,
                101,
                102,
                103,
                104,
                105,
                106,
                107,
                108,
                109,
                110,
                111
              ],
              "provinces": [
                {
                  "label": "利马大区",
                  "value": 87
                },
                {
                  "label": "莫克瓜大区",
                  "value": 88
                },
                {
                  "label": "伊卡大区",
                  "value": 89
                },
                {
                  "label": "卡亚俄大区",
                  "value": 90
                },
                {
                  "label": "利马省",
                  "value": 91
                },
                {
                  "label": "秘鲁",
                  "value": 92
                },
                {
                  "label": "安卡什大区",
                  "value": 93
                },
                {
                  "label": "兰巴耶克大区",
                  "value": 94
                },
                {
                  "label": "圣马丁大区",
                  "value": 95
                },
                {
                  "label": "塔克纳大区",
                  "value": 96
                },
                {
                  "label": "卡哈马卡大区",
                  "value": 97
                },
                {
                  "label": "库斯科大区",
                  "value": 98
                },
                {
                  "label": "胡宁大区",
                  "value": 99
                },
                {
                  "label": "皮乌拉大区",
                  "value": 100
                },
                {
                  "label": "拉利伯塔德大区",
                  "value": 101
                },
                {
                  "label": "乌卡亚利大区",
                  "value": 102
                },
                {
                  "label": "亚马孙大区",
                  "value": 103
                },
                {
                  "label": "万卡韦利卡大区",
                  "value": 104
                },
                {
                  "label": "马德雷德迪奥斯大区",
                  "value": 105
                },
                {
                  "label": "阿雷基帕大区",
                  "value": 106
                },
                {
                  "label": "阿亚库乔大区",
                  "value": 107
                },
                {
                  "label": "瓦努科大区",
                  "value": 108
                },
                {
                  "label": "洛雷托大区",
                  "value": 109
                },
                {
                  "label": "通贝斯大区",
                  "value": 110
                },
                {
                  "label": "普诺大区",
                  "value": 111
                }
              ]
            },
            {
              "country_code": 14,
              "country_name_ch": "白俄罗斯",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Belarus.svg",
              "cityIds": [
                132,
                133,
                134,
                135,
                136
              ],
              "provinces": [
                {
                  "label": "明斯克",
                  "value": 132
                },
                {
                  "label": "维捷布斯克州",
                  "value": 133
                },
                {
                  "label": "戈梅利州",
                  "value": 134
                },
                {
                  "label": "布列斯特州",
                  "value": 135
                },
                {
                  "label": "格罗德诺州",
                  "value": 136
                }
              ]
            },
            {
              "country_code": 43,
              "country_name_ch": "尼日利亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Nigeria.svg",
              "cityIds": [
                440,
                441,
                442
              ],
              "provinces": [
                {
                  "label": "尼日利亚",
                  "value": 440
                },
                {
                  "label": "包奇州",
                  "value": 441
                },
                {
                  "label": "拉各斯州",
                  "value": 442
                }
              ]
            },
            {
              "country_code": 48,
              "country_name_ch": "乌干达",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Uganda.svg",
              "cityIds": [
                544,
                545
              ],
              "provinces": [
                {
                  "label": "乌干达",
                  "value": 544
                },
                {
                  "label": "坎帕拉",
                  "value": 545
                }
              ]
            },
            {
              "country_code": 66,
              "country_name_ch": "缅甸",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Myanmar.svg",
              "cityIds": [
                705,
                706,
                707,
                708,
                709,
                710,
                711,
                712,
                713,
                714,
                715,
                716
              ],
              "provinces": [
                {
                  "label": "内比都联邦区",
                  "value": 705
                },
                {
                  "label": "掸邦",
                  "value": 706
                },
                {
                  "label": "伊洛瓦底省",
                  "value": 707
                },
                {
                  "label": "勃固省",
                  "value": 708
                },
                {
                  "label": "仰光省",
                  "value": 709
                },
                {
                  "label": "德林达依省",
                  "value": 710
                },
                {
                  "label": "马圭省",
                  "value": 711
                },
                {
                  "label": "缅甸",
                  "value": 712
                },
                {
                  "label": "克伦邦",
                  "value": 713
                },
                {
                  "label": "实皆省",
                  "value": 714
                },
                {
                  "label": "孟邦",
                  "value": 715
                },
                {
                  "label": "曼德勒省",
                  "value": 716
                }
              ]
            },
            {
              "country_code": 71,
              "country_name_ch": "立陶宛",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Lithuania.svg",
              "cityIds": [
                734,
                735,
                736,
                737,
                738,
                739,
                740
              ],
              "provinces": [
                {
                  "label": "维尔纽斯县",
                  "value": 734
                },
                {
                  "label": "克莱佩达县",
                  "value": 735
                },
                {
                  "label": "乌田纳县",
                  "value": 736
                },
                {
                  "label": "帕涅韦日斯县",
                  "value": 737
                },
                {
                  "label": "立陶宛",
                  "value": 738
                },
                {
                  "label": "考纳斯县",
                  "value": 739
                },
                {
                  "label": "希奥利艾县",
                  "value": 740
                }
              ]
            },
            {
              "country_code": 143,
              "country_name_ch": "柬埔寨",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Cambodia.svg",
              "cityIds": [
                1276,
                1277,
                1278,
                1279,
                1280,
                1281,
                1282,
                1283
              ],
              "provinces": [
                {
                  "label": "暹粒省",
                  "value": 1276
                },
                {
                  "label": "柴桢省",
                  "value": 1277
                },
                {
                  "label": "西哈努克省",
                  "value": 1278
                },
                {
                  "label": "马德望省",
                  "value": 1279
                },
                {
                  "label": "甘丹省",
                  "value": 1280
                },
                {
                  "label": "柬埔寨",
                  "value": 1281
                },
                {
                  "label": "班迭棉吉省",
                  "value": 1282
                },
                {
                  "label": "金边",
                  "value": 1283
                }
              ]
            },
            {
              "country_code": 148,
              "country_name_ch": "利比亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Libya.svg",
              "cityIds": [
                1302,
                1303,
                1304,
                1305,
                1306,
                1307,
                1308,
                1309,
                1310,
                1311,
                1312,
                1313,
                1314,
                1315,
                1316,
                1317
              ],
              "provinces": [
                {
                  "label": "迈尔盖卜省",
                  "value": 1302
                },
                {
                  "label": "布特南省",
                  "value": 1303
                },
                {
                  "label": "纳卢特省",
                  "value": 1304
                },
                {
                  "label": "德尔纳省",
                  "value": 1305
                },
                {
                  "label": "班加西省",
                  "value": 1306
                },
                {
                  "label": "朱夫拉省",
                  "value": 1307
                },
                {
                  "label": "绿洲省",
                  "value": 1308
                },
                {
                  "label": "苏尔特省",
                  "value": 1309
                },
                {
                  "label": "扎维耶省",
                  "value": 1310
                },
                {
                  "label": "努加特海姆斯省",
                  "value": 1311
                },
                {
                  "label": "米苏拉塔省",
                  "value": 1312
                },
                {
                  "label": "的黎波里省",
                  "value": 1313
                },
                {
                  "label": "西山省",
                  "value": 1314
                },
                {
                  "label": "绿山省",
                  "value": 1315
                },
                {
                  "label": "迈尔季省",
                  "value": 1316
                },
                {
                  "label": "利比亚",
                  "value": 1317
                }
              ]
            },
            {
              "country_code": 149,
              "country_name_ch": "荷兰",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Netherlands.svg",
              "cityIds": [
                1318,
                1319,
                1320,
                1321,
                1322,
                1323,
                1324,
                1325,
                1326,
                1327
              ],
              "provinces": [
                {
                  "label": "北荷兰省",
                  "value": 1318
                },
                {
                  "label": "海尔德兰省",
                  "value": 1319
                },
                {
                  "label": "乌得勒支省",
                  "value": 1320
                },
                {
                  "label": "北布拉班特省",
                  "value": 1321
                },
                {
                  "label": "南荷兰省",
                  "value": 1322
                },
                {
                  "label": "林堡省",
                  "value": 1323
                },
                {
                  "label": "上艾瑟尔省",
                  "value": 1324
                },
                {
                  "label": "荷兰",
                  "value": 1325
                },
                {
                  "label": "弗莱福兰省",
                  "value": 1326
                },
                {
                  "label": "德伦特省",
                  "value": 1327
                }
              ]
            },
            {
              "country_code": 158,
              "country_name_ch": "越南",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Vietnam.svg",
              "cityIds": [
                1403,
                1404,
                1405,
                1406,
                1407,
                1408,
                1409,
                1410,
                1411,
                1412,
                1413,
                1414,
                1415,
                1416,
                1417,
                1418,
                1419,
                1420,
                1421,
                1422,
                1423,
                1424,
                1425,
                1426,
                1427,
                1428,
                1429,
                1430,
                1431
              ],
              "provinces": [
                {
                  "label": "隆安省",
                  "value": 1403
                },
                {
                  "label": "海防市",
                  "value": 1404
                },
                {
                  "label": "平阳省",
                  "value": 1405
                },
                {
                  "label": "平定省",
                  "value": 1406
                },
                {
                  "label": "河南省",
                  "value": 1407
                },
                {
                  "label": "海阳省",
                  "value": 1408
                },
                {
                  "label": "前江省",
                  "value": 1409
                },
                {
                  "label": "朔庄省",
                  "value": 1410
                },
                {
                  "label": "岘港市",
                  "value": 1411
                },
                {
                  "label": "北部地区",
                  "value": 1412
                },
                {
                  "label": "太原省",
                  "value": 1413
                },
                {
                  "label": "芹苴市",
                  "value": 1414
                },
                {
                  "label": "庆和省",
                  "value": 1415
                },
                {
                  "label": "河静省",
                  "value": 1416
                },
                {
                  "label": "南部地区",
                  "value": 1417
                },
                {
                  "label": "同奈省",
                  "value": 1418
                },
                {
                  "label": "同塔省",
                  "value": 1419
                },
                {
                  "label": "安江省",
                  "value": 1420
                },
                {
                  "label": "得乐省",
                  "value": 1421
                },
                {
                  "label": "平顺省",
                  "value": 1422
                },
                {
                  "label": "西宁省",
                  "value": 1423
                },
                {
                  "label": "河内市",
                  "value": 1424
                },
                {
                  "label": "富寿省",
                  "value": 1425
                },
                {
                  "label": "胡志明市",
                  "value": 1426
                },
                {
                  "label": "金瓯省",
                  "value": 1427
                },
                {
                  "label": "茶荣省",
                  "value": 1428
                },
                {
                  "label": "太平省",
                  "value": 1429
                },
                {
                  "label": "广治省",
                  "value": 1430
                },
                {
                  "label": "越南",
                  "value": 1431
                }
              ]
            },
            {
              "country_code": 165,
              "country_name_ch": "巴巴多斯",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Barbados.svg",
              "cityIds": [
                1509
              ],
              "provinces": [
                {
                  "label": "巴巴多斯",
                  "value": 1509
                }
              ]
            },
            {
              "country_code": 4,
              "country_name_ch": "格鲁吉亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Georgia.svg",
              "cityIds": [
                49,
                50,
                51,
                52,
                53,
                54,
                55,
                56,
                57,
                58,
                59
              ],
              "provinces": [
                {
                  "label": "阿布哈兹共和国",
                  "value": 49
                },
                {
                  "label": "姆茨赫塔－姆季阿涅季州",
                  "value": 50
                },
                {
                  "label": "克维莫－卡特利州",
                  "value": 51
                },
                {
                  "label": "伊梅列季州",
                  "value": 52
                },
                {
                  "label": "古利亚州",
                  "value": 53
                },
                {
                  "label": "什达－卡特利州",
                  "value": 54
                },
                {
                  "label": "格鲁吉亚",
                  "value": 55
                },
                {
                  "label": "阿扎尔自治共和国",
                  "value": 56
                },
                {
                  "label": "萨梅格列罗－上斯瓦涅季亚州",
                  "value": 57
                },
                {
                  "label": "第比利斯",
                  "value": 58
                },
                {
                  "label": "卡赫季州",
                  "value": 59
                }
              ]
            },
            {
              "country_code": 5,
              "country_name_ch": "特立尼达和多巴哥",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/TrinidadAndTobago.svg",
              "cityIds": [
                60,
                61,
                62,
                63,
                64,
                65,
                66
              ],
              "provinces": [
                {
                  "label": "波因特福廷",
                  "value": 60
                },
                {
                  "label": "特立尼达和多巴哥",
                  "value": 61
                },
                {
                  "label": "西班牙港",
                  "value": 62
                },
                {
                  "label": "王子镇地区",
                  "value": 63
                },
                {
                  "label": "图纳普纳－皮亚尔科地区",
                  "value": 64
                },
                {
                  "label": "锡帕里亚地区",
                  "value": 65
                },
                {
                  "label": "大桑格雷地区",
                  "value": 66
                }
              ]
            },
            {
              "country_code": 6,
              "country_name_ch": "阿鲁巴",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Aruba.svg",
              "cityIds": [
                67
              ],
              "provinces": [
                {
                  "label": "阿鲁巴",
                  "value": 67
                }
              ]
            },
            {
              "country_code": 10,
              "country_name_ch": "斯洛文尼亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Slovenia.svg",
              "cityIds": [
                112,
                113,
                114,
                115
              ],
              "provinces": [
                {
                  "label": "斯洛文尼亚格拉代茨市",
                  "value": 112
                },
                {
                  "label": "穆尔斯卡索博塔市",
                  "value": 113
                },
                {
                  "label": "卢布尔雅那",
                  "value": 114
                },
                {
                  "label": "斯洛文尼亚",
                  "value": 115
                }
              ]
            },
            {
              "country_code": 11,
              "country_name_ch": "玻利维亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Bolivia.svg",
              "cityIds": [
                116,
                117,
                118,
                119,
                120,
                121,
                122
              ],
              "provinces": [
                {
                  "label": "圣克鲁斯省",
                  "value": 116
                },
                {
                  "label": "潘多省",
                  "value": 117
                },
                {
                  "label": "贝尼省",
                  "value": 118
                },
                {
                  "label": "奥鲁罗省",
                  "value": 119
                },
                {
                  "label": "科恰班巴省",
                  "value": 120
                },
                {
                  "label": "拉巴斯省",
                  "value": 121
                },
                {
                  "label": "玻利维亚",
                  "value": 122
                }
              ]
            },
            {
              "country_code": 12,
              "country_name_ch": "多米尼克",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Dominica.svg",
              "cityIds": [
                123
              ],
              "provinces": [
                {
                  "label": "多米尼克",
                  "value": 123
                }
              ]
            },
            {
              "country_code": 15,
              "country_name_ch": "马拉维",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Malawi.svg",
              "cityIds": [
                137,
                138
              ],
              "provinces": [
                {
                  "label": "中央区",
                  "value": 137
                },
                {
                  "label": "南部区",
                  "value": 138
                }
              ]
            },
            {
              "country_code": 17,
              "country_name_ch": "卡塔尔",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Qatar.svg",
              "cityIds": [
                145,
                146
              ],
              "provinces": [
                {
                  "label": "卡塔尔",
                  "value": 145
                },
                {
                  "label": "多哈",
                  "value": 146
                }
              ]
            },
            {
              "country_code": 18,
              "country_name_ch": "塞尔维亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Serbia.svg",
              "cityIds": [
                147,
                148,
                149,
                150,
                151,
                152,
                153,
                154,
                155,
                156,
                157,
                158,
                159,
                160
              ],
              "provinces": [
                {
                  "label": "尼沙瓦州",
                  "value": 147
                },
                {
                  "label": "贝尔格莱德",
                  "value": 148
                },
                {
                  "label": "普奇尼亚州",
                  "value": 149
                },
                {
                  "label": "北巴奇卡州",
                  "value": 150
                },
                {
                  "label": "马切万州",
                  "value": 151
                },
                {
                  "label": "博尔州",
                  "value": 152
                },
                {
                  "label": "拉什卡州",
                  "value": 153
                },
                {
                  "label": "莫拉瓦州",
                  "value": 154
                },
                {
                  "label": "波莫拉夫列州",
                  "value": 155
                },
                {
                  "label": "布兰尼切夫州",
                  "value": 156
                },
                {
                  "label": "南巴纳特州",
                  "value": 157
                },
                {
                  "label": "斯雷姆州",
                  "value": 158
                },
                {
                  "label": "塞尔维亚",
                  "value": 159
                },
                {
                  "label": "拉辛那州",
                  "value": 160
                }
              ]
            },
            {
              "country_code": 19,
              "country_name_ch": "法属圣马丁",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/CollectivitedeSaintMartin.svg",
              "cityIds": [
                161
              ],
              "provinces": [
                {
                  "label": "马里戈特",
                  "value": 161
                }
              ]
            },
            {
              "country_code": 22,
              "country_name_ch": "叙利亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/SyrianArabRepublic.svg",
              "cityIds": [
                198,
                199,
                200,
                201,
                202
              ],
              "provinces": [
                {
                  "label": "塔尔图斯省",
                  "value": 198
                },
                {
                  "label": "叙利亚",
                  "value": 199
                },
                {
                  "label": "大马士革省",
                  "value": 200
                },
                {
                  "label": "阿勒颇省",
                  "value": 201
                },
                {
                  "label": "哈马省",
                  "value": 202
                }
              ]
            },
            {
              "country_code": 23,
              "country_name_ch": "莫桑比克",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Mozambique.svg",
              "cityIds": [
                203
              ],
              "provinces": [
                {
                  "label": "马普托",
                  "value": 203
                }
              ]
            },
            {
              "country_code": 25,
              "country_name_ch": "阿尔巴尼亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Albania.svg",
              "cityIds": [
                237,
                238,
                239,
                240,
                241,
                242,
                243,
                244,
                245
              ],
              "provinces": [
                {
                  "label": "都拉斯州",
                  "value": 237
                },
                {
                  "label": "地拉那州",
                  "value": 238
                },
                {
                  "label": "培拉特州",
                  "value": 239
                },
                {
                  "label": "爱尔巴桑州",
                  "value": 240
                },
                {
                  "label": "迪勃拉州",
                  "value": 241
                },
                {
                  "label": "斯库台州",
                  "value": 242
                },
                {
                  "label": "费里州",
                  "value": 243
                },
                {
                  "label": "发罗拉州",
                  "value": 244
                },
                {
                  "label": "阿尔巴尼亚",
                  "value": 245
                }
              ]
            },
            {
              "country_code": 26,
              "country_name_ch": "以色列",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Israel.svg",
              "cityIds": [
                246,
                247,
                248,
                249,
                250,
                251,
                252
              ],
              "provinces": [
                {
                  "label": "北部区",
                  "value": 246
                },
                {
                  "label": "以色列",
                  "value": 247
                },
                {
                  "label": "中央区",
                  "value": 248
                },
                {
                  "label": "特拉维夫区",
                  "value": 249
                },
                {
                  "label": "耶路撒冷区",
                  "value": 250
                },
                {
                  "label": "南部区",
                  "value": 251
                },
                {
                  "label": "海法区",
                  "value": 252
                }
              ]
            },
            {
              "country_code": 27,
              "country_name_ch": "伯利兹",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Belize.svg",
              "cityIds": [
                253,
                254,
                255
              ],
              "provinces": [
                {
                  "label": "伯利兹区",
                  "value": 253
                },
                {
                  "label": "卡约区",
                  "value": 254
                },
                {
                  "label": "科罗萨尔区",
                  "value": 255
                }
              ]
            },
            {
              "country_code": 28,
              "country_name_ch": "塔吉克斯坦",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Tajikistan.svg",
              "cityIds": [
                256,
                257
              ],
              "provinces": [
                {
                  "label": "塔吉克斯坦",
                  "value": 256
                },
                {
                  "label": "杜尚别",
                  "value": 257
                }
              ]
            },
            {
              "country_code": 29,
              "country_name_ch": "马约特",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Mayotte.svg",
              "cityIds": [
                258
              ],
              "provinces": [
                {
                  "label": "马约特",
                  "value": 258
                }
              ]
            },
            {
              "country_code": 30,
              "country_name_ch": "苏丹",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Sudan.svg",
              "cityIds": [
                295,
                296
              ],
              "provinces": [
                {
                  "label": "喀土穆州",
                  "value": 295
                },
                {
                  "label": "苏丹",
                  "value": 296
                }
              ]
            },
            {
              "country_code": 31,
              "country_name_ch": "不丹",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Bhutan.svg",
              "cityIds": [
                297
              ],
              "provinces": [
                {
                  "label": "不丹",
                  "value": 297
                }
              ]
            },
            {
              "country_code": 32,
              "country_name_ch": "马耳他",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Malta.svg",
              "cityIds": [
                298
              ],
              "provinces": [
                {
                  "label": "马耳他",
                  "value": 298
                }
              ]
            },
            {
              "country_code": 37,
              "country_name_ch": "智利",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Chile.svg",
              "cityIds": [
                412,
                413,
                414,
                415,
                416,
                417,
                418,
                419,
                420,
                421,
                422,
                423,
                424,
                425,
                426,
                427,
                428
              ],
              "provinces": [
                {
                  "label": "阿里卡和帕里纳科塔大区",
                  "value": 412
                },
                {
                  "label": "瓦尔帕莱索大区",
                  "value": 413
                },
                {
                  "label": "阿劳卡尼亚大区",
                  "value": 414
                },
                {
                  "label": "麦哲伦－智利南极大区",
                  "value": 415
                },
                {
                  "label": "圣地亚哥首都大区",
                  "value": 416
                },
                {
                  "label": "科金博大区",
                  "value": 417
                },
                {
                  "label": "湖大区",
                  "value": 418
                },
                {
                  "label": "纽布莱大区",
                  "value": 419
                },
                {
                  "label": "安托法加斯塔大区",
                  "value": 420
                },
                {
                  "label": "塔拉帕卡大区",
                  "value": 421
                },
                {
                  "label": "比奥比奥大区",
                  "value": 422
                },
                {
                  "label": "奥伊金斯将军解放者大区",
                  "value": 423
                },
                {
                  "label": "马乌莱大区",
                  "value": 424
                },
                {
                  "label": "河大区",
                  "value": 425
                },
                {
                  "label": "伊瓦涅斯将军的艾森大区",
                  "value": 426
                },
                {
                  "label": "智利",
                  "value": 427
                },
                {
                  "label": "阿塔卡马大区",
                  "value": 428
                }
              ]
            },
            {
              "country_code": 38,
              "country_name_ch": "也门",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Yemen.svg",
              "cityIds": [
                429,
                430,
                431
              ],
              "provinces": [
                {
                  "label": "也门",
                  "value": 429
                },
                {
                  "label": "萨那",
                  "value": 430
                },
                {
                  "label": "亚丁省",
                  "value": 431
                }
              ]
            },
            {
              "country_code": 39,
              "country_name_ch": "海地",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Haiti.svg",
              "cityIds": [
                432,
                433
              ],
              "provinces": [
                {
                  "label": "海地",
                  "value": 432
                },
                {
                  "label": "西部省",
                  "value": 433
                }
              ]
            },
            {
              "country_code": 40,
              "country_name_ch": "斐济",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Fiji.svg",
              "cityIds": [
                434
              ],
              "provinces": [
                {
                  "label": "斐济",
                  "value": 434
                }
              ]
            },
            {
              "country_code": 44,
              "country_name_ch": "瑞士",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Switzerland.svg",
              "cityIds": [
                443,
                444,
                445,
                446,
                447,
                448,
                449
              ],
              "provinces": [
                {
                  "label": "提契诺州",
                  "value": 443
                },
                {
                  "label": "日内瓦州",
                  "value": 444
                },
                {
                  "label": "巴塞尔城市州",
                  "value": 445
                },
                {
                  "label": "瑞士",
                  "value": 446
                },
                {
                  "label": "苏黎世州",
                  "value": 447
                },
                {
                  "label": "楚格州",
                  "value": 448
                },
                {
                  "label": "伯尔尼州",
                  "value": 449
                }
              ]
            },
            {
              "country_code": 45,
              "country_name_ch": "拉美地区",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "",
              "cityIds": [
                450
              ],
              "provinces": [
                {
                  "label": "拉美地区",
                  "value": 450
                }
              ]
            },
            {
              "country_code": 49,
              "country_name_ch": "吉尔吉斯斯坦",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Kyrgyzstan.svg",
              "cityIds": [
                546,
                547
              ],
              "provinces": [
                {
                  "label": "比什凯克",
                  "value": 546
                },
                {
                  "label": "吉尔吉斯斯坦",
                  "value": 547
                }
              ]
            },
            {
              "country_code": 50,
              "country_name_ch": "冈比亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Gambia.svg",
              "cityIds": [
                548
              ],
              "provinces": [
                {
                  "label": "班珠尔区",
                  "value": 548
                }
              ]
            },
            {
              "country_code": 51,
              "country_name_ch": "斯里兰卡",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/SriLanka.svg",
              "cityIds": [
                549
              ],
              "provinces": [
                {
                  "label": "西部省",
                  "value": 549
                }
              ]
            },
            {
              "country_code": 52,
              "country_name_ch": "加纳",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Ghana.svg",
              "cityIds": [
                550,
                551
              ],
              "provinces": [
                {
                  "label": "大阿克拉地区",
                  "value": 550
                },
                {
                  "label": "加纳",
                  "value": 551
                }
              ]
            },
            {
              "country_code": 53,
              "country_name_ch": "赞比亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Zambia.svg",
              "cityIds": [
                552
              ],
              "provinces": [
                {
                  "label": "铜带省",
                  "value": 552
                }
              ]
            },
            {
              "country_code": 55,
              "country_name_ch": "尼加拉瓜",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Nicaragua.svg",
              "cityIds": [
                574,
                575,
                576
              ],
              "provinces": [
                {
                  "label": "马那瓜省",
                  "value": 574
                },
                {
                  "label": "卡拉索省",
                  "value": 575
                },
                {
                  "label": "尼加拉瓜",
                  "value": 576
                }
              ]
            },
            {
              "country_code": 56,
              "country_name_ch": "阿富汗",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Afghanistan.svg",
              "cityIds": [
                577
              ],
              "provinces": [
                {
                  "label": "阿富汗",
                  "value": 577
                }
              ]
            },
            {
              "country_code": 57,
              "country_name_ch": "科威特",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Kuwait.svg",
              "cityIds": [
                578,
                579
              ],
              "provinces": [
                {
                  "label": "科威特",
                  "value": 578
                },
                {
                  "label": "首都省",
                  "value": 579
                }
              ]
            },
            {
              "country_code": 58,
              "country_name_ch": "加蓬",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Gabon.svg",
              "cityIds": [
                580
              ],
              "provinces": [
                {
                  "label": "河口省",
                  "value": 580
                }
              ]
            },
            {
              "country_code": 59,
              "country_name_ch": "马里",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Mali.svg",
              "cityIds": [
                581
              ],
              "provinces": [
                {
                  "label": "巴马科",
                  "value": 581
                }
              ]
            },
            {
              "country_code": 60,
              "country_name_ch": "阿塞拜疆",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Azerbaijan.svg",
              "cityIds": [
                582,
                583,
                584,
                585,
                586,
                587,
                588,
                589,
                590,
                591,
                592,
                593,
                594,
                595,
                596,
                597,
                598,
                599,
                600,
                601
              ],
              "provinces": [
                {
                  "label": "沙姆基尔区",
                  "value": 582
                },
                {
                  "label": "阿克斯塔法区",
                  "value": 583
                },
                {
                  "label": "乌贾雷区",
                  "value": 584
                },
                {
                  "label": "盖奥克恰伊区",
                  "value": 585
                },
                {
                  "label": "库萨雷区",
                  "value": 586
                },
                {
                  "label": "占贾",
                  "value": 587
                },
                {
                  "label": "盖贝莱区",
                  "value": 588
                },
                {
                  "label": "巴库",
                  "value": 589
                },
                {
                  "label": "阿布歇隆区",
                  "value": 590
                },
                {
                  "label": "苏姆盖特",
                  "value": 591
                },
                {
                  "label": "巴尔达区",
                  "value": 592
                },
                {
                  "label": "汉肯德",
                  "value": 593
                },
                {
                  "label": "扎卡塔雷区",
                  "value": 594
                },
                {
                  "label": "明盖恰乌尔",
                  "value": 595
                },
                {
                  "label": "阿格达什区",
                  "value": 596
                },
                {
                  "label": "阿格贾贝迪区",
                  "value": 597
                },
                {
                  "label": "阿塞拜疆",
                  "value": 598
                },
                {
                  "label": "菲祖利区",
                  "value": 599
                },
                {
                  "label": "希尔万",
                  "value": 600
                },
                {
                  "label": "纳希切万",
                  "value": 601
                }
              ]
            },
            {
              "country_code": 61,
              "country_name_ch": "斯洛伐克",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Slovakia.svg",
              "cityIds": [
                602,
                603,
                604,
                605,
                606,
                607,
                608,
                609
              ],
              "provinces": [
                {
                  "label": "布拉迪斯拉发州",
                  "value": 602
                },
                {
                  "label": "日利纳州",
                  "value": 603
                },
                {
                  "label": "班斯卡－比斯特里察州",
                  "value": 604
                },
                {
                  "label": "普列索夫州",
                  "value": 605
                },
                {
                  "label": "尼特拉州",
                  "value": 606
                },
                {
                  "label": "特尔纳瓦州",
                  "value": 607
                },
                {
                  "label": "科希策州",
                  "value": 608
                },
                {
                  "label": "斯洛伐克",
                  "value": 609
                }
              ]
            },
            {
              "country_code": 62,
              "country_name_ch": "基里巴斯",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Kiribati.svg",
              "cityIds": [
                610
              ],
              "provinces": [
                {
                  "label": "吉尔柏特群岛",
                  "value": 610
                }
              ]
            },
            {
              "country_code": 63,
              "country_name_ch": "卢森堡",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Luxembourg.svg",
              "cityIds": [
                611
              ],
              "provinces": [
                {
                  "label": "卢森堡",
                  "value": 611
                }
              ]
            },
            {
              "country_code": 67,
              "country_name_ch": "南非",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/SouthAfrica.svg",
              "cityIds": [
                717,
                718,
                719
              ],
              "provinces": [
                {
                  "label": "南非",
                  "value": 717
                },
                {
                  "label": "西开普省",
                  "value": 718
                },
                {
                  "label": "豪登省",
                  "value": 719
                }
              ]
            },
            {
              "country_code": 68,
              "country_name_ch": "克罗地亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Croatia.svg",
              "cityIds": [
                720,
                721,
                722,
                723,
                724
              ],
              "provinces": [
                {
                  "label": "奥西耶克－巴拉尼亚县",
                  "value": 720
                },
                {
                  "label": "萨格勒布县",
                  "value": 721
                },
                {
                  "label": "伊斯特拉县",
                  "value": 722
                },
                {
                  "label": "萨格勒布",
                  "value": 723
                },
                {
                  "label": "克罗地亚",
                  "value": 724
                }
              ]
            },
            {
              "country_code": 69,
              "country_name_ch": "北美地区",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "",
              "cityIds": [
                725
              ],
              "provinces": [
                {
                  "label": "北美地区",
                  "value": 725
                }
              ]
            },
            {
              "country_code": 72,
              "country_name_ch": "匈牙利",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Hungary.svg",
              "cityIds": [
                741,
                742,
                743,
                744,
                745,
                746,
                747,
                748,
                749,
                750,
                751,
                752,
                753,
                754,
                755,
                756,
                757,
                758,
                759,
                760,
                761
              ],
              "provinces": [
                {
                  "label": "费耶尔州",
                  "value": 741
                },
                {
                  "label": "索博尔奇－索特马尔－贝拉格州",
                  "value": 742
                },
                {
                  "label": "托尔瑙州",
                  "value": 743
                },
                {
                  "label": "沃什州",
                  "value": 744
                },
                {
                  "label": "巴兰尼亚州",
                  "value": 745
                },
                {
                  "label": "琼格拉德州",
                  "value": 746
                },
                {
                  "label": "包尔绍德－奥包乌伊－曾普伦州",
                  "value": 747
                },
                {
                  "label": "亚斯－大昆－索尔诺克州",
                  "value": 748
                },
                {
                  "label": "布达佩斯",
                  "value": 749
                },
                {
                  "label": "佐洛州",
                  "value": 750
                },
                {
                  "label": "诺格拉德州",
                  "value": 751
                },
                {
                  "label": "巴奇－基什孔州",
                  "value": 752
                },
                {
                  "label": "佩斯州",
                  "value": 753
                },
                {
                  "label": "科马罗姆－埃斯泰尔戈姆州",
                  "value": 754
                },
                {
                  "label": "杰尔－莫雄－肖普朗州",
                  "value": 755
                },
                {
                  "label": "匈牙利",
                  "value": 756
                },
                {
                  "label": "贝凯什州",
                  "value": 757
                },
                {
                  "label": "豪伊杜－比豪尔州",
                  "value": 758
                },
                {
                  "label": "绍莫吉州",
                  "value": 759
                },
                {
                  "label": "维斯普雷姆州",
                  "value": 760
                },
                {
                  "label": "赫维什州",
                  "value": 761
                }
              ]
            },
            {
              "country_code": 73,
              "country_name_ch": "挪威",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Norway.svg",
              "cityIds": [
                762,
                763,
                764,
                765,
                766,
                767,
                768
              ],
              "provinces": [
                {
                  "label": "西福尔郡",
                  "value": 762
                },
                {
                  "label": "默勒－鲁姆斯达尔郡",
                  "value": 763
                },
                {
                  "label": "韦斯特兰郡",
                  "value": 764
                },
                {
                  "label": "诺尔兰郡",
                  "value": 765
                },
                {
                  "label": "挪威",
                  "value": 766
                },
                {
                  "label": "奥斯陆郡",
                  "value": 767
                },
                {
                  "label": "罗加兰郡",
                  "value": 768
                }
              ]
            },
            {
              "country_code": 74,
              "country_name_ch": "拉脱维亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Latvia.svg",
              "cityIds": [
                769,
                770,
                771,
                772
              ],
              "provinces": [
                {
                  "label": "里加",
                  "value": 769
                },
                {
                  "label": "拉脱维亚",
                  "value": 770
                },
                {
                  "label": "利耶帕亚",
                  "value": 771
                },
                {
                  "label": "瓦尔米耶拉自治市",
                  "value": 772
                }
              ]
            },
            {
              "country_code": 75,
              "country_name_ch": "摩尔多瓦",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Moldova.svg",
              "cityIds": [
                773,
                774,
                775,
                776,
                777,
                778,
                779,
                780,
                781,
                782,
                783
              ],
              "provinces": [
                {
                  "label": "基希讷乌",
                  "value": 773
                },
                {
                  "label": "雷什卡内区",
                  "value": 774
                },
                {
                  "label": "克留莱尼区",
                  "value": 775
                },
                {
                  "label": "布里切尼区",
                  "value": 776
                },
                {
                  "label": "德涅斯特河沿岸",
                  "value": 777
                },
                {
                  "label": "加告兹自治区",
                  "value": 778
                },
                {
                  "label": "栋杜谢尼区",
                  "value": 779
                },
                {
                  "label": "德罗基亚区",
                  "value": 780
                },
                {
                  "label": "森杰雷区",
                  "value": 781
                },
                {
                  "label": "摩尔多瓦",
                  "value": 782
                },
                {
                  "label": "宾杰里",
                  "value": 783
                }
              ]
            },
            {
              "country_code": 76,
              "country_name_ch": "东帝汶",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Timor-Leste.svg",
              "cityIds": [
                784
              ],
              "provinces": [
                {
                  "label": "东帝汶",
                  "value": 784
                }
              ]
            },
            {
              "country_code": 78,
              "country_name_ch": "乌兹别克斯坦",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Uzbekistan.svg",
              "cityIds": [
                807,
                808,
                809,
                810,
                811,
                812,
                813,
                814,
                815,
                816,
                817,
                818,
                819
              ],
              "provinces": [
                {
                  "label": "撒马尔罕州",
                  "value": 807
                },
                {
                  "label": "卡什卡达里亚州",
                  "value": 808
                },
                {
                  "label": "费尔干纳州",
                  "value": 809
                },
                {
                  "label": "锡尔河州",
                  "value": 810
                },
                {
                  "label": "塔什干州",
                  "value": 811
                },
                {
                  "label": "吉扎克州",
                  "value": 812
                },
                {
                  "label": "卡拉卡尔帕克斯坦共和国",
                  "value": 813
                },
                {
                  "label": "乌兹别克斯坦",
                  "value": 814
                },
                {
                  "label": "塔什干",
                  "value": 815
                },
                {
                  "label": "纳曼干州",
                  "value": 816
                },
                {
                  "label": "布哈拉州",
                  "value": 817
                },
                {
                  "label": "安集延州",
                  "value": 818
                },
                {
                  "label": "纳沃伊州",
                  "value": 819
                }
              ]
            },
            {
              "country_code": 79,
              "country_name_ch": "GLOBALSECURELAYER.COM",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "",
              "cityIds": [
                820
              ],
              "provinces": [
                {
                  "label": "GLOBALSECURELAYER.COM",
                  "value": 820
                }
              ]
            },
            {
              "country_code": 82,
              "country_name_ch": "希腊",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Greece.svg",
              "cityIds": [
                859,
                860,
                861,
                862,
                863,
                864,
                865,
                866,
                867,
                868,
                869,
                870
              ],
              "provinces": [
                {
                  "label": "阿提卡大区",
                  "value": 859
                },
                {
                  "label": "南爱琴大区",
                  "value": 860
                },
                {
                  "label": "伯罗奔尼撒大区",
                  "value": 861
                },
                {
                  "label": "中希腊大区",
                  "value": 862
                },
                {
                  "label": "色萨利大区",
                  "value": 863
                },
                {
                  "label": "西希腊大区",
                  "value": 864
                },
                {
                  "label": "伊奥尼亚群岛区",
                  "value": 865
                },
                {
                  "label": "希腊",
                  "value": 866
                },
                {
                  "label": "中马其顿大区",
                  "value": 867
                },
                {
                  "label": "东马其顿和色雷斯大区",
                  "value": 868
                },
                {
                  "label": "西马其顿大区",
                  "value": 869
                },
                {
                  "label": "克里特大区",
                  "value": 870
                }
              ]
            },
            {
              "country_code": 83,
              "country_name_ch": "乍得",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Chad.svg",
              "cityIds": [
                871
              ],
              "provinces": [
                {
                  "label": "恩贾梅纳",
                  "value": 871
                }
              ]
            },
            {
              "country_code": 84,
              "country_name_ch": "肯尼亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Kenya.svg",
              "cityIds": [
                872,
                873
              ],
              "provinces": [
                {
                  "label": "内罗毕县",
                  "value": 872
                },
                {
                  "label": "肯尼亚",
                  "value": 873
                }
              ]
            },
            {
              "country_code": 85,
              "country_name_ch": "美属萨摩亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/AmericanSamoa.svg",
              "cityIds": [
                874
              ],
              "provinces": [
                {
                  "label": "东区",
                  "value": 874
                }
              ]
            },
            {
              "country_code": 88,
              "country_name_ch": "奥地利",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Austria.svg",
              "cityIds": [
                913,
                914,
                915,
                916
              ],
              "provinces": [
                {
                  "label": "上奥地利州",
                  "value": 913
                },
                {
                  "label": "维也纳州",
                  "value": 914
                },
                {
                  "label": "奥地利",
                  "value": 915
                },
                {
                  "label": "下奥地利州",
                  "value": 916
                }
              ]
            },
            {
              "country_code": 89,
              "country_name_ch": "科特迪瓦",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Coted'Ivoire.svg",
              "cityIds": [
                917,
                918
              ],
              "provinces": [
                {
                  "label": "阿比让",
                  "value": 917
                },
                {
                  "label": "邦达马河谷地区",
                  "value": 918
                }
              ]
            },
            {
              "country_code": 90,
              "country_name_ch": "布基纳法索",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/BurkinaFaso.svg",
              "cityIds": [
                919
              ],
              "provinces": [
                {
                  "label": "中央大区",
                  "value": 919
                }
              ]
            },
            {
              "country_code": 91,
              "country_name_ch": "百慕大",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Bermuda.svg",
              "cityIds": [
                920
              ],
              "provinces": [
                {
                  "label": "百慕大",
                  "value": 920
                }
              ]
            },
            {
              "country_code": 92,
              "country_name_ch": "瓜德罗普",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Guadeloupe.svg",
              "cityIds": [
                921
              ],
              "provinces": [
                {
                  "label": "瓜德罗普",
                  "value": 921
                }
              ]
            },
            {
              "country_code": 93,
              "country_name_ch": "伊朗",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Iran.svg",
              "cityIds": [
                922,
                923,
                924,
                925,
                926,
                927,
                928,
                929,
                930,
                931
              ],
              "provinces": [
                {
                  "label": "胡齐斯坦省",
                  "value": 922
                },
                {
                  "label": "东阿塞拜疆省",
                  "value": 923
                },
                {
                  "label": "伊朗",
                  "value": 924
                },
                {
                  "label": "库姆省",
                  "value": 925
                },
                {
                  "label": "伊斯法罕省",
                  "value": 926
                },
                {
                  "label": "厄尔布尔士省",
                  "value": 927
                },
                {
                  "label": "法尔斯省",
                  "value": 928
                },
                {
                  "label": "德黑兰省",
                  "value": 929
                },
                {
                  "label": "礼萨呼罗珊省",
                  "value": 930
                },
                {
                  "label": "加兹温省",
                  "value": 931
                }
              ]
            },
            {
              "country_code": 94,
              "country_name_ch": "圭亚那",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Guyana.svg",
              "cityIds": [
                932,
                933
              ],
              "provinces": [
                {
                  "label": "马海卡－伯比斯区",
                  "value": 932
                },
                {
                  "label": "德梅拉拉－马海卡区",
                  "value": 933
                }
              ]
            },
            {
              "country_code": 95,
              "country_name_ch": "法属圭亚那",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/FrenchGuiana.svg",
              "cityIds": [
                934
              ],
              "provinces": [
                {
                  "label": "卡宴区",
                  "value": 934
                }
              ]
            },
            {
              "country_code": 96,
              "country_name_ch": "非洲地区",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "",
              "cityIds": [
                935
              ],
              "provinces": [
                {
                  "label": "非洲地区",
                  "value": 935
                }
              ]
            },
            {
              "country_code": 98,
              "country_name_ch": "巴拿马",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Panama.svg",
              "cityIds": [
                955,
                956,
                957,
                958,
                959,
                960,
                961
              ],
              "provinces": [
                {
                  "label": "科克莱省",
                  "value": 955
                },
                {
                  "label": "巴拿马省",
                  "value": 956
                },
                {
                  "label": "巴拿马",
                  "value": 957
                },
                {
                  "label": "科隆省",
                  "value": 958
                },
                {
                  "label": "贝拉瓜斯省",
                  "value": 959
                },
                {
                  "label": "西巴拿马省",
                  "value": 960
                },
                {
                  "label": "奇里基省",
                  "value": 961
                }
              ]
            },
            {
              "country_code": 99,
              "country_name_ch": "巴拉圭",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Paraguay.svg",
              "cityIds": [
                962,
                963,
                964,
                965,
                966,
                967,
                968,
                969
              ],
              "provinces": [
                {
                  "label": "博克龙省",
                  "value": 962
                },
                {
                  "label": "上巴拉那省",
                  "value": 963
                },
                {
                  "label": "巴拉圭",
                  "value": 964
                },
                {
                  "label": "中央省",
                  "value": 965
                },
                {
                  "label": "圣佩德罗省",
                  "value": 966
                },
                {
                  "label": "巴拉瓜里省",
                  "value": 967
                },
                {
                  "label": "科迪勒拉省",
                  "value": 968
                },
                {
                  "label": "亚松森",
                  "value": 969
                }
              ]
            },
            {
              "country_code": 100,
              "country_name_ch": "芬兰",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Finland.svg",
              "cityIds": [
                970,
                971
              ],
              "provinces": [
                {
                  "label": "芬兰",
                  "value": 970
                },
                {
                  "label": "新地区",
                  "value": 971
                }
              ]
            },
            {
              "country_code": 101,
              "country_name_ch": "尼泊尔",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Nepal.svg",
              "cityIds": [
                972,
                973,
                974,
                975,
                976,
                977
              ],
              "provinces": [
                {
                  "label": "戈西省",
                  "value": 972
                },
                {
                  "label": "远西省",
                  "value": 973
                },
                {
                  "label": "尼泊尔",
                  "value": 974
                },
                {
                  "label": "蓝毗尼省",
                  "value": 975
                },
                {
                  "label": "巴格马蒂省",
                  "value": 976
                },
                {
                  "label": "甘达基省",
                  "value": 977
                }
              ]
            },
            {
              "country_code": 104,
              "country_name_ch": "葡萄牙",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Portugal.svg",
              "cityIds": [
                1023,
                1024,
                1025,
                1026
              ],
              "provinces": [
                {
                  "label": "波尔图区",
                  "value": 1023
                },
                {
                  "label": "葡萄牙",
                  "value": 1024
                },
                {
                  "label": "塞图巴尔区",
                  "value": 1025
                },
                {
                  "label": "里斯本区",
                  "value": 1026
                }
              ]
            },
            {
              "country_code": 105,
              "country_name_ch": "刚果民主共和国",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "",
              "cityIds": [
                1027,
                1028
              ],
              "provinces": [
                {
                  "label": "金沙萨",
                  "value": 1027
                },
                {
                  "label": "上加丹加省",
                  "value": 1028
                }
              ]
            },
            {
              "country_code": 106,
              "country_name_ch": "纳米比亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Namibia.svg",
              "cityIds": [
                1029
              ],
              "provinces": [
                {
                  "label": "霍马斯区",
                  "value": 1029
                }
              ]
            },
            {
              "country_code": 107,
              "country_name_ch": "索马里",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Somalia.svg",
              "cityIds": [
                1030,
                1031
              ],
              "provinces": [
                {
                  "label": "巴纳迪尔州",
                  "value": 1030
                },
                {
                  "label": "索马里",
                  "value": 1031
                }
              ]
            },
            {
              "country_code": 108,
              "country_name_ch": "蒙古",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Mongolia.svg",
              "cityIds": [
                1032
              ],
              "provinces": [
                {
                  "label": "乌兰巴托",
                  "value": 1032
                }
              ]
            },
            {
              "country_code": 111,
              "country_name_ch": "古巴",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Cuba.svg",
              "cityIds": [
                1083
              ],
              "provinces": [
                {
                  "label": "拉哈瓦那省",
                  "value": 1083
                }
              ]
            },
            {
              "country_code": 112,
              "country_name_ch": "牙买加",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Jamaica.svg",
              "cityIds": [
                1084,
                1085,
                1086,
                1087
              ],
              "provinces": [
                {
                  "label": "克雷伦敦区",
                  "value": 1084
                },
                {
                  "label": "圣凯瑟琳区",
                  "value": 1085
                },
                {
                  "label": "牙买加",
                  "value": 1086
                },
                {
                  "label": "金斯敦区",
                  "value": 1087
                }
              ]
            },
            {
              "country_code": 113,
              "country_name_ch": "坦桑尼亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Tanzania.svg",
              "cityIds": [
                1088,
                1089,
                1090
              ],
              "provinces": [
                {
                  "label": "坦桑尼亚",
                  "value": 1088
                },
                {
                  "label": "阿鲁沙区",
                  "value": 1089
                },
                {
                  "label": "乞力马扎罗区",
                  "value": 1090
                }
              ]
            },
            {
              "country_code": 114,
              "country_name_ch": "巴林",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Bahrain.svg",
              "cityIds": [
                1091,
                1092,
                1093
              ],
              "provinces": [
                {
                  "label": "首都省",
                  "value": 1091
                },
                {
                  "label": "巴林",
                  "value": 1092
                },
                {
                  "label": "穆哈拉格省",
                  "value": 1093
                }
              ]
            },
            {
              "country_code": 115,
              "country_name_ch": "黑山",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Montenegro.svg",
              "cityIds": [
                1094
              ],
              "provinces": [
                {
                  "label": "黑山",
                  "value": 1094
                }
              ]
            },
            {
              "country_code": 116,
              "country_name_ch": "新西兰",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/NewZealand.svg",
              "cityIds": [
                1095,
                1096
              ],
              "provinces": [
                {
                  "label": "坎特伯雷大区",
                  "value": 1095
                },
                {
                  "label": "奥克兰大区",
                  "value": 1096
                }
              ]
            },
            {
              "country_code": 121,
              "country_name_ch": "塞浦路斯",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Cyprus.svg",
              "cityIds": [
                1168,
                1169,
                1170,
                1171,
                1172,
                1173
              ],
              "provinces": [
                {
                  "label": "法马古斯塔区",
                  "value": 1168
                },
                {
                  "label": "尼科西亚区",
                  "value": 1169
                },
                {
                  "label": "塞浦路斯",
                  "value": 1170
                },
                {
                  "label": "凯里尼亚区",
                  "value": 1171
                },
                {
                  "label": "利马索尔区",
                  "value": 1172
                },
                {
                  "label": "帕福斯区",
                  "value": 1173
                }
              ]
            },
            {
              "country_code": 122,
              "country_name_ch": "文莱",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Brunei.svg",
              "cityIds": [
                1174,
                1175
              ],
              "provinces": [
                {
                  "label": "文莱",
                  "value": 1174
                },
                {
                  "label": "汶莱摩拉县",
                  "value": 1175
                }
              ]
            },
            {
              "country_code": 123,
              "country_name_ch": "圣卢西亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/SaintLucia.svg",
              "cityIds": [
                1176
              ],
              "provinces": [
                {
                  "label": "圣卢西亚",
                  "value": 1176
                }
              ]
            },
            {
              "country_code": 126,
              "country_name_ch": "洪都拉斯",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Honduras.svg",
              "cityIds": [
                1188,
                1189,
                1190,
                1191,
                1192,
                1193,
                1194,
                1195,
                1196,
                1197
              ],
              "provinces": [
                {
                  "label": "洪都拉斯",
                  "value": 1188
                },
                {
                  "label": "科马亚瓜省",
                  "value": 1189
                },
                {
                  "label": "约罗省",
                  "value": 1190
                },
                {
                  "label": "弗朗西斯科－莫拉桑省",
                  "value": 1191
                },
                {
                  "label": "科潘省",
                  "value": 1192
                },
                {
                  "label": "海湾群岛省",
                  "value": 1193
                },
                {
                  "label": "科尔特斯省",
                  "value": 1194
                },
                {
                  "label": "奥科特佩克省",
                  "value": 1195
                },
                {
                  "label": "科隆省",
                  "value": 1196
                },
                {
                  "label": "阿特兰蒂达省",
                  "value": 1197
                }
              ]
            },
            {
              "country_code": 127,
              "country_name_ch": "保加利亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Bulgaria.svg",
              "cityIds": [
                1198,
                1199,
                1200,
                1201,
                1202,
                1203,
                1204,
                1205,
                1206,
                1207,
                1208,
                1209,
                1210,
                1211,
                1212,
                1213,
                1214
              ],
              "provinces": [
                {
                  "label": "瓦尔纳州",
                  "value": 1198
                },
                {
                  "label": "斯利文州",
                  "value": 1199
                },
                {
                  "label": "布尔加斯州",
                  "value": 1200
                },
                {
                  "label": "帕扎尔吉克州",
                  "value": 1201
                },
                {
                  "label": "拉兹格勒州",
                  "value": 1202
                },
                {
                  "label": "鲁塞州",
                  "value": 1203
                },
                {
                  "label": "克尔贾利州",
                  "value": 1204
                },
                {
                  "label": "佩尔尼克州",
                  "value": 1205
                },
                {
                  "label": "保加利亚",
                  "value": 1206
                },
                {
                  "label": "锡利斯特拉州",
                  "value": 1207
                },
                {
                  "label": "普列文州",
                  "value": 1208
                },
                {
                  "label": "多布里奇州",
                  "value": 1209
                },
                {
                  "label": "索非亚",
                  "value": 1210
                },
                {
                  "label": "布拉戈耶夫格勒州",
                  "value": 1211
                },
                {
                  "label": "普罗夫迪夫州",
                  "value": 1212
                },
                {
                  "label": "哈斯科沃州",
                  "value": 1213
                },
                {
                  "label": "扬博尔州",
                  "value": 1214
                }
              ]
            },
            {
              "country_code": 128,
              "country_name_ch": "利比里亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Liberia.svg",
              "cityIds": [
                1215
              ],
              "provinces": [
                {
                  "label": "蒙特塞拉多县",
                  "value": 1215
                }
              ]
            },
            {
              "country_code": 129,
              "country_name_ch": "阿曼",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Oman.svg",
              "cityIds": [
                1216,
                1217,
                1218,
                1219,
                1220,
                1221,
                1222,
                1223,
                1224,
                1225
              ],
              "provinces": [
                {
                  "label": "佐法尔省",
                  "value": 1216
                },
                {
                  "label": "中部省",
                  "value": 1217
                },
                {
                  "label": "布赖米省",
                  "value": 1218
                },
                {
                  "label": "东南省",
                  "value": 1219
                },
                {
                  "label": "扎希拉省",
                  "value": 1220
                },
                {
                  "label": "马斯喀特省",
                  "value": 1221
                },
                {
                  "label": "北巴提奈省",
                  "value": 1222
                },
                {
                  "label": "阿曼",
                  "value": 1223
                },
                {
                  "label": "南巴提奈省",
                  "value": 1224
                },
                {
                  "label": "内地省",
                  "value": 1225
                }
              ]
            },
            {
              "country_code": 130,
              "country_name_ch": "危地马拉",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Guatemala.svg",
              "cityIds": [
                1226,
                1227,
                1228,
                1229,
                1230,
                1231,
                1232,
                1233,
                1234,
                1235
              ],
              "provinces": [
                {
                  "label": "韦韦特南戈省",
                  "value": 1226
                },
                {
                  "label": "萨卡特佩克斯省",
                  "value": 1227
                },
                {
                  "label": "克萨尔特南戈省",
                  "value": 1228
                },
                {
                  "label": "危地马拉省",
                  "value": 1229
                },
                {
                  "label": "危地马拉",
                  "value": 1230
                },
                {
                  "label": "贾拉普省",
                  "value": 1231
                },
                {
                  "label": "奇基穆拉省",
                  "value": 1232
                },
                {
                  "label": "基切省",
                  "value": 1233
                },
                {
                  "label": "上韦拉帕斯省",
                  "value": 1234
                },
                {
                  "label": "伊萨瓦尔省",
                  "value": 1235
                }
              ]
            },
            {
              "country_code": 132,
              "country_name_ch": "乌拉圭",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Uruguay.svg",
              "cityIds": [
                1237,
                1238,
                1239,
                1240
              ],
              "provinces": [
                {
                  "label": "卡内洛内斯省",
                  "value": 1237
                },
                {
                  "label": "马尔多纳多省",
                  "value": 1238
                },
                {
                  "label": "蒙得维的亚省",
                  "value": 1239
                },
                {
                  "label": "乌拉圭",
                  "value": 1240
                }
              ]
            },
            {
              "country_code": 133,
              "country_name_ch": "3BB.CO.TH",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "",
              "cityIds": [
                1241
              ],
              "provinces": [
                {
                  "label": "3BB.CO.TH",
                  "value": 1241
                }
              ]
            },
            {
              "country_code": 134,
              "country_name_ch": "埃塞俄比亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Ethiopia.svg",
              "cityIds": [
                1242,
                1243,
                1244
              ],
              "provinces": [
                {
                  "label": "亚的斯亚贝巴",
                  "value": 1242
                },
                {
                  "label": "索马里州",
                  "value": 1243
                },
                {
                  "label": "埃塞俄比亚",
                  "value": 1244
                }
              ]
            },
            {
              "country_code": 135,
              "country_name_ch": "圣皮埃尔和密克隆群岛",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "",
              "cityIds": [
                1245
              ],
              "provinces": [
                {
                  "label": "圣皮埃尔",
                  "value": 1245
                }
              ]
            },
            {
              "country_code": 139,
              "country_name_ch": "黎巴嫩",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Lebanon.svg",
              "cityIds": [
                1261,
                1262,
                1263,
                1264,
                1265,
                1266,
                1267,
                1268,
                1269,
                1270
              ],
              "provinces": [
                {
                  "label": "北黎巴嫩省",
                  "value": 1261
                },
                {
                  "label": "黎巴嫩山省",
                  "value": 1262
                },
                {
                  "label": "凯斯莱－朱拜勒省",
                  "value": 1263
                },
                {
                  "label": "贝鲁特省",
                  "value": 1264
                },
                {
                  "label": "贝卡省",
                  "value": 1265
                },
                {
                  "label": "阿卡省",
                  "value": 1266
                },
                {
                  "label": "南黎巴嫩省",
                  "value": 1267
                },
                {
                  "label": "黎巴嫩",
                  "value": 1268
                },
                {
                  "label": "纳巴泰省",
                  "value": 1269
                },
                {
                  "label": "巴勒贝克－希尔米勒省",
                  "value": 1270
                }
              ]
            },
            {
              "country_code": 140,
              "country_name_ch": "苏里南",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Suriname.svg",
              "cityIds": [
                1271,
                1272
              ],
              "provinces": [
                {
                  "label": "帕拉马里博区",
                  "value": 1271
                },
                {
                  "label": "苏里南",
                  "value": 1272
                }
              ]
            },
            {
              "country_code": 141,
              "country_name_ch": "毛里塔尼亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Mauritania.svg",
              "cityIds": [
                1273,
                1274
              ],
              "provinces": [
                {
                  "label": "毛里塔尼亚",
                  "value": 1273
                },
                {
                  "label": "努瓦克肖特",
                  "value": 1274
                }
              ]
            },
            {
              "country_code": 142,
              "country_name_ch": "M247.COM 骨干网",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "",
              "cityIds": [
                1275
              ],
              "provinces": [
                {
                  "label": "M247.COM 骨干网",
                  "value": 1275
                }
              ]
            },
            {
              "country_code": 144,
              "country_name_ch": "土库曼斯坦",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Turkmenistan.svg",
              "cityIds": [
                1284,
                1285
              ],
              "provinces": [
                {
                  "label": "阿什哈巴德",
                  "value": 1284
                },
                {
                  "label": "列巴普州",
                  "value": 1285
                }
              ]
            },
            {
              "country_code": 145,
              "country_name_ch": "老挝",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Laos.svg",
              "cityIds": [
                1286,
                1287,
                1288,
                1289,
                1290
              ],
              "provinces": [
                {
                  "label": "赛宋奔省",
                  "value": 1286
                },
                {
                  "label": "老挝",
                  "value": 1287
                },
                {
                  "label": "沙湾拿吉省",
                  "value": 1288
                },
                {
                  "label": "万象市",
                  "value": 1289
                },
                {
                  "label": "博胶省",
                  "value": 1290
                }
              ]
            },
            {
              "country_code": 146,
              "country_name_ch": "北马其顿",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Macedonia.svg",
              "cityIds": [
                1291,
                1292,
                1293,
                1294
              ],
              "provinces": [
                {
                  "label": "北马其顿",
                  "value": 1291
                },
                {
                  "label": "斯科普里",
                  "value": 1292
                },
                {
                  "label": "斯特鲁米察市镇",
                  "value": 1293
                },
                {
                  "label": "比托拉市镇",
                  "value": 1294
                }
              ]
            },
            {
              "country_code": 147,
              "country_name_ch": "巴勒斯坦",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Palestine.svg",
              "cityIds": [
                1295,
                1296,
                1297,
                1298,
                1299,
                1300,
                1301
              ],
              "provinces": [
                {
                  "label": "希布伦省",
                  "value": 1295
                },
                {
                  "label": "巴勒斯坦",
                  "value": 1296
                },
                {
                  "label": "纳布卢斯省",
                  "value": 1297
                },
                {
                  "label": "杰宁省",
                  "value": 1298
                },
                {
                  "label": "图勒凯尔姆省",
                  "value": 1299
                },
                {
                  "label": "萨尔费特省",
                  "value": 1300
                },
                {
                  "label": "拉马拉和比雷赫省",
                  "value": 1301
                }
              ]
            },
            {
              "country_code": 150,
              "country_name_ch": "乌克兰",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Ukraine.svg",
              "cityIds": [
                1328,
                1329,
                1330,
                1331,
                1332,
                1333,
                1334,
                1335,
                1336,
                1337,
                1338,
                1339,
                1340,
                1341,
                1342,
                1343,
                1344,
                1345,
                1346,
                1347,
                1348,
                1349,
                1350,
                1351,
                1352,
                1353
              ],
              "provinces": [
                {
                  "label": "哈尔科夫州",
                  "value": 1328
                },
                {
                  "label": "利沃夫州",
                  "value": 1329
                },
                {
                  "label": "波尔塔瓦州",
                  "value": 1330
                },
                {
                  "label": "切尔卡瑟州",
                  "value": 1331
                },
                {
                  "label": "基洛夫格勒州",
                  "value": 1332
                },
                {
                  "label": "罗夫诺州",
                  "value": 1333
                },
                {
                  "label": "外喀尔巴阡州",
                  "value": 1334
                },
                {
                  "label": "赫梅利尼茨基州",
                  "value": 1335
                },
                {
                  "label": "捷尔诺波尔州",
                  "value": 1336
                },
                {
                  "label": "切尔诺夫策州",
                  "value": 1337
                },
                {
                  "label": "日托米尔州",
                  "value": 1338
                },
                {
                  "label": "苏梅州",
                  "value": 1339
                },
                {
                  "label": "卢甘斯克州",
                  "value": 1340
                },
                {
                  "label": "切尔尼戈夫州",
                  "value": 1341
                },
                {
                  "label": "赫尔松州",
                  "value": 1342
                },
                {
                  "label": "第聂伯罗彼得罗夫斯克州",
                  "value": 1343
                },
                {
                  "label": "扎波罗热州",
                  "value": 1344
                },
                {
                  "label": "敖德萨州",
                  "value": 1345
                },
                {
                  "label": "顿涅茨克州",
                  "value": 1346
                },
                {
                  "label": "沃伦州",
                  "value": 1347
                },
                {
                  "label": "文尼察州",
                  "value": 1348
                },
                {
                  "label": "基辅",
                  "value": 1349
                },
                {
                  "label": "尼古拉耶夫州",
                  "value": 1350
                },
                {
                  "label": "乌克兰",
                  "value": 1351
                },
                {
                  "label": "基辅州",
                  "value": 1352
                },
                {
                  "label": "伊万诺－弗兰科夫斯克州",
                  "value": 1353
                }
              ]
            },
            {
              "country_code": 151,
              "country_name_ch": "沙特阿拉伯",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/SaudiArabia.svg",
              "cityIds": [
                1354,
                1355,
                1356,
                1357,
                1358,
                1359,
                1360,
                1361,
                1362,
                1363
              ],
              "provinces": [
                {
                  "label": "吉赞省",
                  "value": 1354
                },
                {
                  "label": "塔布克省",
                  "value": 1355
                },
                {
                  "label": "东部省",
                  "value": 1356
                },
                {
                  "label": "利雅得省",
                  "value": 1357
                },
                {
                  "label": "阿西尔省",
                  "value": 1358
                },
                {
                  "label": "麦加省",
                  "value": 1359
                },
                {
                  "label": "麦地那省",
                  "value": 1360
                },
                {
                  "label": "盖西姆省",
                  "value": 1361
                },
                {
                  "label": "北部边疆省",
                  "value": 1362
                },
                {
                  "label": "沙特阿拉伯",
                  "value": 1363
                }
              ]
            },
            {
              "country_code": 152,
              "country_name_ch": "所罗门群岛",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/SolomonIslands.svg",
              "cityIds": [
                1364
              ],
              "provinces": [
                {
                  "label": "霍尼亚拉",
                  "value": 1364
                }
              ]
            },
            {
              "country_code": 153,
              "country_name_ch": "爱沙尼亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Estonia.svg",
              "cityIds": [
                1365,
                1366,
                1367
              ],
              "provinces": [
                {
                  "label": "瓦尔加县",
                  "value": 1365
                },
                {
                  "label": "爱沙尼亚",
                  "value": 1366
                },
                {
                  "label": "哈尔尤县",
                  "value": 1367
                }
              ]
            },
            {
              "country_code": 154,
              "country_name_ch": "马尔代夫",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Maldives.svg",
              "cityIds": [
                1368
              ],
              "provinces": [
                {
                  "label": "马尔代夫",
                  "value": 1368
                }
              ]
            },
            {
              "country_code": 155,
              "country_name_ch": "塞拉利昂",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/SierraLeone.svg",
              "cityIds": [
                1369
              ],
              "provinces": [
                {
                  "label": "西部地区",
                  "value": 1369
                }
              ]
            },
            {
              "country_code": 159,
              "country_name_ch": "亚美尼亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Armenia.svg",
              "cityIds": [
                1432,
                1433,
                1434,
                1435,
                1436
              ],
              "provinces": [
                {
                  "label": "阿拉拉特省",
                  "value": 1432
                },
                {
                  "label": "亚美尼亚",
                  "value": 1433
                },
                {
                  "label": "格加尔库尼克省",
                  "value": 1434
                },
                {
                  "label": "埃里温",
                  "value": 1435
                },
                {
                  "label": "阿拉加措特恩省",
                  "value": 1436
                }
              ]
            },
            {
              "country_code": 160,
              "country_name_ch": "比利时",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Belgium.svg",
              "cityIds": [
                1437,
                1438,
                1439,
                1440
              ],
              "provinces": [
                {
                  "label": "布鲁塞尔－首都大区",
                  "value": 1437
                },
                {
                  "label": "瓦隆大区",
                  "value": 1438
                },
                {
                  "label": "比利时",
                  "value": 1439
                },
                {
                  "label": "弗拉芒大区",
                  "value": 1440
                }
              ]
            },
            {
              "country_code": 161,
              "country_name_ch": "波斯尼亚和黑塞哥维那",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/BosniaAndHerzegovina.svg",
              "cityIds": [
                1441,
                1442,
                1443,
                1444
              ],
              "provinces": [
                {
                  "label": "波斯尼亚和黑塞哥维那联邦",
                  "value": 1441
                },
                {
                  "label": "塞族共和国",
                  "value": 1442
                },
                {
                  "label": "布尔奇科特区",
                  "value": 1443
                },
                {
                  "label": "波斯尼亚和黑塞哥维那",
                  "value": 1444
                }
              ]
            },
            {
              "country_code": 162,
              "country_name_ch": "安提瓜和巴布达",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/AntiguaAndBarbuda.svg",
              "cityIds": [
                1445,
                1446
              ],
              "provinces": [
                {
                  "label": "圣约翰区",
                  "value": 1445
                },
                {
                  "label": "安提瓜和巴布达",
                  "value": 1446
                }
              ]
            },
            {
              "country_code": 163,
              "country_name_ch": "马达加斯加",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Madagascar.svg",
              "cityIds": [
                1447
              ],
              "provinces": [
                {
                  "label": "阿那拉芒加区",
                  "value": 1447
                }
              ]
            },
            {
              "country_code": 166,
              "country_name_ch": "哥斯达黎加",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/CostaRica.svg",
              "cityIds": [
                1510,
                1511,
                1512,
                1513,
                1514,
                1515,
                1516,
                1517
              ],
              "provinces": [
                {
                  "label": "利蒙省",
                  "value": 1510
                },
                {
                  "label": "卡塔戈省",
                  "value": 1511
                },
                {
                  "label": "埃雷迪亚省",
                  "value": 1512
                },
                {
                  "label": "圣何塞省",
                  "value": 1513
                },
                {
                  "label": "蓬塔雷纳斯省",
                  "value": 1514
                },
                {
                  "label": "哥斯达黎加",
                  "value": 1515
                },
                {
                  "label": "阿拉胡埃拉省",
                  "value": 1516
                },
                {
                  "label": "瓜纳卡斯特省",
                  "value": 1517
                }
              ]
            },
            {
              "country_code": 167,
              "country_name_ch": "科索沃",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Kosovo.svg",
              "cityIds": [
                1518,
                1519,
                1520,
                1521
              ],
              "provinces": [
                {
                  "label": "科索沃",
                  "value": 1518
                },
                {
                  "label": "格尼拉内区",
                  "value": 1519
                },
                {
                  "label": "普里什蒂纳区",
                  "value": 1520
                },
                {
                  "label": "普里兹伦区",
                  "value": 1521
                }
              ]
            }
          ],
          componentList: [
            {
              name: 'NetworkLatencyService',
              type: 'view',
              props: {
                requestParams: {
                  AggType: 'country',
                  Platform: 0,
                  _province: ['全部'],
                  _city: ['全部'],
                  cityIds: [],
                  app_version: ['0.9.1_14800.294'],
                  _scene: [],
                  RequestID: 'performance_android',
                  userName: 'judymao',
                  CountrySplit: 1,
                  projectId: 5120,
                  apmEnv: 'sgp',
                  projVersionIds: [1010323],
                  timezoneOffset: 0,
                  convertTodayToUtc: false,
                  todayLookbackHours: 11,
                  excludeVpn: false,
                  excludeCross: false,
                  netLables: [],
                },
                formatBeforeRequest: "function(data) {\n  data = data || {};\n  var filterValue = data.filterVal || data.filterValue || {};\n  var countryRegionOptions = data.countryRegionOptions || [];\n  var gameCode = data.gameCode;\n  var requestParams = data.requestParams || {};\n  var rangeTime = filterValue.rangeTime || filterValue.rangeDaily || [];\n  var countryValue = filterValue.country;\n  var isAllCountry = countryValue === undefined || countryValue === null || Number(countryValue) === -1;\n  var countryRegionOption;\n  for (var i = 0; i < countryRegionOptions.length; i++) {\n    if (Number(countryRegionOptions[i].country_code) === Number(countryValue)) {\n      countryRegionOption = countryRegionOptions[i];\n      break;\n    }\n  }\n  var regionName = String((countryRegionOption && (countryRegionOption.country_name_ch || countryRegionOption.country_name_en)) || '');\n  var isRegion = regionName.indexOf('地区') !== -1;\n  var countryName = isAllCountry\n    ? '全部'\n    : ((countryRegionOption && (countryRegionOption.country_name_en || countryRegionOption.country_name_ch)) || '');\n  var cityValue = (isAllCountry || isRegion)\n    ? []\n    : ((countryRegionOption && countryRegionOption.request_city) || []);\n  var normalizeDateStr = function(value) {\n    if (value === undefined || value === null || value === '') return '';\n    if (value && typeof value.format === 'function') return value.format('YYYY-MM-DD');\n    var str = String(value).trim();\n    return /^\\d{4}-\\d{2}-\\d{2}/.test(str) ? str.slice(0, 10) : '';\n  };\n  var startDate = normalizeDateStr(rangeTime[0]);\n  var endDate = normalizeDateStr(rangeTime[1]);\n  var timezoneOffset = Number(requestParams.timezoneOffset);\n  if (!isFinite(timezoneOffset)) timezoneOffset = 0;\n  var convertTodayToUtc = requestParams.convertTodayToUtc === true;\n  var lookbackHours = Number(requestParams.todayLookbackHours);\n  if (!isFinite(lookbackHours) || lookbackHours <= 0) lookbackHours = 11;\n  var pad = function(n) { return n < 10 ? '0' + n : '' + n; };\n  var formatUtc = function(date) {\n    return date.getUTCFullYear() + '-' + pad(date.getUTCMonth() + 1) + '-' + pad(date.getUTCDate()) + ' ' + pad(date.getUTCHours()) + ':' + pad(date.getUTCMinutes()) + ':' + pad(date.getUTCSeconds());\n  };\n  var todayUtcMs = Date.now() + timezoneOffset * 3600000;\n  var todayDate = new Date(todayUtcMs);\n  var today = todayDate.getUTCFullYear() + '-' + pad(todayDate.getUTCMonth() + 1) + '-' + pad(todayDate.getUTCDate());\n  var isToday = startDate && startDate === endDate && startDate === today;\n  var start;\n  var end;\n  if (convertTodayToUtc && isToday) {\n    var endDateTime = new Date();\n    endDateTime.setUTCMinutes(0, 0, 0);\n    endDateTime = new Date(endDateTime.getTime() - 3600000);\n    var startDateTime = new Date(endDateTime.getTime() - lookbackHours * 3600000);\n    start = formatUtc(startDateTime);\n    end = formatUtc(endDateTime);\n  } else {\n    start = startDate ? startDate + ' 00:00:00' : '';\n    end = endDate ? endDate + ' 23:59:59' : '';\n  }\n  var result = Object.assign({}, requestParams, {\n    game_code: gameCode,\n    start: start,\n    end: end,\n    timezoneOffset: timezoneOffset,\n    _country: [countryName],\n    _city: cityValue,\n    countryId: isAllCountry ? -1 : Number((countryRegionOption && countryRegionOption.country_code) || countryValue || -1),\n    cityIds: [],\n    AggType: (isAllCountry || isRegion) ? (requestParams.AggType || 'country') : 'province'\n  });\n  if (isAllCountry) {\n    result.IsCityAll = true;\n    result._province = [];\n  } else {\n    result._province = requestParams._province || ['全部'];\n  }\n  delete result.convertTodayToUtc;\n  delete result.todayLookbackHours;\n  return result;\n}",
                formatData: "function(response, filterVal) {\n  var payload = (response && response.data && response.data.ret) || (response && response.ret) || (response && response.data) || response || {};\n  var normalizeNetworkType = function(item) {\n    var next = Object.assign({}, item);\n    next.NetworkType = Number(item && item.NetworkType) === 6 ? 5 : (item && item.NetworkType);\n    return next;\n  };\n  var hasZoneMetric = function(item) {\n    return Number(item && item.MergeCount) > 0 || Number(item && item.Value) > 0 || Number(item && item.CountRatio) > 0;\n  };\n  var flattenHoursToTable = function(hoursData, times) {\n    var orderedTimes = (times && times.length) ? times.slice().reverse() : Object.keys(hoursData || {}).reverse();\n    var rows = [];\n    for (var i = 0; i < orderedTimes.length; i++) {\n      var items = hoursData && hoursData[orderedTimes[i]];\n      if (Array.isArray(items) && items.length) rows = rows.concat(items);\n    }\n    return rows;\n  };\n  var trendKeys = [\n    { networkType: 1, valueKey: 'dataWifi', countKey: 'battleDataWifi' },\n    { networkType: 2, valueKey: 'data2g', countKey: 'battleData2g' },\n    { networkType: 3, valueKey: 'data3g', countKey: 'battleData3g' },\n    { networkType: 4, valueKey: 'data4g', countKey: 'battleData4g' },\n    { networkType: 5, valueKey: 'data5g', countKey: 'battleData5g' }\n  ];\n  var buildHoursFromTrend = function(source) {\n    var trend = (source && source.netDelayTrend) || {};\n    var netDataTimes = (Array.isArray(trend.xData) && trend.xData.length ? trend.xData : source && source.netDelayTime) || [];\n    var netHoursData = {};\n    for (var i = 0; i < netDataTimes.length; i++) {\n      var time = netDataTimes[i];\n      var row = [];\n      for (var j = 0; j < trendKeys.length; j++) {\n        row.push({\n          CalendarTime: time,\n          NetworkType: trendKeys[j].networkType,\n          Value: trend[trendKeys[j].valueKey] && trend[trendKeys[j].valueKey][i],\n          MergeCount: trend[trendKeys[j].countKey] && trend[trendKeys[j].countKey][i]\n        });\n      }\n      row.push({\n        CalendarTime: time,\n        NetworkType: 0,\n        Value: trend.dataCommon && trend.dataCommon[i],\n        MergeCount: trend.count && trend.count[i]\n      });\n      netHoursData[time] = row;\n    }\n    return { netDataTimes: netDataTimes, netHoursData: netHoursData };\n  };\n  var flattenZoneAgg = function(zoneRows) {\n    if (Array.isArray(zoneRows)) return zoneRows;\n    if (!zoneRows || typeof zoneRows !== 'object') return [];\n    var rows = [];\n    var keys = Object.keys(zoneRows);\n    for (var z = 0; z < keys.length; z++) {\n      var key = keys[z];\n      var list = zoneRows[key];\n      if (!Array.isArray(list)) continue;\n      for (var r = 0; r < list.length; r++) {\n        var item = Object.assign({}, list[r] || {});\n        if (!item.CountryName) item.CountryName = key;\n        rows.push(item);\n      }\n    }\n    return rows;\n  };\n  var unwrapCountryValue = function(value) {\n    if (value === undefined || value === null || value === '') return value;\n    if (Array.isArray(value)) return unwrapCountryValue(value[0]);\n    if (value && typeof value === 'object') {\n      if (value.country_code !== undefined && value.country_code !== null) return value.country_code;\n      if (value.value !== undefined && value.value !== null) return value.value;\n    }\n    return value;\n  };\n  var countryValue = unwrapCountryValue(filterVal && filterVal.country);\n  var isAllCountry = countryValue === undefined || countryValue === null || countryValue === '' || Number(countryValue) === -1;\n  var pickFallbackZoneRows = function(zoneRows, ispRows, networkAgg, networkType) {\n    var flattened = flattenZoneAgg(zoneRows);\n    if (flattened.length) return flattened;\n    if (!isAllCountry) return [];\n    var ispTotals = [];\n    for (var i = 0; i < (ispRows || []).length; i++) {\n      var ispItem = ispRows[i];\n      if (!String((ispItem && ispItem.IspName) || '').trim() && hasZoneMetric(ispItem)) ispTotals.push(ispItem);\n    }\n    if (ispTotals.length) return ispTotals;\n    var normalized = [];\n    for (var n = 0; n < (networkAgg || []).length; n++) normalized.push(normalizeNetworkType(networkAgg[n]));\n    if (networkType === 0) {\n      var allType = [];\n      for (var a = 0; a < normalized.length; a++) {\n        if (Number(normalized[a].NetworkType) === 0 && hasZoneMetric(normalized[a])) allType.push(normalized[a]);\n      }\n      if (allType.length) return allType;\n      var ranked = normalized.filter(hasZoneMetric).sort(function(a, b) { return (b.CountRatio || 0) - (a.CountRatio || 0); });\n      return ranked[0] ? [ranked[0]] : [];\n    }\n    return normalized.filter(function(item) {\n      return Number(item.NetworkType) === networkType && hasZoneMetric(item);\n    });\n  };\n  var isNewFormat = Boolean((payload && payload.netHoursData) || (payload && payload.networkAgg) || (payload && payload.zoneAggAll));\n  var hours;\n  if (isNewFormat) {\n    var netHoursData = {};\n    var hourKeys = Object.keys((payload && payload.netHoursData) || {});\n    for (var h = 0; h < hourKeys.length; h++) {\n      netHoursData[hourKeys[h]] = ((payload.netHoursData[hourKeys[h]]) || []).map(normalizeNetworkType);\n    }\n    hours = {\n      netDataTimes: (Array.isArray(payload.netDataTimes) && payload.netDataTimes.length ? payload.netDataTimes : hourKeys) || [],\n      netHoursData: netHoursData\n    };\n  } else {\n    hours = buildHoursFromTrend(payload);\n  }\n  var networkAgg = ((payload && payload.networkAgg) || (payload && payload.netDistribution) || []).map(normalizeNetworkType);\n  return Object.assign({}, payload, {\n    netDataTimes: hours.netDataTimes,\n    netHoursData: hours.netHoursData,\n    netDelayTable: (payload && payload.netDelayTable) || flattenHoursToTable(hours.netHoursData, hours.netDataTimes),\n    networkAgg: networkAgg,\n    zoneAggAll: pickFallbackZoneRows((payload && payload.zoneAggAll) || (payload && payload.zoneAll) || [], payload && payload.ispAggAll, networkAgg, 0),\n    zoneAggWifi: pickFallbackZoneRows((payload && payload.zoneAggWifi) || (payload && payload.zoneWifi) || [], payload && payload.ispAggWifi, networkAgg, 1),\n    zoneAgg5G: pickFallbackZoneRows((payload && payload.zoneAgg5G) || (payload && payload.zone5G) || [], payload && payload.ispAgg5G, networkAgg, 5),\n    zoneAgg4G: pickFallbackZoneRows((payload && payload.zoneAgg4G) || (payload && payload.zone4G) || [], payload && payload.ispAgg4G, networkAgg, 4),\n    zoneAgg3G: pickFallbackZoneRows((payload && payload.zoneAgg3G) || (payload && payload.zone3G) || [], payload && payload.ispAgg3G, networkAgg, 3),\n    zoneAgg2G: pickFallbackZoneRows((payload && payload.zoneAgg2G) || (payload && payload.zone2G) || [], payload && payload.ispAgg2G, networkAgg, 2)\n  });\n}",
              },
              children: [
                {
                  name: 'NetworkLatencyTrend',
                  type: 'view',
                  className: 'dbd-network-latency-trend',
                  props: {
                    platform: 'android',
                    config: {
                      titleCn: '网络延迟趋势',
                      titleEn: 'Network Latency Trend',
                      height: 280,
                      tableHeight: 350,
                      pageSize: 5,
                      unselectedLegendKeys: ['2g_latency', '3g_latency'],
                      yAxis: [
                        {
                          nameCn: '网络延迟(ms)',
                          nameEn: 'Network Latency(ms)',
                          formatRule: 'oneDecimal',
                        },
                      ],
                      componentMetrics: [
                        {
                          metricKey: 'wifi_latency',
                          nameCn: 'WiFi网络延迟',
                          nameEn: 'WiFi Latency',
                          formatRule: 'twoDecimal',
                          yAxisIndex: 0,
                          color: '#5B6CFF',
                        },
                        {
                          metricKey: '2g_latency',
                          nameCn: '2G网络延迟',
                          nameEn: '2G Latency',
                          formatRule: 'twoDecimal',
                          yAxisIndex: 0,
                          color: '#8C9AAF',
                        },
                        {
                          metricKey: '3g_latency',
                          nameCn: '3G网络延迟',
                          nameEn: '3G Latency',
                          formatRule: 'twoDecimal',
                          yAxisIndex: 0,
                          color: '#A78BFA',
                        },
                        {
                          metricKey: '4g_latency',
                          nameCn: '4G网络延迟',
                          nameEn: '4G Latency',
                          formatRule: 'twoDecimal',
                          yAxisIndex: 0,
                          color: '#FF7961',
                        },
                        {
                          metricKey: '5g_latency',
                          nameCn: '5G网络延迟',
                          nameEn: '5G Latency',
                          formatRule: 'twoDecimal',
                          yAxisIndex: 0,
                          color: '#00B8BF',
                        },
                      ],
                    },
                  },
                },
                {
                  name: 'NetworkLatencyDistribution',
                  type: 'view',
                  props: {
                    platform: 'android',
                    config: {
                      titleCn: '网络延迟分布',
                      titleEn: 'Network Latency Distribution',
                      titleInfoCn: '数据为所选时间段内累计数据的分布',
                      titleInfoEn:
                        'The data shows the cumulative distribution within the selected time range.',
                      pieMetricKey: 'share',
                      chartPercentDecimal: 2,
                      chartHeight: 290,
                      tableHeight: 310,
                      mapRanges: [0, 99, 301],
                      tableGroup: {
                        nameCn: '网络状态分布占比',
                        nameEn: 'Network Status Distribution',
                        align: 'center',
                        metricKeys: ['p0', 'p30', 'p60'],
                      },
                      colors: [
                        '#5B6CFF',
                        '#F0A33A',
                        '#B6BDCC',
                        '#8C9AAF',
                        '#F1749C',
                      ],
                      componentMetrics: [
                        {
                          metricKey: 'network',
                          nameCn: '网络类型',
                          nameEn: 'Network Type',
                          width: 110,
                          align: 'left',
                          lock: true,
                        },
                        {
                          metricKey: 'share',
                          nameCn: '占比(%)',
                          nameEn: 'Share(%)',
                          width: 130,
                          formatRule: 'percent2Decimal',
                          downLoadFormat: '0.00%',
                          showProgressBar: true,
                        },
                        {
                          metricKey: 'latency',
                          nameCn: '平均网络延时(ms)',
                          nameEn: 'Average Latency(ms)',
                          width: 160,
                          formatRule: 'twoDecimal',
                          downLoadFormat: '0.00',
                        },
                        {
                          metricKey: 'p0',
                          nameCn: '0-99(ms) 占比(%)',
                          nameEn: '0-99(ms) Share(%)',
                          width: 155,
                          formatRule: 'percent2Decimal',
                          downLoadFormat: '0.00%',
                          showProgressBar: true,
                        },
                        {
                          metricKey: 'p30',
                          nameCn: '99-301(ms) 占比(%)',
                          nameEn: '99-301(ms) Share(%)',
                          width: 165,
                          formatRule: 'percent2Decimal',
                          downLoadFormat: '0.00%',
                          showProgressBar: true,
                        },
                        {
                          metricKey: 'p60',
                          nameCn: '>301(ms) 占比(%)',
                          nameEn: '>301(ms) Share(%)',
                          width: 175,
                          formatRule: 'percent2Decimal',
                          downLoadFormat: '0.00%',
                          showProgressBar: true,
                        },
                      ],
                    },
                  },
                },
                {
                  name: 'CountryLatencyDistribution',
                  type: 'view',
                  props: {
                    platform: 'android',
                    config: {
                      titleCn: '国家/地区网络延迟分布',
                      titleEn: 'Country/Region Network Latency Distribution',
                      titleInfoCn:
                        '数据为所选时间段内累计数据的分布，国家/地区信息来自IP解析。',
                      titleInfoEn:
                        'The data shows the cumulative distribution within the selected time range. Country/region information is parsed from IP.',
                      mapHeight: 350,
                      tableHeight: 350,
                      tableGroup: {
                        nameCn: '网络延迟分段占比',
                        nameEn: 'Network Latency Distribution',
                        align: 'center',
                        metricKeys: ['p0', 'p30', 'p60'],
                      },
                      networkOptions: [
                        { text: '全部', value: 'all' },
                        { text: 'WIFI', value: 'wifi' },
                        { text: '5G', value: '5g' },
                        { text: '4G', value: '4g' },
                        { text: '3G', value: '3g' },
                        { text: '2G', value: '2g' },
                      ],
                      mapMetric: {
                        metricKey: 'latency',
                        nameCn: '平均网络延迟',
                        nameEn: 'Average Network Latency',
                        unitCn: 'ms',
                        unitEn: 'ms',
                        formatRule: 'twoDecimal',
                      },
                      mapColors: ['#26C477', '#F3B800', '#F26322'],
                      mapLegendMinMs: 0,
                      mapLegendMidMs: 99,
                      mapLegendMaxMs: 301,
                      mapLegendUnit: 'ms',
                      mapRanges: [0, 99, 301],
                      mapLegend: [
                        { label: '301+', colorIndex: 2 },
                        { label: '99-301', colorIndex: 1 },
                        { label: '0-99', colorIndex: 0 },
                      ],
                      componentMetrics: [
                        {
                          metricKey: 'country',
                          nameCn: '国家/地区',
                          nameEn: 'Country/Region',
                          width: 150,
                          align: 'left',
                          lock: true,
                          showCountryFlag: false,
                        },
                        {
                          metricKey: 'network',
                          nameCn: '网络类型',
                          nameEn: 'Network Type',
                          width: 100,
                          align: 'left',
                        },
                        {
                          metricKey: 'share',
                          nameCn: '占比(%)',
                          nameEn: 'Share(%)',
                          width: 130,
                          formatRule: 'percent2Decimal',
                          downLoadFormat: '0.00%',
                          showProgressBar: true,
                        },
                        {
                          metricKey: 'latency',
                          nameCn: '平均网络延时(ms)',
                          nameEn: 'Average Latency(ms)',
                          width: 160,
                          formatRule: 'twoDecimal',
                          downLoadFormat: '0.00',
                        },
                        {
                          metricKey: 'p0',
                          nameCn: '0-99(ms) 占比(%)',
                          nameEn: '0-99(ms) Share(%)',
                          width: 155,
                          formatRule: 'percent2Decimal',
                          downLoadFormat: '0.00%',
                          showProgressBar: true,
                        },
                        {
                          metricKey: 'p30',
                          nameCn: '99-301(ms) 占比(%)',
                          nameEn: '99-301(ms) Share(%)',
                          width: 165,
                          formatRule: 'percent2Decimal',
                          downLoadFormat: '0.00%',
                          showProgressBar: true,
                        },
                        {
                          metricKey: 'p60',
                          nameCn: '>301(ms) 占比(%)',
                          nameEn: '>301(ms) Share(%)',
                          width: 175,
                          formatRule: 'percent2Decimal',
                          downLoadFormat: '0.00%',
                          showProgressBar: true,
                        },
                      ],
                    },
                  },
                },

              ],
            },
          ],
        },
      ],
    },
    {
      id: 'ios',
      tabName: 'IOS',
      tabNameCN: 'IOS',
      isHaveNotification: false,
      path: '/performance/overall',
      logConfig: {
        pageId: '210202',
        pageName: 'performanceOverallIos',
        extInfo: 'performanceOverallIos',
        pagePath: '/performance/overall',
      },
      children: [
        {
          name: 'PerformanceOverviewService',
          type: 'view',
          props: {
            platform: 'ios',
            requestParams: {
              platform: 1,
              version: '1.0.0.0.409',
              projectId: 5120,
              projVersionIds: [1545314],
              dateRangeDays: 14,
              userName: 'judymao',
              timezoneOffset: 0,
            },
            formatBeforeRequest: "function(data) {\n  data = data || {};\n  var gameCode = data.gameCode;\n  var platform = data.platform;\n  var requestParams = data.requestParams || {};\n  var tz;\n  if (typeof data.timeZone === 'number' && isFinite(data.timeZone)) {\n    tz = data.timeZone;\n  } else {\n    tz = Number(requestParams.timezoneOffset);\n    if (!isFinite(tz)) {\n      var matched = String(data.timeZone || '').match(/([+-]?\\d+)/);\n      tz = matched ? Number(matched[1]) : 0;\n    }\n  }\n  var days = Number(requestParams.dateRangeDays);\n  var dateRangeDays = isFinite(days) && days > 0 ? days : 14;\n  var pad = function(n) { return n < 10 ? '0' + n : '' + n; };\n  var formatDateTime = function(date) {\n    return date.getUTCFullYear() + '-' + pad(date.getUTCMonth() + 1) + '-' + pad(date.getUTCDate()) + ' ' + pad(date.getUTCHours()) + ':' + pad(date.getUTCMinutes()) + ':' + pad(date.getUTCSeconds());\n  };\n  var shifted = new Date(Date.now() + tz * 3600000);\n  shifted.setUTCMinutes(0, 0, 0);\n  var startTime = new Date(shifted.getTime() - dateRangeDays * 86400000);\n  var resolvedPlatform = typeof requestParams.platform === 'number'\n    ? requestParams.platform\n    : (typeof platform === 'number' ? platform : ({ android: 0, ios: 1, windows: 5 }[String(platform || '').toLowerCase()] || 0));\n  var version = requestParams.version\n    ? String(requestParams.version)\n    : (Array.isArray(requestParams.app_version) && requestParams.app_version[0] ? String(requestParams.app_version[0]) : '');\n  return Object.assign({}, requestParams, {\n    game_code: gameCode,\n    platform: resolvedPlatform,\n    version: version,\n    end_time: formatDateTime(shifted),\n    start_time: formatDateTime(startTime)\n  });\n}",
            formatData: "function(response) {\n  var payload = (response && response.data && response.data.ret) || (response && response.data) || (response && response.ret) || response || {};\n  return {\n    last24h: payload.last24h || {},\n    lastWeek: payload.lastWeek || {},\n    msg: payload.msg,\n    requestid: payload.requestid,\n    endTime: (response && response.req && response.req.end_time) || payload.end_time || ''\n  };\n}",
          },
          children: [
            {
              name: 'PerformanceOverview',
              type: 'view',
              props: {
                platform: 'ios',
                config: {
                  titleEn: 'Performance Overview',
                  titleCn: '性能总览',
                  updateTimeLabelCn: '数据更新处理时间：',
                  dayRateLabelCn: '日环比',
                  weekRateLabelCn: '上周同期',
                  wowRateLabelCn: '周环比',
                  showRadar: false,
                  radarHeight: 270,
                  periodOptions: [
                    { text: '近24小时', value: 'day' },
                    { text: '近一周', value: 'week' },
                  ],
                  componentMetrics: [
                    {
                      metricKey: 'avg_fps',
                      nameCn: 'FPS均值',
                      nameEn: 'Average FPS',
                      unitCn: '帧/秒',
                      unitEn: 'FPS',
                      formatRule: 'twoDecimal',
                      rateFormatRule: 'percent2Decimal',
                      betterDirection: 'up',
                    },
                    {
                      metricKey: 'fps_jitter',
                      nameCn: 'FPS抖动',
                      nameEn: 'FPS Jitter',
                      unitCn: '次/小时',
                      unitEn: 'times/hour',
                      formatRule: 'twoDecimal',
                      rateFormatRule: 'percent2Decimal',
                      betterDirection: 'down',
                    },
                    {
                      metricKey: 'fps_stutter',
                      nameCn: 'FPS卡顿',
                      nameEn: 'FPS Stutter',
                      unitCn: '次/小时',
                      unitEn: 'times/hour',
                      formatRule: 'twoDecimal',
                      rateFormatRule: 'percent2Decimal',
                      betterDirection: 'down',
                    },
                    {
                      metricKey: 'jank',
                      nameCn: 'Jank卡顿',
                      nameEn: 'Jank',
                      unitCn: '次/10分钟',
                      unitEn: 'times/10min',
                      formatRule: 'twoDecimal',
                      rateFormatRule: 'percent2Decimal',
                      betterDirection: 'down',
                    },
                    {
                      metricKey: 'big_jank',
                      nameCn: 'BigJank卡顿',
                      nameEn: 'Big Jank',
                      unitCn: '次/10分钟',
                      unitEn: 'times/10min',
                      formatRule: 'twoDecimal',
                      rateFormatRule: 'percent2Decimal',
                      betterDirection: 'down',
                    },
                    {
                      metricKey: 'pss_peak',
                      nameCn: 'PSS内存峰值均值',
                      nameEn: 'Average PSS Peak',
                      unitCn: 'MB',
                      unitEn: 'MB',
                      formatRule: 'thousands2Decimal',
                      rateFormatRule: 'percent2Decimal',
                      betterDirection: 'down',
                    },
                  ],
                  matchMetric: {
                    metricKey: 'matches',
                    nameCn: '对局数',
                    nameEn: 'Matches',
                    unitCn: '',
                    unitEn: '',
                    formatRule: 'thousandsInit',
                  },
                },
              },
            },
          ],
        },
      ],
      filters: [
        {
          name: 'PerformanceFilter',
          type: 'view',
          isOpenSticky: true,
          isHaveFilterSave: false,
          platform: 'ios',
          filterPath: '/performance/overall',
          countryRegionOptions: [
            {
              "country_code": -1,
              "country_name_ch": "全部",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "",
              "cityIds": [],
              "provinces": []
            },
            {
              "country_code": 77,
              "country_name_ch": "菲律宾",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Philippines.svg",
              "cityIds": [
                785,
                786,
                787,
                788,
                789,
                790,
                791,
                792,
                793,
                794,
                795,
                796,
                797,
                798,
                799,
                800,
                801,
                802,
                803,
                804,
                805,
                806
              ],
              "provinces": [
                {
                  "label": "马尼拉都会区",
                  "value": 785
                },
                {
                  "label": "吕宋岛",
                  "value": 786
                },
                {
                  "label": "棉兰老岛",
                  "value": 787
                },
                {
                  "label": "中央吕宋大区",
                  "value": 788
                },
                {
                  "label": "达沃大区",
                  "value": 789
                },
                {
                  "label": "北棉兰老大区",
                  "value": 790
                },
                {
                  "label": "卡加延河谷大区",
                  "value": 791
                },
                {
                  "label": "南哥苏库萨将大区",
                  "value": 792
                },
                {
                  "label": "卡拉巴松大区",
                  "value": 793
                },
                {
                  "label": "中米沙鄢大区",
                  "value": 794
                },
                {
                  "label": "菲律宾",
                  "value": 795
                },
                {
                  "label": "米沙鄢群岛",
                  "value": 796
                },
                {
                  "label": "内格罗斯岛大区",
                  "value": 797
                },
                {
                  "label": "民马罗巴大区",
                  "value": 798
                },
                {
                  "label": "东米沙鄢大区",
                  "value": 799
                },
                {
                  "label": "卡拉加大区",
                  "value": 800
                },
                {
                  "label": "科迪勒拉大区",
                  "value": 801
                },
                {
                  "label": "三宝颜半岛区",
                  "value": 802
                },
                {
                  "label": "伊罗戈大区",
                  "value": 803
                },
                {
                  "label": "比科尔大区",
                  "value": 804
                },
                {
                  "label": "西米沙鄢大区",
                  "value": 805
                },
                {
                  "label": "棉兰老穆斯林自治区",
                  "value": 806
                }
              ]
            },
            {
              "country_code": 1,
              "country_name_ch": "中国",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/China.svg",
              "cityIds": [
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23,
                24
              ],
              "provinces": [
                {
                  "label": "陕西",
                  "value": 1
                },
                {
                  "label": "北京",
                  "value": 2
                },
                {
                  "label": "辽宁",
                  "value": 3
                },
                {
                  "label": "湖南",
                  "value": 4
                },
                {
                  "label": "重庆",
                  "value": 5
                },
                {
                  "label": "安徽",
                  "value": 6
                },
                {
                  "label": "江苏",
                  "value": 7
                },
                {
                  "label": "浙江",
                  "value": 8
                },
                {
                  "label": "中国",
                  "value": 9
                },
                {
                  "label": "内蒙古",
                  "value": 10
                },
                {
                  "label": "新疆",
                  "value": 11
                },
                {
                  "label": "澳门",
                  "value": 12
                },
                {
                  "label": "河南",
                  "value": 13
                },
                {
                  "label": "香港",
                  "value": 14
                },
                {
                  "label": "上海",
                  "value": 15
                },
                {
                  "label": "台湾",
                  "value": 16
                },
                {
                  "label": "四川",
                  "value": 17
                },
                {
                  "label": "广西",
                  "value": 18
                },
                {
                  "label": "福建",
                  "value": 19
                },
                {
                  "label": "海南",
                  "value": 20
                },
                {
                  "label": "广东",
                  "value": 21
                },
                {
                  "label": "云南",
                  "value": 22
                },
                {
                  "label": "山东",
                  "value": 23
                },
                {
                  "label": "湖北",
                  "value": 24
                }
              ]
            },
            {
              "country_code": 109,
              "country_name_ch": "印度尼西亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Indonesia.svg",
              "cityIds": [
                1033,
                1034,
                1035,
                1036,
                1037,
                1038,
                1039,
                1040,
                1041,
                1042,
                1043,
                1044,
                1045,
                1046,
                1047,
                1048,
                1049,
                1050,
                1051,
                1052,
                1053,
                1054,
                1055,
                1056,
                1057,
                1058,
                1059,
                1060,
                1061,
                1062,
                1063,
                1064,
                1065,
                1066,
                1067,
                1068,
                1069,
                1070,
                1071,
                1072,
                1073,
                1074,
                1075
              ],
              "provinces": [
                {
                  "label": "苏拉威西岛",
                  "value": 1033
                },
                {
                  "label": "南苏拉威西省",
                  "value": 1034
                },
                {
                  "label": "明古鲁省",
                  "value": 1035
                },
                {
                  "label": "小巽他群岛",
                  "value": 1036
                },
                {
                  "label": "苏门答腊岛",
                  "value": 1037
                },
                {
                  "label": "哥伦打洛省",
                  "value": 1038
                },
                {
                  "label": "印度尼西亚",
                  "value": 1039
                },
                {
                  "label": "东爪哇省",
                  "value": 1040
                },
                {
                  "label": "楠榜省",
                  "value": 1041
                },
                {
                  "label": "东南苏拉威西省",
                  "value": 1042
                },
                {
                  "label": "邦加－勿里洞省",
                  "value": 1043
                },
                {
                  "label": "爪哇岛",
                  "value": 1044
                },
                {
                  "label": "亚齐特区",
                  "value": 1045
                },
                {
                  "label": "中加里曼丹省",
                  "value": 1046
                },
                {
                  "label": "巴布亚省",
                  "value": 1047
                },
                {
                  "label": "中巴布亚省",
                  "value": 1048
                },
                {
                  "label": "西苏拉威西省",
                  "value": 1049
                },
                {
                  "label": "西努沙登加拉省",
                  "value": 1050
                },
                {
                  "label": "日惹特区",
                  "value": 1051
                },
                {
                  "label": "西巴布亚岛",
                  "value": 1052
                },
                {
                  "label": "西巴布亚省",
                  "value": 1053
                },
                {
                  "label": "中爪哇省",
                  "value": 1054
                },
                {
                  "label": "西苏门答腊省",
                  "value": 1055
                },
                {
                  "label": "南苏门答腊省",
                  "value": 1056
                },
                {
                  "label": "东加里曼丹省",
                  "value": 1057
                },
                {
                  "label": "巴厘省",
                  "value": 1058
                },
                {
                  "label": "万丹省",
                  "value": 1059
                },
                {
                  "label": "北马鲁古省",
                  "value": 1060
                },
                {
                  "label": "雅加达",
                  "value": 1061
                },
                {
                  "label": "加里曼丹岛",
                  "value": 1062
                },
                {
                  "label": "廖内群岛省",
                  "value": 1063
                },
                {
                  "label": "中苏拉威西省",
                  "value": 1064
                },
                {
                  "label": "西加里曼丹省",
                  "value": 1065
                },
                {
                  "label": "马鲁古省",
                  "value": 1066
                },
                {
                  "label": "西爪哇省",
                  "value": 1067
                },
                {
                  "label": "南加里曼丹省",
                  "value": 1068
                },
                {
                  "label": "占碑省",
                  "value": 1069
                },
                {
                  "label": "北加里曼丹省",
                  "value": 1070
                },
                {
                  "label": "北苏拉威西省",
                  "value": 1071
                },
                {
                  "label": "东努沙登加拉省",
                  "value": 1072
                },
                {
                  "label": "北苏门答腊省",
                  "value": 1073
                },
                {
                  "label": "廖内省",
                  "value": 1074
                },
                {
                  "label": "南巴布亚省",
                  "value": 1075
                }
              ]
            },
            {
              "country_code": 174,
              "country_name_ch": "美国",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/USA.svg",
              "cityIds": [
                259,
                260,
                261,
                262,
                263,
                264,
                265,
                266,
                267,
                268,
                269,
                270,
                271,
                272,
                273,
                274,
                275,
                276,
                277,
                278,
                279,
                280,
                281,
                282,
                283,
                284,
                285,
                286,
                287,
                288,
                289,
                290,
                291,
                292,
                293,
                294
              ],
              "provinces": [
                {
                  "label": "马里兰州",
                  "value": 259
                },
                {
                  "label": "密苏里州",
                  "value": 260
                },
                {
                  "label": "怀俄明州",
                  "value": 261
                },
                {
                  "label": "亚利桑那州",
                  "value": 262
                },
                {
                  "label": "西弗吉尼亚州",
                  "value": 263
                },
                {
                  "label": "俄亥俄州",
                  "value": 264
                },
                {
                  "label": "明尼苏达州",
                  "value": 265
                },
                {
                  "label": "内华达州",
                  "value": 266
                },
                {
                  "label": "华盛顿州",
                  "value": 267
                },
                {
                  "label": "德克萨斯州",
                  "value": 268
                },
                {
                  "label": "新泽西州",
                  "value": 269
                },
                {
                  "label": "北卡罗来纳州",
                  "value": 270
                },
                {
                  "label": "堪萨斯州",
                  "value": 271
                },
                {
                  "label": "纽约州",
                  "value": 272
                },
                {
                  "label": "马萨诸塞州",
                  "value": 273
                },
                {
                  "label": "俄勒冈州",
                  "value": 274
                },
                {
                  "label": "缅因州",
                  "value": 275
                },
                {
                  "label": "新墨西哥州",
                  "value": 276
                },
                {
                  "label": "犹他州",
                  "value": 277
                },
                {
                  "label": "路易斯安那州",
                  "value": 278
                },
                {
                  "label": "佛罗里达州",
                  "value": 279
                },
                {
                  "label": "宾夕法尼亚州",
                  "value": 280
                },
                {
                  "label": "科罗拉多州",
                  "value": 281
                },
                {
                  "label": "亚拉巴马州",
                  "value": 282
                },
                {
                  "label": "加利福尼亚州",
                  "value": 283
                },
                {
                  "label": "康涅狄格州",
                  "value": 284
                },
                {
                  "label": "田纳西州",
                  "value": 285
                },
                {
                  "label": "南卡罗来纳州",
                  "value": 286
                },
                {
                  "label": "华盛顿",
                  "value": 287
                },
                {
                  "label": "俄克拉荷马州",
                  "value": 288
                },
                {
                  "label": "弗吉尼亚州",
                  "value": 289
                },
                {
                  "label": "乔治亚州",
                  "value": 290
                },
                {
                  "label": "密歇根州",
                  "value": 291
                },
                {
                  "label": "美国",
                  "value": 292
                },
                {
                  "label": "伊利诺伊州",
                  "value": 293
                },
                {
                  "label": "威斯康星州",
                  "value": 294
                }
              ]
            },
            {
              "country_code": 102,
              "country_name_ch": "印度",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/India.svg",
              "cityIds": [
                978,
                979,
                980,
                981,
                982,
                983,
                984,
                985,
                986,
                987,
                988,
                989,
                990,
                991,
                992,
                993,
                994,
                995,
                996,
                997,
                998,
                999,
                1000,
                1001,
                1002,
                1003,
                1004,
                1005,
                1006,
                1007,
                1008,
                1009,
                1010,
                1011,
                1012,
                1013,
                1014,
                1015,
                1016
              ],
              "provinces": [
                {
                  "label": "本地冶里联邦直辖区",
                  "value": 978
                },
                {
                  "label": "东北部地区",
                  "value": 979
                },
                {
                  "label": "古吉拉特邦",
                  "value": 980
                },
                {
                  "label": "锡金邦",
                  "value": 981
                },
                {
                  "label": "达德拉－纳加尔哈维利和达曼－第乌",
                  "value": 982
                },
                {
                  "label": "奥里萨邦",
                  "value": 983
                },
                {
                  "label": "贾坎德邦",
                  "value": 984
                },
                {
                  "label": "哈里亚纳邦",
                  "value": 985
                },
                {
                  "label": "旁遮普邦",
                  "value": 986
                },
                {
                  "label": "安达曼－尼科巴群岛",
                  "value": 987
                },
                {
                  "label": "曼尼普尔邦",
                  "value": 988
                },
                {
                  "label": "喜马偕尔邦",
                  "value": 989
                },
                {
                  "label": "安得拉邦",
                  "value": 990
                },
                {
                  "label": "昌迪加尔",
                  "value": 991
                },
                {
                  "label": "马哈拉施特拉邦",
                  "value": 992
                },
                {
                  "label": "德里",
                  "value": 993
                },
                {
                  "label": "西孟加拉邦",
                  "value": 994
                },
                {
                  "label": "拉贾斯坦邦",
                  "value": 995
                },
                {
                  "label": "果阿邦",
                  "value": 996
                },
                {
                  "label": "印度",
                  "value": 997
                },
                {
                  "label": "北部地区",
                  "value": 998
                },
                {
                  "label": "比哈尔邦",
                  "value": 999
                },
                {
                  "label": "阿萨姆邦",
                  "value": 1000
                },
                {
                  "label": "中央邦",
                  "value": 1001
                },
                {
                  "label": "米佐拉姆邦",
                  "value": 1002
                },
                {
                  "label": "北方邦",
                  "value": 1003
                },
                {
                  "label": "恰蒂斯加尔邦",
                  "value": 1004
                },
                {
                  "label": "查谟和克什米尔邦",
                  "value": 1005
                },
                {
                  "label": "东部地区",
                  "value": 1006
                },
                {
                  "label": "拉克沙群岛",
                  "value": 1007
                },
                {
                  "label": "梅加拉亚邦",
                  "value": 1008
                },
                {
                  "label": "泰米尔纳德邦",
                  "value": 1009
                },
                {
                  "label": "中部地区",
                  "value": 1010
                },
                {
                  "label": "那加兰邦",
                  "value": 1011
                },
                {
                  "label": "喀拉拉邦",
                  "value": 1012
                },
                {
                  "label": "卡纳塔克邦",
                  "value": 1013
                },
                {
                  "label": "特伦甘纳邦",
                  "value": 1014
                },
                {
                  "label": "北阿坎德邦",
                  "value": 1015
                },
                {
                  "label": "特里普拉邦",
                  "value": 1016
                }
              ]
            },
            {
              "country_code": 65,
              "country_name_ch": "土耳其",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Turkey.svg",
              "cityIds": [
                625,
                626,
                627,
                628,
                629,
                630,
                631,
                632,
                633,
                634,
                635,
                636,
                637,
                638,
                639,
                640,
                641,
                642,
                643,
                644,
                645,
                646,
                647,
                648,
                649,
                650,
                651,
                652,
                653,
                654,
                655,
                656,
                657,
                658,
                659,
                660,
                661,
                662,
                663,
                664,
                665,
                666,
                667,
                668,
                669,
                670,
                671,
                672,
                673,
                674,
                675,
                676,
                677,
                678,
                679,
                680,
                681,
                682,
                683,
                684,
                685,
                686,
                687,
                688,
                689,
                690,
                691,
                692,
                693,
                694,
                695,
                696,
                697,
                698,
                699,
                700,
                701,
                702,
                703,
                704
              ],
              "provinces": [
                {
                  "label": "泰基尔达省",
                  "value": 625
                },
                {
                  "label": "埃尔津詹省",
                  "value": 626
                },
                {
                  "label": "亚洛瓦省",
                  "value": 627
                },
                {
                  "label": "乌沙克省",
                  "value": 628
                },
                {
                  "label": "穆什省",
                  "value": 629
                },
                {
                  "label": "阿克萨赖省",
                  "value": 630
                },
                {
                  "label": "卡拉比克省",
                  "value": 631
                },
                {
                  "label": "马尔马拉地区",
                  "value": 632
                },
                {
                  "label": "宗古尔达克省",
                  "value": 633
                },
                {
                  "label": "巴特曼省",
                  "value": 634
                },
                {
                  "label": "尚勒乌尔法省",
                  "value": 635
                },
                {
                  "label": "哈塔伊省",
                  "value": 636
                },
                {
                  "label": "乔鲁姆省",
                  "value": 637
                },
                {
                  "label": "代尼兹利省",
                  "value": 638
                },
                {
                  "label": "舍尔纳克省",
                  "value": 639
                },
                {
                  "label": "梅尔辛省",
                  "value": 640
                },
                {
                  "label": "特拉布宗省",
                  "value": 641
                },
                {
                  "label": "迪兹杰省",
                  "value": 642
                },
                {
                  "label": "克勒克卡莱省",
                  "value": 643
                },
                {
                  "label": "穆拉省",
                  "value": 644
                },
                {
                  "label": "东部安那托利亚地区",
                  "value": 645
                },
                {
                  "label": "中部安那托利亚地区",
                  "value": 646
                },
                {
                  "label": "托卡特省",
                  "value": 647
                },
                {
                  "label": "萨卡里亚省",
                  "value": 648
                },
                {
                  "label": "埃尔祖鲁姆省",
                  "value": 649
                },
                {
                  "label": "安塔利亚省",
                  "value": 650
                },
                {
                  "label": "基利斯省",
                  "value": 651
                },
                {
                  "label": "奥尔杜省",
                  "value": 652
                },
                {
                  "label": "埃斯基谢希尔省",
                  "value": 653
                },
                {
                  "label": "萨姆松省",
                  "value": 654
                },
                {
                  "label": "艾登省",
                  "value": 655
                },
                {
                  "label": "克尔克拉雷利省",
                  "value": 656
                },
                {
                  "label": "巴勒克埃西尔省",
                  "value": 657
                },
                {
                  "label": "布尔杜尔省",
                  "value": 658
                },
                {
                  "label": "阿尔特温省",
                  "value": 659
                },
                {
                  "label": "爱琴海地区",
                  "value": 660
                },
                {
                  "label": "开塞利省",
                  "value": 661
                },
                {
                  "label": "卡赫拉曼马拉什省",
                  "value": 662
                },
                {
                  "label": "博卢省",
                  "value": 663
                },
                {
                  "label": "巴尔滕省",
                  "value": 664
                },
                {
                  "label": "卡尔斯省",
                  "value": 665
                },
                {
                  "label": "土耳其",
                  "value": 666
                },
                {
                  "label": "迪亚巴克尔省",
                  "value": 667
                },
                {
                  "label": "科尼亚省",
                  "value": 668
                },
                {
                  "label": "尼代省",
                  "value": 669
                },
                {
                  "label": "埃拉泽省",
                  "value": 670
                },
                {
                  "label": "科加厄利省",
                  "value": 671
                },
                {
                  "label": "内夫谢希尔省",
                  "value": 672
                },
                {
                  "label": "卡拉曼省",
                  "value": 673
                },
                {
                  "label": "东南安那托利亚地区",
                  "value": 674
                },
                {
                  "label": "比莱吉克省",
                  "value": 675
                },
                {
                  "label": "安卡拉省",
                  "value": 676
                },
                {
                  "label": "马尔丁省",
                  "value": 677
                },
                {
                  "label": "阿达纳省",
                  "value": 678
                },
                {
                  "label": "凡城省",
                  "value": 679
                },
                {
                  "label": "卡斯塔莫努省",
                  "value": 680
                },
                {
                  "label": "伊兹密尔省",
                  "value": 681
                },
                {
                  "label": "阿菲永卡拉希萨尔省",
                  "value": 682
                },
                {
                  "label": "锡瓦斯省",
                  "value": 683
                },
                {
                  "label": "昌克勒省",
                  "value": 684
                },
                {
                  "label": "埃迪尔内省",
                  "value": 685
                },
                {
                  "label": "马拉蒂亚省",
                  "value": 686
                },
                {
                  "label": "阿勒省",
                  "value": 687
                },
                {
                  "label": "黑海地区",
                  "value": 688
                },
                {
                  "label": "伊斯坦布尔省",
                  "value": 689
                },
                {
                  "label": "吉雷松省",
                  "value": 690
                },
                {
                  "label": "布尔萨省",
                  "value": 691
                },
                {
                  "label": "恰纳卡莱省",
                  "value": 692
                },
                {
                  "label": "加济安泰普省",
                  "value": 693
                },
                {
                  "label": "克尔谢希尔省",
                  "value": 694
                },
                {
                  "label": "里泽省",
                  "value": 695
                },
                {
                  "label": "锡诺普省",
                  "value": 696
                },
                {
                  "label": "奥斯曼尼耶省",
                  "value": 697
                },
                {
                  "label": "马尼萨省",
                  "value": 698
                },
                {
                  "label": "伊斯帕尔塔省",
                  "value": 699
                },
                {
                  "label": "地中海地区",
                  "value": 700
                },
                {
                  "label": "约兹加特省",
                  "value": 701
                },
                {
                  "label": "屈塔希亚省",
                  "value": 702
                },
                {
                  "label": "阿马西亚省",
                  "value": 703
                },
                {
                  "label": "锡尔特省",
                  "value": 704
                }
              ]
            },
            {
              "country_code": 136,
              "country_name_ch": "亚太地区",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "",
              "cityIds": [
                1246
              ],
              "provinces": [
                {
                  "label": "亚太地区",
                  "value": 1246
                }
              ]
            },
            {
              "country_code": 7,
              "country_name_ch": "日本",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Japan.svg",
              "cityIds": [
                68,
                69,
                70,
                71,
                72,
                73,
                74,
                75,
                76,
                77,
                78,
                79
              ],
              "provinces": [
                {
                  "label": "爱知县",
                  "value": 68
                },
                {
                  "label": "东京都",
                  "value": 69
                },
                {
                  "label": "北海道",
                  "value": 70
                },
                {
                  "label": "大阪府",
                  "value": 71
                },
                {
                  "label": "茨城县",
                  "value": 72
                },
                {
                  "label": "富山县",
                  "value": 73
                },
                {
                  "label": "日本",
                  "value": 74
                },
                {
                  "label": "京都府",
                  "value": 75
                },
                {
                  "label": "千叶县",
                  "value": 76
                },
                {
                  "label": "岐阜县",
                  "value": 77
                },
                {
                  "label": "山形县",
                  "value": 78
                },
                {
                  "label": "神奈川县",
                  "value": 79
                }
              ]
            },
            {
              "country_code": 46,
              "country_name_ch": "泰国",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Thailand.svg",
              "cityIds": [
                451,
                452,
                453,
                454,
                455,
                456,
                457,
                458,
                459,
                460,
                461,
                462,
                463,
                464,
                465,
                466,
                467,
                468,
                469,
                470,
                471,
                472,
                473,
                474,
                475,
                476,
                477,
                478,
                479,
                480,
                481,
                482,
                483,
                484,
                485,
                486,
                487,
                488,
                489,
                490,
                491,
                492,
                493,
                494,
                495,
                496,
                497,
                498,
                499,
                500,
                501,
                502,
                503,
                504,
                505,
                506,
                507,
                508,
                509,
                510,
                511,
                512
              ],
              "provinces": [
                {
                  "label": "罗勇府",
                  "value": 451
                },
                {
                  "label": "呵叻府",
                  "value": 452
                },
                {
                  "label": "北部大区",
                  "value": 453
                },
                {
                  "label": "清莱府",
                  "value": 454
                },
                {
                  "label": "北碧府",
                  "value": 455
                },
                {
                  "label": "碧差汶府",
                  "value": 456
                },
                {
                  "label": "春武里府",
                  "value": 457
                },
                {
                  "label": "普吉府",
                  "value": 458
                },
                {
                  "label": "曼谷",
                  "value": 459
                },
                {
                  "label": "龙仔厝府",
                  "value": 460
                },
                {
                  "label": "程逸府",
                  "value": 461
                },
                {
                  "label": "佛统府",
                  "value": 462
                },
                {
                  "label": "那空拍侬府",
                  "value": 463
                },
                {
                  "label": "董里府",
                  "value": 464
                },
                {
                  "label": "沙缴府",
                  "value": 465
                },
                {
                  "label": "披集府",
                  "value": 466
                },
                {
                  "label": "安纳乍能府",
                  "value": 467
                },
                {
                  "label": "东北大区",
                  "value": 468
                },
                {
                  "label": "莫拉限府",
                  "value": 469
                },
                {
                  "label": "素叻他尼府",
                  "value": 470
                },
                {
                  "label": "黎逸府",
                  "value": 471
                },
                {
                  "label": "乌汶府",
                  "value": 472
                },
                {
                  "label": "佛丕府",
                  "value": 473
                },
                {
                  "label": "北揽坡府",
                  "value": 474
                },
                {
                  "label": "色军府",
                  "value": 475
                },
                {
                  "label": "春蓬府",
                  "value": 476
                },
                {
                  "label": "南部大区",
                  "value": 477
                },
                {
                  "label": "宋卡府",
                  "value": 478
                },
                {
                  "label": "益梭通府",
                  "value": 479
                },
                {
                  "label": "暖武里府",
                  "value": 480
                },
                {
                  "label": "大城府",
                  "value": 481
                },
                {
                  "label": "玛哈沙拉堪府",
                  "value": 482
                },
                {
                  "label": "来兴府",
                  "value": 483
                },
                {
                  "label": "清迈府",
                  "value": 484
                },
                {
                  "label": "中部大区",
                  "value": 485
                },
                {
                  "label": "叻丕府",
                  "value": 486
                },
                {
                  "label": "加拉信府",
                  "value": 487
                },
                {
                  "label": "素可泰府",
                  "value": 488
                },
                {
                  "label": "博他仑府",
                  "value": 489
                },
                {
                  "label": "巴吞他尼府",
                  "value": 490
                },
                {
                  "label": "信武里府",
                  "value": 491
                },
                {
                  "label": "班武里府",
                  "value": 492
                },
                {
                  "label": "甲米府",
                  "value": 493
                },
                {
                  "label": "四色菊府",
                  "value": 494
                },
                {
                  "label": "帕夭府",
                  "value": 495
                },
                {
                  "label": "惹拉府",
                  "value": 496
                },
                {
                  "label": "红统府",
                  "value": 497
                },
                {
                  "label": "坤敬府",
                  "value": 498
                },
                {
                  "label": "华富里府",
                  "value": 499
                },
                {
                  "label": "东部大区",
                  "value": 500
                },
                {
                  "label": "廊开府",
                  "value": 501
                },
                {
                  "label": "彭世洛府",
                  "value": 502
                },
                {
                  "label": "西部大区",
                  "value": 503
                },
                {
                  "label": "北标府",
                  "value": 504
                },
                {
                  "label": "巴真府",
                  "value": 505
                },
                {
                  "label": "北榄府",
                  "value": 506
                },
                {
                  "label": "尖竹汶府",
                  "value": 507
                },
                {
                  "label": "泰国",
                  "value": 508
                },
                {
                  "label": "素辇府",
                  "value": 509
                },
                {
                  "label": "北柳府",
                  "value": 510
                },
                {
                  "label": "南邦府",
                  "value": 511
                },
                {
                  "label": "乌隆府",
                  "value": 512
                }
              ]
            },
            {
              "country_code": 131,
              "country_name_ch": "新加坡",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Singapore.svg",
              "cityIds": [
                1236
              ],
              "provinces": [
                {
                  "label": "新加坡",
                  "value": 1236
                }
              ]
            },
            {
              "country_code": 117,
              "country_name_ch": "马来西亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Malaysia.svg",
              "cityIds": [
                1097,
                1098,
                1099,
                1100,
                1101,
                1102,
                1103,
                1104,
                1105,
                1106,
                1107,
                1108,
                1109,
                1110,
                1111,
                1112,
                1113
              ],
              "provinces": [
                {
                  "label": "沙巴州",
                  "value": 1097
                },
                {
                  "label": "马六甲州",
                  "value": 1098
                },
                {
                  "label": "玻璃市州",
                  "value": 1099
                },
                {
                  "label": "吉隆坡联邦直辖区",
                  "value": 1100
                },
                {
                  "label": "马来西亚",
                  "value": 1101
                },
                {
                  "label": "霹雳州",
                  "value": 1102
                },
                {
                  "label": "森美兰州",
                  "value": 1103
                },
                {
                  "label": "吉兰丹州",
                  "value": 1104
                },
                {
                  "label": "吉打州",
                  "value": 1105
                },
                {
                  "label": "雪兰莪州",
                  "value": 1106
                },
                {
                  "label": "西马",
                  "value": 1107
                },
                {
                  "label": "槟城州",
                  "value": 1108
                },
                {
                  "label": "布城联邦直辖区",
                  "value": 1109
                },
                {
                  "label": "砂拉越州",
                  "value": 1110
                },
                {
                  "label": "彭亨州",
                  "value": 1111
                },
                {
                  "label": "登嘉楼州",
                  "value": 1112
                },
                {
                  "label": "柔佛州",
                  "value": 1113
                }
              ]
            },
            {
              "country_code": 70,
              "country_name_ch": "孟加拉",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Bangladesh.svg",
              "cityIds": [
                726,
                727,
                728,
                729,
                730,
                731,
                732,
                733
              ],
              "provinces": [
                {
                  "label": "朗布尔专区",
                  "value": 726
                },
                {
                  "label": "库尔纳专区",
                  "value": 727
                },
                {
                  "label": "锡尔赫特专区",
                  "value": 728
                },
                {
                  "label": "达卡专区",
                  "value": 729
                },
                {
                  "label": "迈门辛专区",
                  "value": 730
                },
                {
                  "label": "吉大港专区",
                  "value": 731
                },
                {
                  "label": "拉杰沙希专区",
                  "value": 732
                },
                {
                  "label": "孟加拉",
                  "value": 733
                }
              ]
            },
            {
              "country_code": 97,
              "country_name_ch": "伊拉克",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Iraq.svg",
              "cityIds": [
                936,
                937,
                938,
                939,
                940,
                941,
                942,
                943,
                944,
                945,
                946,
                947,
                948,
                949,
                950,
                951,
                952,
                953,
                954
              ],
              "provinces": [
                {
                  "label": "巴比伦省",
                  "value": 936
                },
                {
                  "label": "迪亚拉省",
                  "value": 937
                },
                {
                  "label": "杜胡克省",
                  "value": 938
                },
                {
                  "label": "埃尔比勒省",
                  "value": 939
                },
                {
                  "label": "纳杰夫省",
                  "value": 940
                },
                {
                  "label": "苏莱曼尼亚省",
                  "value": 941
                },
                {
                  "label": "米桑省",
                  "value": 942
                },
                {
                  "label": "巴士拉省",
                  "value": 943
                },
                {
                  "label": "萨拉赫丁省",
                  "value": 944
                },
                {
                  "label": "尼尼微省",
                  "value": 945
                },
                {
                  "label": "巴格达省",
                  "value": 946
                },
                {
                  "label": "伊拉克",
                  "value": 947
                },
                {
                  "label": "瓦西特省",
                  "value": 948
                },
                {
                  "label": "济加尔省",
                  "value": 949
                },
                {
                  "label": "基尔库克省",
                  "value": 950
                },
                {
                  "label": "穆萨纳省",
                  "value": 951
                },
                {
                  "label": "卡尔巴拉省",
                  "value": 952
                },
                {
                  "label": "卡迪西亚省",
                  "value": 953
                },
                {
                  "label": "安巴尔省",
                  "value": 954
                }
              ]
            },
            {
              "country_code": 13,
              "country_name_ch": "意大利",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Italy.svg",
              "cityIds": [
                124,
                125,
                126,
                127,
                128,
                129,
                130,
                131
              ],
              "provinces": [
                {
                  "label": "伦巴第大区",
                  "value": 124
                },
                {
                  "label": "托斯卡纳大区",
                  "value": 125
                },
                {
                  "label": "意大利",
                  "value": 126
                },
                {
                  "label": "西西里大区",
                  "value": 127
                },
                {
                  "label": "威尼托大区",
                  "value": 128
                },
                {
                  "label": "拉齐奥大区",
                  "value": 129
                },
                {
                  "label": "马尔凯大区",
                  "value": 130
                },
                {
                  "label": "皮埃蒙特大区",
                  "value": 131
                }
              ]
            },
            {
              "country_code": 118,
              "country_name_ch": "巴西",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Brazil.svg",
              "cityIds": [
                1114,
                1115,
                1116,
                1117,
                1118,
                1119,
                1120,
                1121,
                1122,
                1123,
                1124,
                1125,
                1126,
                1127,
                1128,
                1129,
                1130,
                1131,
                1132,
                1133,
                1134,
                1135,
                1136,
                1137,
                1138,
                1139,
                1140,
                1141,
                1142
              ],
              "provinces": [
                {
                  "label": "里约热内卢州",
                  "value": 1114
                },
                {
                  "label": "塞阿腊州",
                  "value": 1115
                },
                {
                  "label": "罗赖马州",
                  "value": 1116
                },
                {
                  "label": "东北部",
                  "value": 1117
                },
                {
                  "label": "圣卡塔琳娜州",
                  "value": 1118
                },
                {
                  "label": "米纳斯吉拉斯州",
                  "value": 1119
                },
                {
                  "label": "南里奥格兰德州",
                  "value": 1120
                },
                {
                  "label": "北里奥格兰德州",
                  "value": 1121
                },
                {
                  "label": "伯南布哥州",
                  "value": 1122
                },
                {
                  "label": "巴西",
                  "value": 1123
                },
                {
                  "label": "阿拉戈斯州",
                  "value": 1124
                },
                {
                  "label": "皮奥伊州",
                  "value": 1125
                },
                {
                  "label": "阿克雷州",
                  "value": 1126
                },
                {
                  "label": "帕拉州",
                  "value": 1127
                },
                {
                  "label": "帕拉伊巴州",
                  "value": 1128
                },
                {
                  "label": "巴伊亚州",
                  "value": 1129
                },
                {
                  "label": "亚马孙州",
                  "value": 1130
                },
                {
                  "label": "马拉尼昂州",
                  "value": 1131
                },
                {
                  "label": "马托格罗索州",
                  "value": 1132
                },
                {
                  "label": "南马托格罗索州",
                  "value": 1133
                },
                {
                  "label": "巴拉那州",
                  "value": 1134
                },
                {
                  "label": "塞尔希培州",
                  "value": 1135
                },
                {
                  "label": "圣保罗州",
                  "value": 1136
                },
                {
                  "label": "托坎廷斯州",
                  "value": 1137
                },
                {
                  "label": "圣埃斯皮里图州",
                  "value": 1138
                },
                {
                  "label": "戈亚斯州",
                  "value": 1139
                },
                {
                  "label": "朗多尼亚州",
                  "value": 1140
                },
                {
                  "label": "阿马帕州",
                  "value": 1141
                },
                {
                  "label": "联邦区",
                  "value": 1142
                }
              ]
            },
            {
              "country_code": 20,
              "country_name_ch": "多米尼加",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/DominicanRepublic.svg",
              "cityIds": [
                162,
                163,
                164,
                165,
                166,
                167,
                168,
                169,
                170,
                171,
                172,
                173,
                174,
                175,
                176,
                177,
                178,
                179,
                180,
                181,
                182,
                183,
                184,
                185,
                186,
                187,
                188,
                189,
                190
              ],
              "provinces": [
                {
                  "label": "普拉塔港省",
                  "value": 162
                },
                {
                  "label": "杜阿尔特省",
                  "value": 163
                },
                {
                  "label": "桑切斯拉米雷斯省",
                  "value": 164
                },
                {
                  "label": "阿苏阿省",
                  "value": 165
                },
                {
                  "label": "多米尼加",
                  "value": 166
                },
                {
                  "label": "玛丽亚特立尼达桑切斯省",
                  "value": 167
                },
                {
                  "label": "国家特区",
                  "value": 168
                },
                {
                  "label": "巴拉奥纳省",
                  "value": 169
                },
                {
                  "label": "主教瑙黎省",
                  "value": 170
                },
                {
                  "label": "圣胡安省",
                  "value": 171
                },
                {
                  "label": "圣佩得罗－德马科里斯省",
                  "value": 172
                },
                {
                  "label": "蒙特普拉塔省",
                  "value": 173
                },
                {
                  "label": "巴尔韦德省",
                  "value": 174
                },
                {
                  "label": "圣克里斯托瓦尔省",
                  "value": 175
                },
                {
                  "label": "圣地亚哥罗德里格斯省",
                  "value": 176
                },
                {
                  "label": "埃斯派亚省",
                  "value": 177
                },
                {
                  "label": "埃尔塞沃省",
                  "value": 178
                },
                {
                  "label": "阿托马约尔省",
                  "value": 179
                },
                {
                  "label": "佩拉维亚省",
                  "value": 180
                },
                {
                  "label": "巴奥鲁科省",
                  "value": 181
                },
                {
                  "label": "蒙特克里斯蒂省",
                  "value": 182
                },
                {
                  "label": "圣多明戈省",
                  "value": 183
                },
                {
                  "label": "拉罗马纳省",
                  "value": 184
                },
                {
                  "label": "萨马纳省",
                  "value": 185
                },
                {
                  "label": "圣地亚哥省",
                  "value": 186
                },
                {
                  "label": "米拉贝姐妹省",
                  "value": 187
                },
                {
                  "label": "达哈翁省",
                  "value": 188
                },
                {
                  "label": "拉贝加省",
                  "value": 189
                },
                {
                  "label": "阿尔塔格拉西亚省",
                  "value": 190
                }
              ]
            },
            {
              "country_code": 64,
              "country_name_ch": "捷克",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/CzechRepublic.svg",
              "cityIds": [
                612,
                613,
                614,
                615,
                616,
                617,
                618,
                619,
                620,
                621,
                622,
                623,
                624
              ],
              "provinces": [
                {
                  "label": "摩拉维亚－西里西亚州",
                  "value": 612
                },
                {
                  "label": "奥洛穆克州",
                  "value": 613
                },
                {
                  "label": "赫拉德茨－克拉洛韦州",
                  "value": 614
                },
                {
                  "label": "中波希米亚州",
                  "value": 615
                },
                {
                  "label": "维索基纳州",
                  "value": 616
                },
                {
                  "label": "布拉格",
                  "value": 617
                },
                {
                  "label": "南摩拉维亚州",
                  "value": 618
                },
                {
                  "label": "乌斯季州",
                  "value": 619
                },
                {
                  "label": "比尔森州",
                  "value": 620
                },
                {
                  "label": "卡罗维发利州",
                  "value": 621
                },
                {
                  "label": "兹林州",
                  "value": 622
                },
                {
                  "label": "帕尔杜比采州",
                  "value": 623
                },
                {
                  "label": "捷克",
                  "value": 624
                }
              ]
            },
            {
              "country_code": 80,
              "country_name_ch": "埃及",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Egypt.svg",
              "cityIds": [
                821,
                822,
                823,
                824,
                825,
                826,
                827,
                828,
                829,
                830,
                831,
                832,
                833,
                834,
                835,
                836,
                837,
                838,
                839,
                840,
                841,
                842,
                843,
                844,
                845,
                846,
                847
              ],
              "provinces": [
                {
                  "label": "开罗省",
                  "value": 821
                },
                {
                  "label": "基纳省",
                  "value": 822
                },
                {
                  "label": "米努夫省",
                  "value": 823
                },
                {
                  "label": "索哈杰省",
                  "value": 824
                },
                {
                  "label": "红海省",
                  "value": 825
                },
                {
                  "label": "北西奈省",
                  "value": 826
                },
                {
                  "label": "加比亚省",
                  "value": 827
                },
                {
                  "label": "塞得港省",
                  "value": 828
                },
                {
                  "label": "布海拉省",
                  "value": 829
                },
                {
                  "label": "埃及",
                  "value": 830
                },
                {
                  "label": "艾斯尤特省",
                  "value": 831
                },
                {
                  "label": "谢赫村省",
                  "value": 832
                },
                {
                  "label": "沙迦省",
                  "value": 833
                },
                {
                  "label": "伊斯梅利亚省",
                  "value": 834
                },
                {
                  "label": "贝尼苏韦夫省",
                  "value": 835
                },
                {
                  "label": "亚历山大省",
                  "value": 836
                },
                {
                  "label": "明亚省",
                  "value": 837
                },
                {
                  "label": "马特鲁省",
                  "value": 838
                },
                {
                  "label": "杜姆亚特省",
                  "value": 839
                },
                {
                  "label": "达卡利亚省",
                  "value": 840
                },
                {
                  "label": "苏伊士省",
                  "value": 841
                },
                {
                  "label": "阿斯旺省",
                  "value": 842
                },
                {
                  "label": "盖卢比尤省",
                  "value": 843
                },
                {
                  "label": "吉萨省",
                  "value": 844
                },
                {
                  "label": "卢克索省",
                  "value": 845
                },
                {
                  "label": "法尤姆省",
                  "value": 846
                },
                {
                  "label": "南西奈省",
                  "value": 847
                }
              ]
            },
            {
              "country_code": 86,
              "country_name_ch": "阿尔及利亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Algeria.svg",
              "cityIds": [
                875,
                876,
                877,
                878,
                879,
                880,
                881,
                882,
                883,
                884,
                885,
                886,
                887,
                888,
                889,
                890,
                891,
                892,
                893,
                894,
                895,
                896,
                897,
                898,
                899,
                900,
                901,
                902,
                903,
                904,
                905,
                906,
                907,
                908,
                909,
                910
              ],
              "provinces": [
                {
                  "label": "谢利夫省",
                  "value": 875
                },
                {
                  "label": "提塞姆西勒特省",
                  "value": 876
                },
                {
                  "label": "瓦迪省",
                  "value": 877
                },
                {
                  "label": "阿尔及利亚",
                  "value": 878
                },
                {
                  "label": "吉杰勒省",
                  "value": 879
                },
                {
                  "label": "法属时期奥尔良维尔省",
                  "value": 880
                },
                {
                  "label": "法属时期瓦哈特省",
                  "value": 881
                },
                {
                  "label": "君士坦丁省",
                  "value": 882
                },
                {
                  "label": "法属时期萨伊达省",
                  "value": 883
                },
                {
                  "label": "法属时期蒂兹乌祖省",
                  "value": 884
                },
                {
                  "label": "米拉省",
                  "value": 885
                },
                {
                  "label": "安纳巴省",
                  "value": 886
                },
                {
                  "label": "奥兰省",
                  "value": 887
                },
                {
                  "label": "特莱姆森省",
                  "value": 888
                },
                {
                  "label": "布阿拉里季堡省",
                  "value": 889
                },
                {
                  "label": "法属时期墨斯塔加那姆省",
                  "value": 890
                },
                {
                  "label": "法属时期巴塔尼亚省",
                  "value": 891
                },
                {
                  "label": "泰贝萨省",
                  "value": 892
                },
                {
                  "label": "姆西拉省",
                  "value": 893
                },
                {
                  "label": "阿德拉尔省",
                  "value": 894
                },
                {
                  "label": "提济乌祖省",
                  "value": 895
                },
                {
                  "label": "比斯克拉省",
                  "value": 896
                },
                {
                  "label": "法属时期欧兰省",
                  "value": 897
                },
                {
                  "label": "塞提夫省",
                  "value": 898
                },
                {
                  "label": "贝贾亚省",
                  "value": 899
                },
                {
                  "label": "阿尔及尔省",
                  "value": 900
                },
                {
                  "label": "法属时期萨欧拉省",
                  "value": 901
                },
                {
                  "label": "奥拉德杰拉勒省",
                  "value": 902
                },
                {
                  "label": "法属时期塞蒂夫省",
                  "value": 903
                },
                {
                  "label": "苏格艾赫拉斯省",
                  "value": 904
                },
                {
                  "label": "提亚雷特省",
                  "value": 905
                },
                {
                  "label": "法属时期伯恩省",
                  "value": 906
                },
                {
                  "label": "法属时期康斯坦丁省",
                  "value": 907
                },
                {
                  "label": "法属时期美狄亚省",
                  "value": 908
                },
                {
                  "label": "乌姆布瓦吉省",
                  "value": 909
                },
                {
                  "label": "巴特纳省",
                  "value": 910
                }
              ]
            },
            {
              "country_code": 41,
              "country_name_ch": "欧洲地区",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "",
              "cityIds": [
                435
              ],
              "provinces": [
                {
                  "label": "欧洲地区",
                  "value": 435
                }
              ]
            },
            {
              "country_code": 119,
              "country_name_ch": "瑞典",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Sweden.svg",
              "cityIds": [
                1143,
                1144,
                1145,
                1146,
                1147
              ],
              "provinces": [
                {
                  "label": "耶夫勒堡省",
                  "value": 1143
                },
                {
                  "label": "斯科讷省",
                  "value": 1144
                },
                {
                  "label": "斯德哥尔摩省",
                  "value": 1145
                },
                {
                  "label": "瑞典",
                  "value": 1146
                },
                {
                  "label": "哥特兰省",
                  "value": 1147
                }
              ]
            },
            {
              "country_code": 42,
              "country_name_ch": "约旦",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Jordan.svg",
              "cityIds": [
                436,
                437,
                438,
                439
              ],
              "provinces": [
                {
                  "label": "约旦",
                  "value": 436
                },
                {
                  "label": "安曼省",
                  "value": 437
                },
                {
                  "label": "扎尔卡省",
                  "value": 438
                },
                {
                  "label": "伊尔比德省",
                  "value": 439
                }
              ]
            },
            {
              "country_code": 33,
              "country_name_ch": "哈萨克斯坦",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Kazakhstan.svg",
              "cityIds": [
                299,
                300,
                301,
                302,
                303,
                304,
                305,
                306,
                307,
                308,
                309,
                310,
                311,
                312,
                313,
                314,
                315,
                316,
                317,
                318,
                319
              ],
              "provinces": [
                {
                  "label": "奇姆肯特",
                  "value": 299
                },
                {
                  "label": "阿拜州",
                  "value": 300
                },
                {
                  "label": "阿拉木图州",
                  "value": 301
                },
                {
                  "label": "突厥斯坦州",
                  "value": 302
                },
                {
                  "label": "杰特苏州",
                  "value": 303
                },
                {
                  "label": "江布尔州",
                  "value": 304
                },
                {
                  "label": "北哈萨克斯坦州",
                  "value": 305
                },
                {
                  "label": "克孜勒奥尔达州",
                  "value": 306
                },
                {
                  "label": "曼格斯套州",
                  "value": 307
                },
                {
                  "label": "阿克莫拉州",
                  "value": 308
                },
                {
                  "label": "西哈萨克斯坦州",
                  "value": 309
                },
                {
                  "label": "乌勒套州",
                  "value": 310
                },
                {
                  "label": "卡拉干达州",
                  "value": 311
                },
                {
                  "label": "巴甫洛达尔州",
                  "value": 312
                },
                {
                  "label": "阿斯塔纳",
                  "value": 313
                },
                {
                  "label": "东哈萨克斯坦州",
                  "value": 314
                },
                {
                  "label": "阿拉木图",
                  "value": 315
                },
                {
                  "label": "库斯塔奈州",
                  "value": 316
                },
                {
                  "label": "哈萨克斯坦",
                  "value": 317
                },
                {
                  "label": "阿特劳州",
                  "value": 318
                },
                {
                  "label": "阿克托贝州",
                  "value": 319
                }
              ]
            },
            {
              "country_code": 8,
              "country_name_ch": "巴基斯坦",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Pakistan.svg",
              "cityIds": [
                80,
                81,
                82,
                83,
                84,
                85,
                86
              ],
              "provinces": [
                {
                  "label": "旁遮普省",
                  "value": 80
                },
                {
                  "label": "信德省",
                  "value": 81
                },
                {
                  "label": "开伯尔－普赫图赫瓦省",
                  "value": 82
                },
                {
                  "label": "俾路支省",
                  "value": 83
                },
                {
                  "label": "阿扎德克什米尔",
                  "value": 84
                },
                {
                  "label": "伊斯兰堡首都区",
                  "value": 85
                },
                {
                  "label": "巴基斯坦",
                  "value": 86
                }
              ]
            },
            {
              "country_code": 21,
              "country_name_ch": "韩国",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Korea.svg",
              "cityIds": [
                191,
                192,
                193,
                194,
                195,
                196,
                197
              ],
              "provinces": [
                {
                  "label": "韩国",
                  "value": 191
                },
                {
                  "label": "庆尚北道",
                  "value": 192
                },
                {
                  "label": "京畿道",
                  "value": 193
                },
                {
                  "label": "仁川",
                  "value": 194
                },
                {
                  "label": "世宗",
                  "value": 195
                },
                {
                  "label": "江原特别自治道",
                  "value": 196
                },
                {
                  "label": "首尔",
                  "value": 197
                }
              ]
            },
            {
              "country_code": 124,
              "country_name_ch": "阿联酋",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "",
              "cityIds": [
                1177,
                1178,
                1179,
                1180,
                1181,
                1182,
                1183,
                1184
              ],
              "provinces": [
                {
                  "label": "阿治曼酋长国",
                  "value": 1177
                },
                {
                  "label": "阿布扎比酋长国",
                  "value": 1178
                },
                {
                  "label": "阿联酋",
                  "value": 1179
                },
                {
                  "label": "富查伊拉酋长国",
                  "value": 1180
                },
                {
                  "label": "拉斯海玛酋长国",
                  "value": 1181
                },
                {
                  "label": "乌姆盖万酋长国",
                  "value": 1182
                },
                {
                  "label": "迪拜酋长国",
                  "value": 1183
                },
                {
                  "label": "沙迦酋长国",
                  "value": 1184
                }
              ]
            },
            {
              "country_code": 2,
              "country_name_ch": "法国",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/France.svg",
              "cityIds": [
                25,
                26,
                27,
                28,
                29,
                30,
                31
              ],
              "provinces": [
                {
                  "label": "法国",
                  "value": 25
                },
                {
                  "label": "法兰西岛大区",
                  "value": 26
                },
                {
                  "label": "上法兰西大区",
                  "value": 27
                },
                {
                  "label": "奥克西塔尼大区",
                  "value": 28
                },
                {
                  "label": "普罗旺斯－阿尔卑斯－蓝色海岸大区",
                  "value": 29
                },
                {
                  "label": "奥弗涅－罗纳－阿尔卑斯大区",
                  "value": 30
                },
                {
                  "label": "大东部大区",
                  "value": 31
                }
              ]
            },
            {
              "country_code": 110,
              "country_name_ch": "加拿大",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Canada.svg",
              "cityIds": [
                1076,
                1077,
                1078,
                1079,
                1080,
                1081,
                1082
              ],
              "provinces": [
                {
                  "label": "魁北克省",
                  "value": 1076
                },
                {
                  "label": "曼尼托巴省",
                  "value": 1077
                },
                {
                  "label": "加拿大",
                  "value": 1078
                },
                {
                  "label": "萨斯喀彻温省",
                  "value": 1079
                },
                {
                  "label": "艾伯塔省",
                  "value": 1080
                },
                {
                  "label": "不列颠哥伦比亚省",
                  "value": 1081
                },
                {
                  "label": "安大略省",
                  "value": 1082
                }
              ]
            },
            {
              "country_code": 164,
              "country_name_ch": "俄罗斯",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/RussianFederation.svg",
              "cityIds": [
                1448,
                1449,
                1450,
                1451,
                1452,
                1453,
                1454,
                1455,
                1456,
                1457,
                1458,
                1459,
                1460,
                1461,
                1462,
                1463,
                1464,
                1465,
                1466,
                1467,
                1468,
                1469,
                1470,
                1471,
                1472,
                1473,
                1474,
                1475,
                1476,
                1477,
                1478,
                1479,
                1480,
                1481,
                1482,
                1483,
                1484,
                1485,
                1486,
                1487,
                1488,
                1489,
                1490,
                1491,
                1492,
                1493,
                1494,
                1495,
                1496,
                1497,
                1498,
                1499,
                1500,
                1501,
                1502,
                1503,
                1504,
                1505,
                1506,
                1507,
                1508
              ],
              "provinces": [
                {
                  "label": "莫尔多瓦共和国",
                  "value": 1448
                },
                {
                  "label": "阿斯特拉罕州",
                  "value": 1449
                },
                {
                  "label": "奥廖尔州",
                  "value": 1450
                },
                {
                  "label": "斯塔夫罗波尔边疆区",
                  "value": 1451
                },
                {
                  "label": "沃洛格达州",
                  "value": 1452
                },
                {
                  "label": "乌里扬诺夫斯克州",
                  "value": 1453
                },
                {
                  "label": "俄罗斯",
                  "value": 1454
                },
                {
                  "label": "托木斯克州",
                  "value": 1455
                },
                {
                  "label": "秋明州",
                  "value": 1456
                },
                {
                  "label": "莫斯科州",
                  "value": 1457
                },
                {
                  "label": "普斯科夫州",
                  "value": 1458
                },
                {
                  "label": "图瓦共和国",
                  "value": 1459
                },
                {
                  "label": "加里宁格勒州",
                  "value": 1460
                },
                {
                  "label": "罗斯托夫州",
                  "value": 1461
                },
                {
                  "label": "阿迪格共和国",
                  "value": 1462
                },
                {
                  "label": "图拉州",
                  "value": 1463
                },
                {
                  "label": "萨马拉州",
                  "value": 1464
                },
                {
                  "label": "车里雅宾斯克州",
                  "value": 1465
                },
                {
                  "label": "亚马尔－涅涅茨自治区",
                  "value": 1466
                },
                {
                  "label": "伊万诺沃州",
                  "value": 1467
                },
                {
                  "label": "库尔斯克州",
                  "value": 1468
                },
                {
                  "label": "堪察加边疆区",
                  "value": 1469
                },
                {
                  "label": "布里亚特共和国",
                  "value": 1470
                },
                {
                  "label": "鞑靼斯坦共和国",
                  "value": 1471
                },
                {
                  "label": "圣彼得堡",
                  "value": 1472
                },
                {
                  "label": "阿尔汉格尔斯克州",
                  "value": 1473
                },
                {
                  "label": "哈卡斯共和国",
                  "value": 1474
                },
                {
                  "label": "达吉斯坦共和国",
                  "value": 1475
                },
                {
                  "label": "巴什科尔托斯坦共和国",
                  "value": 1476
                },
                {
                  "label": "塞瓦斯托波尔",
                  "value": 1477
                },
                {
                  "label": "鄂木斯克州",
                  "value": 1478
                },
                {
                  "label": "哈巴罗夫斯克边疆区",
                  "value": 1479
                },
                {
                  "label": "雅罗斯拉夫尔州",
                  "value": 1480
                },
                {
                  "label": "阿尔泰边疆区",
                  "value": 1481
                },
                {
                  "label": "伏尔加格勒州",
                  "value": 1482
                },
                {
                  "label": "沃罗涅什州",
                  "value": 1483
                },
                {
                  "label": "下诺夫哥罗德州",
                  "value": 1484
                },
                {
                  "label": "梁赞州",
                  "value": 1485
                },
                {
                  "label": "莫斯科",
                  "value": 1486
                },
                {
                  "label": "克拉斯诺亚尔斯克边疆区",
                  "value": 1487
                },
                {
                  "label": "伊尔库茨克州",
                  "value": 1488
                },
                {
                  "label": "卡卢加州",
                  "value": 1489
                },
                {
                  "label": "车臣共和国",
                  "value": 1490
                },
                {
                  "label": "克拉斯诺达尔边疆区",
                  "value": 1491
                },
                {
                  "label": "科米共和国",
                  "value": 1492
                },
                {
                  "label": "萨哈林州",
                  "value": 1493
                },
                {
                  "label": "萨拉托夫州",
                  "value": 1494
                },
                {
                  "label": "楚瓦什共和国",
                  "value": 1495
                },
                {
                  "label": "特维尔州",
                  "value": 1496
                },
                {
                  "label": "克里米亚共和国",
                  "value": 1497
                },
                {
                  "label": "斯维尔德洛夫斯克州",
                  "value": 1498
                },
                {
                  "label": "卡巴尔达－巴尔卡尔共和国",
                  "value": 1499
                },
                {
                  "label": "新西伯利亚州",
                  "value": 1500
                },
                {
                  "label": "萨哈共和国",
                  "value": 1501
                },
                {
                  "label": "诺夫哥罗德州",
                  "value": 1502
                },
                {
                  "label": "列宁格勒州",
                  "value": 1503
                },
                {
                  "label": "弗拉基米尔州",
                  "value": 1504
                },
                {
                  "label": "滨海边疆区",
                  "value": 1505
                },
                {
                  "label": "彼尔姆边疆区",
                  "value": 1506
                },
                {
                  "label": "坦波夫州",
                  "value": 1507
                },
                {
                  "label": "北奥塞梯－阿兰共和国",
                  "value": 1508
                }
              ]
            },
            {
              "country_code": 34,
              "country_name_ch": "厄瓜多尔",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Ecuador.svg",
              "cityIds": [
                320,
                321,
                322,
                323,
                324,
                325,
                326,
                327,
                328,
                329,
                330,
                331,
                332,
                333,
                334,
                335,
                336,
                337,
                338,
                339,
                340,
                341,
                342,
                343,
                344
              ],
              "provinces": [
                {
                  "label": "奥雷亚纳省",
                  "value": 320
                },
                {
                  "label": "卡尼亚尔省",
                  "value": 321
                },
                {
                  "label": "埃斯梅拉达斯省",
                  "value": 322
                },
                {
                  "label": "洛哈省",
                  "value": 323
                },
                {
                  "label": "萨莫拉－钦奇佩省",
                  "value": 324
                },
                {
                  "label": "玻利瓦尔省",
                  "value": 325
                },
                {
                  "label": "加拉帕戈斯省",
                  "value": 326
                },
                {
                  "label": "因巴布拉省",
                  "value": 327
                },
                {
                  "label": "圣多明各－德洛斯查奇拉斯省",
                  "value": 328
                },
                {
                  "label": "皮钦查省",
                  "value": 329
                },
                {
                  "label": "马纳比省",
                  "value": 330
                },
                {
                  "label": "卡尔奇省",
                  "value": 331
                },
                {
                  "label": "钦博拉索省",
                  "value": 332
                },
                {
                  "label": "纳波省",
                  "value": 333
                },
                {
                  "label": "莫罗纳－圣地亚哥省",
                  "value": 334
                },
                {
                  "label": "阿苏艾省",
                  "value": 335
                },
                {
                  "label": "洛斯里奥斯省",
                  "value": 336
                },
                {
                  "label": "埃尔奥罗省",
                  "value": 337
                },
                {
                  "label": "圣埃伦娜省",
                  "value": 338
                },
                {
                  "label": "瓜亚斯省",
                  "value": 339
                },
                {
                  "label": "帕斯塔萨省",
                  "value": 340
                },
                {
                  "label": "厄瓜多尔",
                  "value": 341
                },
                {
                  "label": "通古拉瓦省",
                  "value": 342
                },
                {
                  "label": "科托帕希省",
                  "value": 343
                },
                {
                  "label": "苏昆比奥斯省",
                  "value": 344
                }
              ]
            },
            {
              "country_code": 137,
              "country_name_ch": "德国",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Germany.svg",
              "cityIds": [
                1247,
                1248,
                1249,
                1250,
                1251,
                1252,
                1253,
                1254,
                1255,
                1256,
                1257,
                1258
              ],
              "provinces": [
                {
                  "label": "萨克森自由州",
                  "value": 1247
                },
                {
                  "label": "巴伐利亚州",
                  "value": 1248
                },
                {
                  "label": "北莱茵－威斯特法伦州",
                  "value": 1249
                },
                {
                  "label": "汉堡",
                  "value": 1250
                },
                {
                  "label": "勃兰登堡州",
                  "value": 1251
                },
                {
                  "label": "巴登－符腾堡州",
                  "value": 1252
                },
                {
                  "label": "下萨克森州",
                  "value": 1253
                },
                {
                  "label": "柏林",
                  "value": 1254
                },
                {
                  "label": "莱茵兰－普法尔茨州",
                  "value": 1255
                },
                {
                  "label": "德国",
                  "value": 1256
                },
                {
                  "label": "黑森州",
                  "value": 1257
                },
                {
                  "label": "石勒苏益格－荷尔斯泰因州",
                  "value": 1258
                }
              ]
            },
            {
              "country_code": 156,
              "country_name_ch": "英国",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/UK.svg",
              "cityIds": [
                1370,
                1371,
                1372,
                1373,
                1374,
                1375,
                1376,
                1377,
                1378,
                1379,
                1380,
                1381,
                1382,
                1383,
                1384,
                1385,
                1386,
                1387,
                1388,
                1389,
                1390,
                1391,
                1392
              ],
              "provinces": [
                {
                  "label": "斯劳",
                  "value": 1370
                },
                {
                  "label": "朴茨茅斯",
                  "value": 1371
                },
                {
                  "label": "埃塞克斯郡",
                  "value": 1372
                },
                {
                  "label": "考文垂",
                  "value": 1373
                },
                {
                  "label": "德文郡",
                  "value": 1374
                },
                {
                  "label": "曼彻斯特",
                  "value": 1375
                },
                {
                  "label": "苏格兰",
                  "value": 1376
                },
                {
                  "label": "西柴郡与切斯特",
                  "value": 1377
                },
                {
                  "label": "威尔士",
                  "value": 1378
                },
                {
                  "label": "诺福克郡",
                  "value": 1379
                },
                {
                  "label": "中央贝德福",
                  "value": 1380
                },
                {
                  "label": "卡尔德达尔",
                  "value": 1381
                },
                {
                  "label": "伦敦",
                  "value": 1382
                },
                {
                  "label": "伍斯特郡",
                  "value": 1383
                },
                {
                  "label": "伯明翰",
                  "value": 1384
                },
                {
                  "label": "温莎和梅登黑德",
                  "value": 1385
                },
                {
                  "label": "米尔顿凯恩斯",
                  "value": 1386
                },
                {
                  "label": "谢菲尔德区",
                  "value": 1387
                },
                {
                  "label": "西北英格兰",
                  "value": 1388
                },
                {
                  "label": "肯特郡",
                  "value": 1389
                },
                {
                  "label": "英国",
                  "value": 1390
                },
                {
                  "label": "汉普郡",
                  "value": 1391
                },
                {
                  "label": "北林肯郡",
                  "value": 1392
                }
              ]
            },
            {
              "country_code": 125,
              "country_name_ch": "丹麦",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Denmark.svg",
              "cityIds": [
                1185,
                1186,
                1187
              ],
              "provinces": [
                {
                  "label": "首都大区",
                  "value": 1185
                },
                {
                  "label": "中日德兰大区",
                  "value": 1186
                },
                {
                  "label": "丹麦",
                  "value": 1187
                }
              ]
            },
            {
              "country_code": 157,
              "country_name_ch": "摩洛哥",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Morocco.svg",
              "cityIds": [
                1393,
                1394,
                1395,
                1396,
                1397,
                1398,
                1399,
                1400,
                1401,
                1402
              ],
              "provinces": [
                {
                  "label": "丹吉尔－得土安－胡塞马大区",
                  "value": 1393
                },
                {
                  "label": "摩洛哥",
                  "value": 1394
                },
                {
                  "label": "苏斯－马塞大区",
                  "value": 1395
                },
                {
                  "label": "卡萨布兰卡－塞塔特大区",
                  "value": 1396
                },
                {
                  "label": "贝尼迈拉勒－海尼夫拉大区",
                  "value": 1397
                },
                {
                  "label": "阿尤恩－萨基亚－阿姆拉大区",
                  "value": 1398
                },
                {
                  "label": "马拉喀什－萨菲大区",
                  "value": 1399
                },
                {
                  "label": "非斯－梅克内斯大区",
                  "value": 1400
                },
                {
                  "label": "东部大区",
                  "value": 1401
                },
                {
                  "label": "拉巴特－塞拉－盖尼特拉大区",
                  "value": 1402
                }
              ]
            },
            {
              "country_code": 81,
              "country_name_ch": "西班牙",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Spain.svg",
              "cityIds": [
                848,
                849,
                850,
                851,
                852,
                853,
                854,
                855,
                856,
                857,
                858
              ],
              "provinces": [
                {
                  "label": "卡斯蒂利亚－拉曼恰自治区",
                  "value": 848
                },
                {
                  "label": "巴斯克自治区",
                  "value": 849
                },
                {
                  "label": "拉里奥哈自治区",
                  "value": 850
                },
                {
                  "label": "阿拉贡自治区",
                  "value": 851
                },
                {
                  "label": "马德里自治区",
                  "value": 852
                },
                {
                  "label": "安达卢西亚自治区",
                  "value": 853
                },
                {
                  "label": "加泰罗尼亚自治区",
                  "value": 854
                },
                {
                  "label": "加那利群岛自治区",
                  "value": 855
                },
                {
                  "label": "加利西亚自治区",
                  "value": 856
                },
                {
                  "label": "西班牙",
                  "value": 857
                },
                {
                  "label": "瓦伦西亚自治区",
                  "value": 858
                }
              ]
            },
            {
              "country_code": 16,
              "country_name_ch": "澳大利亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Australia.svg",
              "cityIds": [
                139,
                140,
                141,
                142,
                143,
                144
              ],
              "provinces": [
                {
                  "label": "新南威尔士州",
                  "value": 139
                },
                {
                  "label": "昆士兰州",
                  "value": 140
                },
                {
                  "label": "西澳大利亚州",
                  "value": 141
                },
                {
                  "label": "南澳大利亚州",
                  "value": 142
                },
                {
                  "label": "澳大利亚",
                  "value": 143
                },
                {
                  "label": "维多利亚州",
                  "value": 144
                }
              ]
            },
            {
              "country_code": 103,
              "country_name_ch": "萨尔瓦多",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/ElSalvador.svg",
              "cityIds": [
                1017,
                1018,
                1019,
                1020,
                1021,
                1022
              ],
              "provinces": [
                {
                  "label": "乌苏卢坦省",
                  "value": 1017
                },
                {
                  "label": "拉利伯塔德省",
                  "value": 1018
                },
                {
                  "label": "圣米格尔省",
                  "value": 1019
                },
                {
                  "label": "圣萨尔瓦多省",
                  "value": 1020
                },
                {
                  "label": "萨尔瓦多",
                  "value": 1021
                },
                {
                  "label": "阿瓦查潘省",
                  "value": 1022
                }
              ]
            },
            {
              "country_code": 24,
              "country_name_ch": "墨西哥",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Mexico.svg",
              "cityIds": [
                204,
                205,
                206,
                207,
                208,
                209,
                210,
                211,
                212,
                213,
                214,
                215,
                216,
                217,
                218,
                219,
                220,
                221,
                222,
                223,
                224,
                225,
                226,
                227,
                228,
                229,
                230,
                231,
                232,
                233,
                234,
                235,
                236
              ],
              "provinces": [
                {
                  "label": "科阿韦拉州",
                  "value": 204
                },
                {
                  "label": "瓦哈卡州",
                  "value": 205
                },
                {
                  "label": "坎佩切州",
                  "value": 206
                },
                {
                  "label": "塔巴斯科州",
                  "value": 207
                },
                {
                  "label": "普埃布拉州",
                  "value": 208
                },
                {
                  "label": "伊达戈州",
                  "value": 209
                },
                {
                  "label": "科利马州",
                  "value": 210
                },
                {
                  "label": "墨西哥",
                  "value": 211
                },
                {
                  "label": "索诺拉州",
                  "value": 212
                },
                {
                  "label": "韦拉克鲁斯州",
                  "value": 213
                },
                {
                  "label": "新莱昂州",
                  "value": 214
                },
                {
                  "label": "下加利福尼亚州",
                  "value": 215
                },
                {
                  "label": "阿瓜斯卡达特斯州",
                  "value": 216
                },
                {
                  "label": "瓜纳华托州",
                  "value": 217
                },
                {
                  "label": "墨西哥联邦区",
                  "value": 218
                },
                {
                  "label": "纳亚里特州",
                  "value": 219
                },
                {
                  "label": "尤卡坦州",
                  "value": 220
                },
                {
                  "label": "西那罗阿州",
                  "value": 221
                },
                {
                  "label": "塔毛利帕斯州",
                  "value": 222
                },
                {
                  "label": "特拉斯卡拉州",
                  "value": 223
                },
                {
                  "label": "奇瓦瓦州",
                  "value": 224
                },
                {
                  "label": "恰帕斯州",
                  "value": 225
                },
                {
                  "label": "米却肯州",
                  "value": 226
                },
                {
                  "label": "墨西哥州",
                  "value": 227
                },
                {
                  "label": "萨卡特卡斯州",
                  "value": 228
                },
                {
                  "label": "圣路易斯波托西州",
                  "value": 229
                },
                {
                  "label": "金塔纳罗奥州",
                  "value": 230
                },
                {
                  "label": "哈利斯科州",
                  "value": 231
                },
                {
                  "label": "克雷塔罗州",
                  "value": 232
                },
                {
                  "label": "莫雷洛斯州",
                  "value": 233
                },
                {
                  "label": "格雷罗州",
                  "value": 234
                },
                {
                  "label": "杜兰戈州",
                  "value": 235
                },
                {
                  "label": "南下加利福尼亚州",
                  "value": 236
                }
              ]
            },
            {
              "country_code": 120,
              "country_name_ch": "突尼斯",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Tunisia.svg",
              "cityIds": [
                1148,
                1149,
                1150,
                1151,
                1152,
                1153,
                1154,
                1155,
                1156,
                1157,
                1158,
                1159,
                1160,
                1161,
                1162,
                1163,
                1164,
                1165,
                1166,
                1167
              ],
              "provinces": [
                {
                  "label": "托泽尔省",
                  "value": 1148
                },
                {
                  "label": "西迪布济德省",
                  "value": 1149
                },
                {
                  "label": "巴杰省",
                  "value": 1150
                },
                {
                  "label": "马赫迪耶省",
                  "value": 1151
                },
                {
                  "label": "艾尔亚内省",
                  "value": 1152
                },
                {
                  "label": "卡夫省",
                  "value": 1153
                },
                {
                  "label": "加贝斯省",
                  "value": 1154
                },
                {
                  "label": "突尼斯省",
                  "value": 1155
                },
                {
                  "label": "莫纳斯提尔省",
                  "value": 1156
                },
                {
                  "label": "本阿鲁斯省",
                  "value": 1157
                },
                {
                  "label": "吉比利省",
                  "value": 1158
                },
                {
                  "label": "加夫萨省",
                  "value": 1159
                },
                {
                  "label": "苏塞省",
                  "value": 1160
                },
                {
                  "label": "梅德宁省",
                  "value": 1161
                },
                {
                  "label": "比塞大省",
                  "value": 1162
                },
                {
                  "label": "凯鲁万省",
                  "value": 1163
                },
                {
                  "label": "斯法克斯省",
                  "value": 1164
                },
                {
                  "label": "坚杜拜省",
                  "value": 1165
                },
                {
                  "label": "突尼斯",
                  "value": 1166
                },
                {
                  "label": "纳布勒省",
                  "value": 1167
                }
              ]
            },
            {
              "country_code": 138,
              "country_name_ch": "安哥拉",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Angola.svg",
              "cityIds": [
                1259,
                1260
              ],
              "provinces": [
                {
                  "label": "安哥拉",
                  "value": 1259
                },
                {
                  "label": "罗安达省",
                  "value": 1260
                }
              ]
            },
            {
              "country_code": 3,
              "country_name_ch": "波兰",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Poland.svg",
              "cityIds": [
                32,
                33,
                34,
                35,
                36,
                37,
                38,
                39,
                40,
                41,
                42,
                43,
                44,
                45,
                46,
                47,
                48
              ],
              "provinces": [
                {
                  "label": "马佐夫舍省",
                  "value": 32
                },
                {
                  "label": "波兰",
                  "value": 33
                },
                {
                  "label": "西里西亚省",
                  "value": 34
                },
                {
                  "label": "大波兰省",
                  "value": 35
                },
                {
                  "label": "西波美拉尼亚省",
                  "value": 36
                },
                {
                  "label": "奥波莱省",
                  "value": 37
                },
                {
                  "label": "瓦尔米亚－马祖里省",
                  "value": 38
                },
                {
                  "label": "波德拉谢省",
                  "value": 39
                },
                {
                  "label": "罗兹省",
                  "value": 40
                },
                {
                  "label": "库亚维－波美拉尼亚省",
                  "value": 41
                },
                {
                  "label": "下西里西亚省",
                  "value": 42
                },
                {
                  "label": "小波兰省",
                  "value": 43
                },
                {
                  "label": "鲁布斯卡省",
                  "value": 44
                },
                {
                  "label": "卢布林省",
                  "value": 45
                },
                {
                  "label": "喀尔巴阡山省",
                  "value": 46
                },
                {
                  "label": "滨海省",
                  "value": 47
                },
                {
                  "label": "圣十字省",
                  "value": 48
                }
              ]
            },
            {
              "country_code": 35,
              "country_name_ch": "罗马尼亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Romania.svg",
              "cityIds": [
                345,
                346,
                347,
                348,
                349,
                350,
                351,
                352,
                353,
                354,
                355,
                356,
                357,
                358,
                359,
                360,
                361,
                362,
                363,
                364,
                365,
                366,
                367,
                368,
                369,
                370,
                371,
                372,
                373,
                374,
                375,
                376,
                377,
                378,
                379,
                380,
                381,
                382,
                383,
                384,
                385,
                386
              ],
              "provinces": [
                {
                  "label": "比斯特里察－讷瑟乌德县",
                  "value": 345
                },
                {
                  "label": "伊尔福夫县",
                  "value": 346
                },
                {
                  "label": "科瓦斯纳县",
                  "value": 347
                },
                {
                  "label": "克勒拉希县",
                  "value": 348
                },
                {
                  "label": "布加勒斯特",
                  "value": 349
                },
                {
                  "label": "瓦斯卢伊县",
                  "value": 350
                },
                {
                  "label": "博托沙尼县",
                  "value": 351
                },
                {
                  "label": "图尔恰县",
                  "value": 352
                },
                {
                  "label": "克卢日县",
                  "value": 353
                },
                {
                  "label": "布泽乌县",
                  "value": 354
                },
                {
                  "label": "雅洛米察县",
                  "value": 355
                },
                {
                  "label": "奥尔特县",
                  "value": 356
                },
                {
                  "label": "穆列什县",
                  "value": 357
                },
                {
                  "label": "登博维察县",
                  "value": 358
                },
                {
                  "label": "沃尔恰县",
                  "value": 359
                },
                {
                  "label": "加拉茨县",
                  "value": 360
                },
                {
                  "label": "哈尔吉塔县",
                  "value": 361
                },
                {
                  "label": "巴克乌县",
                  "value": 362
                },
                {
                  "label": "特列奥尔曼县",
                  "value": 363
                },
                {
                  "label": "雅西县",
                  "value": 364
                },
                {
                  "label": "胡内多阿拉县",
                  "value": 365
                },
                {
                  "label": "罗马尼亚",
                  "value": 366
                },
                {
                  "label": "布勒伊拉县",
                  "value": 367
                },
                {
                  "label": "萨图马雷县",
                  "value": 368
                },
                {
                  "label": "卡拉什－塞维林县",
                  "value": 369
                },
                {
                  "label": "阿拉德县",
                  "value": 370
                },
                {
                  "label": "布拉索夫县",
                  "value": 371
                },
                {
                  "label": "阿尔杰什县",
                  "value": 372
                },
                {
                  "label": "康斯坦察县",
                  "value": 373
                },
                {
                  "label": "弗朗恰县",
                  "value": 374
                },
                {
                  "label": "比霍尔县",
                  "value": 375
                },
                {
                  "label": "锡比乌县",
                  "value": 376
                },
                {
                  "label": "尼亚姆茨县",
                  "value": 377
                },
                {
                  "label": "马拉穆列什县",
                  "value": 378
                },
                {
                  "label": "瑟拉日县",
                  "value": 379
                },
                {
                  "label": "多尔日县",
                  "value": 380
                },
                {
                  "label": "普拉霍瓦县",
                  "value": 381
                },
                {
                  "label": "戈尔日县",
                  "value": 382
                },
                {
                  "label": "阿尔巴县",
                  "value": 383
                },
                {
                  "label": "蒂米什县",
                  "value": 384
                },
                {
                  "label": "梅赫丁茨县",
                  "value": 385
                },
                {
                  "label": "苏恰瓦县",
                  "value": 386
                }
              ]
            },
            {
              "country_code": 36,
              "country_name_ch": "阿根廷",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Argentina.svg",
              "cityIds": [
                387,
                388,
                389,
                390,
                391,
                392,
                393,
                394,
                395,
                396,
                397,
                398,
                399,
                400,
                401,
                402,
                403,
                404,
                405,
                406,
                407,
                408,
                409,
                410,
                411
              ],
              "provinces": [
                {
                  "label": "福莫萨省",
                  "value": 387
                },
                {
                  "label": "布宜诺斯艾利斯",
                  "value": 388
                },
                {
                  "label": "恩特雷里奥斯省",
                  "value": 389
                },
                {
                  "label": "圣地亚哥－德尔埃斯特罗省",
                  "value": 390
                },
                {
                  "label": "圣路易斯省",
                  "value": 391
                },
                {
                  "label": "丘布特省",
                  "value": 392
                },
                {
                  "label": "拉里奥哈省",
                  "value": 393
                },
                {
                  "label": "阿根廷",
                  "value": 394
                },
                {
                  "label": "火地省",
                  "value": 395
                },
                {
                  "label": "科尔多瓦省",
                  "value": 396
                },
                {
                  "label": "查科省",
                  "value": 397
                },
                {
                  "label": "布宜诺斯艾利斯省",
                  "value": 398
                },
                {
                  "label": "圣菲省",
                  "value": 399
                },
                {
                  "label": "图库曼省",
                  "value": 400
                },
                {
                  "label": "圣克鲁斯省",
                  "value": 401
                },
                {
                  "label": "科连特斯省",
                  "value": 402
                },
                {
                  "label": "胡胡伊省",
                  "value": 403
                },
                {
                  "label": "内乌肯省",
                  "value": 404
                },
                {
                  "label": "米西奥内斯省",
                  "value": 405
                },
                {
                  "label": "圣胡安省",
                  "value": 406
                },
                {
                  "label": "卡塔马卡省",
                  "value": 407
                },
                {
                  "label": "内格罗河省",
                  "value": 408
                },
                {
                  "label": "门多萨省",
                  "value": 409
                },
                {
                  "label": "拉潘帕省",
                  "value": 410
                },
                {
                  "label": "萨尔塔省",
                  "value": 411
                }
              ]
            },
            {
              "country_code": 47,
              "country_name_ch": "哥伦比亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Colombia.svg",
              "cityIds": [
                513,
                514,
                515,
                516,
                517,
                518,
                519,
                520,
                521,
                522,
                523,
                524,
                525,
                526,
                527,
                528,
                529,
                530,
                531,
                532,
                533,
                534,
                535,
                536,
                537,
                538,
                539,
                540,
                541,
                542,
                543
              ],
              "provinces": [
                {
                  "label": "卡尔达斯省",
                  "value": 513
                },
                {
                  "label": "考卡省",
                  "value": 514
                },
                {
                  "label": "普图马约省",
                  "value": 515
                },
                {
                  "label": "苏克雷省",
                  "value": 516
                },
                {
                  "label": "卡萨纳雷省",
                  "value": 517
                },
                {
                  "label": "波利瓦尔省",
                  "value": 518
                },
                {
                  "label": "考卡山谷省",
                  "value": 519
                },
                {
                  "label": "金迪奥省",
                  "value": 520
                },
                {
                  "label": "乌伊拉省",
                  "value": 521
                },
                {
                  "label": "马格达莱纳省",
                  "value": 522
                },
                {
                  "label": "安蒂奥基亚省",
                  "value": 523
                },
                {
                  "label": "波哥大首都区",
                  "value": 524
                },
                {
                  "label": "瓜维亚雷省",
                  "value": 525
                },
                {
                  "label": "博亚卡省",
                  "value": 526
                },
                {
                  "label": "科尔多瓦省",
                  "value": 527
                },
                {
                  "label": "乔科省",
                  "value": 528
                },
                {
                  "label": "梅塔省",
                  "value": 529
                },
                {
                  "label": "里萨拉尔达省",
                  "value": 530
                },
                {
                  "label": "圣安德列斯－普罗维登西亚和圣卡塔利娜群岛省",
                  "value": 531
                },
                {
                  "label": "卡克塔省",
                  "value": 532
                },
                {
                  "label": "阿劳卡省",
                  "value": 533
                },
                {
                  "label": "昆迪纳马卡省",
                  "value": 534
                },
                {
                  "label": "塞萨尔省",
                  "value": 535
                },
                {
                  "label": "北桑坦德省",
                  "value": 536
                },
                {
                  "label": "哥伦比亚",
                  "value": 537
                },
                {
                  "label": "纳里尼奥省",
                  "value": 538
                },
                {
                  "label": "亚马逊省",
                  "value": 539
                },
                {
                  "label": "桑坦德省",
                  "value": 540
                },
                {
                  "label": "大西洋省",
                  "value": 541
                },
                {
                  "label": "托利马省",
                  "value": 542
                },
                {
                  "label": "瓜希拉省",
                  "value": 543
                }
              ]
            },
            {
              "country_code": 54,
              "country_name_ch": "委内瑞拉",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Venezuela.svg",
              "cityIds": [
                553,
                554,
                555,
                556,
                557,
                558,
                559,
                560,
                561,
                562,
                563,
                564,
                565,
                566,
                567,
                568,
                569,
                570,
                571,
                572,
                573
              ],
              "provinces": [
                {
                  "label": "塔奇拉州",
                  "value": 553
                },
                {
                  "label": "特鲁希略州",
                  "value": 554
                },
                {
                  "label": "苏利亚州",
                  "value": 555
                },
                {
                  "label": "卡拉沃沃州",
                  "value": 556
                },
                {
                  "label": "法尔孔州",
                  "value": 557
                },
                {
                  "label": "莫纳加斯州",
                  "value": 558
                },
                {
                  "label": "阿普雷州",
                  "value": 559
                },
                {
                  "label": "瓦尔加斯州",
                  "value": 560
                },
                {
                  "label": "安索阿特吉州",
                  "value": 561
                },
                {
                  "label": "新埃斯帕塔州",
                  "value": 562
                },
                {
                  "label": "波图格萨州",
                  "value": 563
                },
                {
                  "label": "玻利瓦尔州",
                  "value": 564
                },
                {
                  "label": "阿拉瓜州",
                  "value": 565
                },
                {
                  "label": "巴里纳斯州",
                  "value": 566
                },
                {
                  "label": "瓜里科州",
                  "value": 567
                },
                {
                  "label": "米兰达州",
                  "value": 568
                },
                {
                  "label": "苏克雷州",
                  "value": 569
                },
                {
                  "label": "加拉加斯",
                  "value": 570
                },
                {
                  "label": "委内瑞拉",
                  "value": 571
                },
                {
                  "label": "拉腊州",
                  "value": 572
                },
                {
                  "label": "梅里达州",
                  "value": 573
                }
              ]
            },
            {
              "country_code": 87,
              "country_name_ch": "爱尔兰",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Ireland.svg",
              "cityIds": [
                911,
                912
              ],
              "provinces": [
                {
                  "label": "都柏林郡",
                  "value": 911
                },
                {
                  "label": "爱尔兰",
                  "value": 912
                }
              ]
            },
            {
              "country_code": 9,
              "country_name_ch": "秘鲁",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Peru.svg",
              "cityIds": [
                87,
                88,
                89,
                90,
                91,
                92,
                93,
                94,
                95,
                96,
                97,
                98,
                99,
                100,
                101,
                102,
                103,
                104,
                105,
                106,
                107,
                108,
                109,
                110,
                111
              ],
              "provinces": [
                {
                  "label": "利马大区",
                  "value": 87
                },
                {
                  "label": "莫克瓜大区",
                  "value": 88
                },
                {
                  "label": "伊卡大区",
                  "value": 89
                },
                {
                  "label": "卡亚俄大区",
                  "value": 90
                },
                {
                  "label": "利马省",
                  "value": 91
                },
                {
                  "label": "秘鲁",
                  "value": 92
                },
                {
                  "label": "安卡什大区",
                  "value": 93
                },
                {
                  "label": "兰巴耶克大区",
                  "value": 94
                },
                {
                  "label": "圣马丁大区",
                  "value": 95
                },
                {
                  "label": "塔克纳大区",
                  "value": 96
                },
                {
                  "label": "卡哈马卡大区",
                  "value": 97
                },
                {
                  "label": "库斯科大区",
                  "value": 98
                },
                {
                  "label": "胡宁大区",
                  "value": 99
                },
                {
                  "label": "皮乌拉大区",
                  "value": 100
                },
                {
                  "label": "拉利伯塔德大区",
                  "value": 101
                },
                {
                  "label": "乌卡亚利大区",
                  "value": 102
                },
                {
                  "label": "亚马孙大区",
                  "value": 103
                },
                {
                  "label": "万卡韦利卡大区",
                  "value": 104
                },
                {
                  "label": "马德雷德迪奥斯大区",
                  "value": 105
                },
                {
                  "label": "阿雷基帕大区",
                  "value": 106
                },
                {
                  "label": "阿亚库乔大区",
                  "value": 107
                },
                {
                  "label": "瓦努科大区",
                  "value": 108
                },
                {
                  "label": "洛雷托大区",
                  "value": 109
                },
                {
                  "label": "通贝斯大区",
                  "value": 110
                },
                {
                  "label": "普诺大区",
                  "value": 111
                }
              ]
            },
            {
              "country_code": 14,
              "country_name_ch": "白俄罗斯",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Belarus.svg",
              "cityIds": [
                132,
                133,
                134,
                135,
                136
              ],
              "provinces": [
                {
                  "label": "明斯克",
                  "value": 132
                },
                {
                  "label": "维捷布斯克州",
                  "value": 133
                },
                {
                  "label": "戈梅利州",
                  "value": 134
                },
                {
                  "label": "布列斯特州",
                  "value": 135
                },
                {
                  "label": "格罗德诺州",
                  "value": 136
                }
              ]
            },
            {
              "country_code": 43,
              "country_name_ch": "尼日利亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Nigeria.svg",
              "cityIds": [
                440,
                441,
                442
              ],
              "provinces": [
                {
                  "label": "尼日利亚",
                  "value": 440
                },
                {
                  "label": "包奇州",
                  "value": 441
                },
                {
                  "label": "拉各斯州",
                  "value": 442
                }
              ]
            },
            {
              "country_code": 48,
              "country_name_ch": "乌干达",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Uganda.svg",
              "cityIds": [
                544,
                545
              ],
              "provinces": [
                {
                  "label": "乌干达",
                  "value": 544
                },
                {
                  "label": "坎帕拉",
                  "value": 545
                }
              ]
            },
            {
              "country_code": 66,
              "country_name_ch": "缅甸",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Myanmar.svg",
              "cityIds": [
                705,
                706,
                707,
                708,
                709,
                710,
                711,
                712,
                713,
                714,
                715,
                716
              ],
              "provinces": [
                {
                  "label": "内比都联邦区",
                  "value": 705
                },
                {
                  "label": "掸邦",
                  "value": 706
                },
                {
                  "label": "伊洛瓦底省",
                  "value": 707
                },
                {
                  "label": "勃固省",
                  "value": 708
                },
                {
                  "label": "仰光省",
                  "value": 709
                },
                {
                  "label": "德林达依省",
                  "value": 710
                },
                {
                  "label": "马圭省",
                  "value": 711
                },
                {
                  "label": "缅甸",
                  "value": 712
                },
                {
                  "label": "克伦邦",
                  "value": 713
                },
                {
                  "label": "实皆省",
                  "value": 714
                },
                {
                  "label": "孟邦",
                  "value": 715
                },
                {
                  "label": "曼德勒省",
                  "value": 716
                }
              ]
            },
            {
              "country_code": 71,
              "country_name_ch": "立陶宛",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Lithuania.svg",
              "cityIds": [
                734,
                735,
                736,
                737,
                738,
                739,
                740
              ],
              "provinces": [
                {
                  "label": "维尔纽斯县",
                  "value": 734
                },
                {
                  "label": "克莱佩达县",
                  "value": 735
                },
                {
                  "label": "乌田纳县",
                  "value": 736
                },
                {
                  "label": "帕涅韦日斯县",
                  "value": 737
                },
                {
                  "label": "立陶宛",
                  "value": 738
                },
                {
                  "label": "考纳斯县",
                  "value": 739
                },
                {
                  "label": "希奥利艾县",
                  "value": 740
                }
              ]
            },
            {
              "country_code": 143,
              "country_name_ch": "柬埔寨",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Cambodia.svg",
              "cityIds": [
                1276,
                1277,
                1278,
                1279,
                1280,
                1281,
                1282,
                1283
              ],
              "provinces": [
                {
                  "label": "暹粒省",
                  "value": 1276
                },
                {
                  "label": "柴桢省",
                  "value": 1277
                },
                {
                  "label": "西哈努克省",
                  "value": 1278
                },
                {
                  "label": "马德望省",
                  "value": 1279
                },
                {
                  "label": "甘丹省",
                  "value": 1280
                },
                {
                  "label": "柬埔寨",
                  "value": 1281
                },
                {
                  "label": "班迭棉吉省",
                  "value": 1282
                },
                {
                  "label": "金边",
                  "value": 1283
                }
              ]
            },
            {
              "country_code": 148,
              "country_name_ch": "利比亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Libya.svg",
              "cityIds": [
                1302,
                1303,
                1304,
                1305,
                1306,
                1307,
                1308,
                1309,
                1310,
                1311,
                1312,
                1313,
                1314,
                1315,
                1316,
                1317
              ],
              "provinces": [
                {
                  "label": "迈尔盖卜省",
                  "value": 1302
                },
                {
                  "label": "布特南省",
                  "value": 1303
                },
                {
                  "label": "纳卢特省",
                  "value": 1304
                },
                {
                  "label": "德尔纳省",
                  "value": 1305
                },
                {
                  "label": "班加西省",
                  "value": 1306
                },
                {
                  "label": "朱夫拉省",
                  "value": 1307
                },
                {
                  "label": "绿洲省",
                  "value": 1308
                },
                {
                  "label": "苏尔特省",
                  "value": 1309
                },
                {
                  "label": "扎维耶省",
                  "value": 1310
                },
                {
                  "label": "努加特海姆斯省",
                  "value": 1311
                },
                {
                  "label": "米苏拉塔省",
                  "value": 1312
                },
                {
                  "label": "的黎波里省",
                  "value": 1313
                },
                {
                  "label": "西山省",
                  "value": 1314
                },
                {
                  "label": "绿山省",
                  "value": 1315
                },
                {
                  "label": "迈尔季省",
                  "value": 1316
                },
                {
                  "label": "利比亚",
                  "value": 1317
                }
              ]
            },
            {
              "country_code": 149,
              "country_name_ch": "荷兰",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Netherlands.svg",
              "cityIds": [
                1318,
                1319,
                1320,
                1321,
                1322,
                1323,
                1324,
                1325,
                1326,
                1327
              ],
              "provinces": [
                {
                  "label": "北荷兰省",
                  "value": 1318
                },
                {
                  "label": "海尔德兰省",
                  "value": 1319
                },
                {
                  "label": "乌得勒支省",
                  "value": 1320
                },
                {
                  "label": "北布拉班特省",
                  "value": 1321
                },
                {
                  "label": "南荷兰省",
                  "value": 1322
                },
                {
                  "label": "林堡省",
                  "value": 1323
                },
                {
                  "label": "上艾瑟尔省",
                  "value": 1324
                },
                {
                  "label": "荷兰",
                  "value": 1325
                },
                {
                  "label": "弗莱福兰省",
                  "value": 1326
                },
                {
                  "label": "德伦特省",
                  "value": 1327
                }
              ]
            },
            {
              "country_code": 158,
              "country_name_ch": "越南",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Vietnam.svg",
              "cityIds": [
                1403,
                1404,
                1405,
                1406,
                1407,
                1408,
                1409,
                1410,
                1411,
                1412,
                1413,
                1414,
                1415,
                1416,
                1417,
                1418,
                1419,
                1420,
                1421,
                1422,
                1423,
                1424,
                1425,
                1426,
                1427,
                1428,
                1429,
                1430,
                1431
              ],
              "provinces": [
                {
                  "label": "隆安省",
                  "value": 1403
                },
                {
                  "label": "海防市",
                  "value": 1404
                },
                {
                  "label": "平阳省",
                  "value": 1405
                },
                {
                  "label": "平定省",
                  "value": 1406
                },
                {
                  "label": "河南省",
                  "value": 1407
                },
                {
                  "label": "海阳省",
                  "value": 1408
                },
                {
                  "label": "前江省",
                  "value": 1409
                },
                {
                  "label": "朔庄省",
                  "value": 1410
                },
                {
                  "label": "岘港市",
                  "value": 1411
                },
                {
                  "label": "北部地区",
                  "value": 1412
                },
                {
                  "label": "太原省",
                  "value": 1413
                },
                {
                  "label": "芹苴市",
                  "value": 1414
                },
                {
                  "label": "庆和省",
                  "value": 1415
                },
                {
                  "label": "河静省",
                  "value": 1416
                },
                {
                  "label": "南部地区",
                  "value": 1417
                },
                {
                  "label": "同奈省",
                  "value": 1418
                },
                {
                  "label": "同塔省",
                  "value": 1419
                },
                {
                  "label": "安江省",
                  "value": 1420
                },
                {
                  "label": "得乐省",
                  "value": 1421
                },
                {
                  "label": "平顺省",
                  "value": 1422
                },
                {
                  "label": "西宁省",
                  "value": 1423
                },
                {
                  "label": "河内市",
                  "value": 1424
                },
                {
                  "label": "富寿省",
                  "value": 1425
                },
                {
                  "label": "胡志明市",
                  "value": 1426
                },
                {
                  "label": "金瓯省",
                  "value": 1427
                },
                {
                  "label": "茶荣省",
                  "value": 1428
                },
                {
                  "label": "太平省",
                  "value": 1429
                },
                {
                  "label": "广治省",
                  "value": 1430
                },
                {
                  "label": "越南",
                  "value": 1431
                }
              ]
            },
            {
              "country_code": 165,
              "country_name_ch": "巴巴多斯",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Barbados.svg",
              "cityIds": [
                1509
              ],
              "provinces": [
                {
                  "label": "巴巴多斯",
                  "value": 1509
                }
              ]
            },
            {
              "country_code": 4,
              "country_name_ch": "格鲁吉亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Georgia.svg",
              "cityIds": [
                49,
                50,
                51,
                52,
                53,
                54,
                55,
                56,
                57,
                58,
                59
              ],
              "provinces": [
                {
                  "label": "阿布哈兹共和国",
                  "value": 49
                },
                {
                  "label": "姆茨赫塔－姆季阿涅季州",
                  "value": 50
                },
                {
                  "label": "克维莫－卡特利州",
                  "value": 51
                },
                {
                  "label": "伊梅列季州",
                  "value": 52
                },
                {
                  "label": "古利亚州",
                  "value": 53
                },
                {
                  "label": "什达－卡特利州",
                  "value": 54
                },
                {
                  "label": "格鲁吉亚",
                  "value": 55
                },
                {
                  "label": "阿扎尔自治共和国",
                  "value": 56
                },
                {
                  "label": "萨梅格列罗－上斯瓦涅季亚州",
                  "value": 57
                },
                {
                  "label": "第比利斯",
                  "value": 58
                },
                {
                  "label": "卡赫季州",
                  "value": 59
                }
              ]
            },
            {
              "country_code": 5,
              "country_name_ch": "特立尼达和多巴哥",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/TrinidadAndTobago.svg",
              "cityIds": [
                60,
                61,
                62,
                63,
                64,
                65,
                66
              ],
              "provinces": [
                {
                  "label": "波因特福廷",
                  "value": 60
                },
                {
                  "label": "特立尼达和多巴哥",
                  "value": 61
                },
                {
                  "label": "西班牙港",
                  "value": 62
                },
                {
                  "label": "王子镇地区",
                  "value": 63
                },
                {
                  "label": "图纳普纳－皮亚尔科地区",
                  "value": 64
                },
                {
                  "label": "锡帕里亚地区",
                  "value": 65
                },
                {
                  "label": "大桑格雷地区",
                  "value": 66
                }
              ]
            },
            {
              "country_code": 6,
              "country_name_ch": "阿鲁巴",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Aruba.svg",
              "cityIds": [
                67
              ],
              "provinces": [
                {
                  "label": "阿鲁巴",
                  "value": 67
                }
              ]
            },
            {
              "country_code": 10,
              "country_name_ch": "斯洛文尼亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Slovenia.svg",
              "cityIds": [
                112,
                113,
                114,
                115
              ],
              "provinces": [
                {
                  "label": "斯洛文尼亚格拉代茨市",
                  "value": 112
                },
                {
                  "label": "穆尔斯卡索博塔市",
                  "value": 113
                },
                {
                  "label": "卢布尔雅那",
                  "value": 114
                },
                {
                  "label": "斯洛文尼亚",
                  "value": 115
                }
              ]
            },
            {
              "country_code": 11,
              "country_name_ch": "玻利维亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Bolivia.svg",
              "cityIds": [
                116,
                117,
                118,
                119,
                120,
                121,
                122
              ],
              "provinces": [
                {
                  "label": "圣克鲁斯省",
                  "value": 116
                },
                {
                  "label": "潘多省",
                  "value": 117
                },
                {
                  "label": "贝尼省",
                  "value": 118
                },
                {
                  "label": "奥鲁罗省",
                  "value": 119
                },
                {
                  "label": "科恰班巴省",
                  "value": 120
                },
                {
                  "label": "拉巴斯省",
                  "value": 121
                },
                {
                  "label": "玻利维亚",
                  "value": 122
                }
              ]
            },
            {
              "country_code": 12,
              "country_name_ch": "多米尼克",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Dominica.svg",
              "cityIds": [
                123
              ],
              "provinces": [
                {
                  "label": "多米尼克",
                  "value": 123
                }
              ]
            },
            {
              "country_code": 15,
              "country_name_ch": "马拉维",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Malawi.svg",
              "cityIds": [
                137,
                138
              ],
              "provinces": [
                {
                  "label": "中央区",
                  "value": 137
                },
                {
                  "label": "南部区",
                  "value": 138
                }
              ]
            },
            {
              "country_code": 17,
              "country_name_ch": "卡塔尔",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Qatar.svg",
              "cityIds": [
                145,
                146
              ],
              "provinces": [
                {
                  "label": "卡塔尔",
                  "value": 145
                },
                {
                  "label": "多哈",
                  "value": 146
                }
              ]
            },
            {
              "country_code": 18,
              "country_name_ch": "塞尔维亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Serbia.svg",
              "cityIds": [
                147,
                148,
                149,
                150,
                151,
                152,
                153,
                154,
                155,
                156,
                157,
                158,
                159,
                160
              ],
              "provinces": [
                {
                  "label": "尼沙瓦州",
                  "value": 147
                },
                {
                  "label": "贝尔格莱德",
                  "value": 148
                },
                {
                  "label": "普奇尼亚州",
                  "value": 149
                },
                {
                  "label": "北巴奇卡州",
                  "value": 150
                },
                {
                  "label": "马切万州",
                  "value": 151
                },
                {
                  "label": "博尔州",
                  "value": 152
                },
                {
                  "label": "拉什卡州",
                  "value": 153
                },
                {
                  "label": "莫拉瓦州",
                  "value": 154
                },
                {
                  "label": "波莫拉夫列州",
                  "value": 155
                },
                {
                  "label": "布兰尼切夫州",
                  "value": 156
                },
                {
                  "label": "南巴纳特州",
                  "value": 157
                },
                {
                  "label": "斯雷姆州",
                  "value": 158
                },
                {
                  "label": "塞尔维亚",
                  "value": 159
                },
                {
                  "label": "拉辛那州",
                  "value": 160
                }
              ]
            },
            {
              "country_code": 19,
              "country_name_ch": "法属圣马丁",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/CollectivitedeSaintMartin.svg",
              "cityIds": [
                161
              ],
              "provinces": [
                {
                  "label": "马里戈特",
                  "value": 161
                }
              ]
            },
            {
              "country_code": 22,
              "country_name_ch": "叙利亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/SyrianArabRepublic.svg",
              "cityIds": [
                198,
                199,
                200,
                201,
                202
              ],
              "provinces": [
                {
                  "label": "塔尔图斯省",
                  "value": 198
                },
                {
                  "label": "叙利亚",
                  "value": 199
                },
                {
                  "label": "大马士革省",
                  "value": 200
                },
                {
                  "label": "阿勒颇省",
                  "value": 201
                },
                {
                  "label": "哈马省",
                  "value": 202
                }
              ]
            },
            {
              "country_code": 23,
              "country_name_ch": "莫桑比克",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Mozambique.svg",
              "cityIds": [
                203
              ],
              "provinces": [
                {
                  "label": "马普托",
                  "value": 203
                }
              ]
            },
            {
              "country_code": 25,
              "country_name_ch": "阿尔巴尼亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Albania.svg",
              "cityIds": [
                237,
                238,
                239,
                240,
                241,
                242,
                243,
                244,
                245
              ],
              "provinces": [
                {
                  "label": "都拉斯州",
                  "value": 237
                },
                {
                  "label": "地拉那州",
                  "value": 238
                },
                {
                  "label": "培拉特州",
                  "value": 239
                },
                {
                  "label": "爱尔巴桑州",
                  "value": 240
                },
                {
                  "label": "迪勃拉州",
                  "value": 241
                },
                {
                  "label": "斯库台州",
                  "value": 242
                },
                {
                  "label": "费里州",
                  "value": 243
                },
                {
                  "label": "发罗拉州",
                  "value": 244
                },
                {
                  "label": "阿尔巴尼亚",
                  "value": 245
                }
              ]
            },
            {
              "country_code": 26,
              "country_name_ch": "以色列",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Israel.svg",
              "cityIds": [
                246,
                247,
                248,
                249,
                250,
                251,
                252
              ],
              "provinces": [
                {
                  "label": "北部区",
                  "value": 246
                },
                {
                  "label": "以色列",
                  "value": 247
                },
                {
                  "label": "中央区",
                  "value": 248
                },
                {
                  "label": "特拉维夫区",
                  "value": 249
                },
                {
                  "label": "耶路撒冷区",
                  "value": 250
                },
                {
                  "label": "南部区",
                  "value": 251
                },
                {
                  "label": "海法区",
                  "value": 252
                }
              ]
            },
            {
              "country_code": 27,
              "country_name_ch": "伯利兹",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Belize.svg",
              "cityIds": [
                253,
                254,
                255
              ],
              "provinces": [
                {
                  "label": "伯利兹区",
                  "value": 253
                },
                {
                  "label": "卡约区",
                  "value": 254
                },
                {
                  "label": "科罗萨尔区",
                  "value": 255
                }
              ]
            },
            {
              "country_code": 28,
              "country_name_ch": "塔吉克斯坦",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Tajikistan.svg",
              "cityIds": [
                256,
                257
              ],
              "provinces": [
                {
                  "label": "塔吉克斯坦",
                  "value": 256
                },
                {
                  "label": "杜尚别",
                  "value": 257
                }
              ]
            },
            {
              "country_code": 29,
              "country_name_ch": "马约特",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Mayotte.svg",
              "cityIds": [
                258
              ],
              "provinces": [
                {
                  "label": "马约特",
                  "value": 258
                }
              ]
            },
            {
              "country_code": 30,
              "country_name_ch": "苏丹",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Sudan.svg",
              "cityIds": [
                295,
                296
              ],
              "provinces": [
                {
                  "label": "喀土穆州",
                  "value": 295
                },
                {
                  "label": "苏丹",
                  "value": 296
                }
              ]
            },
            {
              "country_code": 31,
              "country_name_ch": "不丹",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Bhutan.svg",
              "cityIds": [
                297
              ],
              "provinces": [
                {
                  "label": "不丹",
                  "value": 297
                }
              ]
            },
            {
              "country_code": 32,
              "country_name_ch": "马耳他",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Malta.svg",
              "cityIds": [
                298
              ],
              "provinces": [
                {
                  "label": "马耳他",
                  "value": 298
                }
              ]
            },
            {
              "country_code": 37,
              "country_name_ch": "智利",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Chile.svg",
              "cityIds": [
                412,
                413,
                414,
                415,
                416,
                417,
                418,
                419,
                420,
                421,
                422,
                423,
                424,
                425,
                426,
                427,
                428
              ],
              "provinces": [
                {
                  "label": "阿里卡和帕里纳科塔大区",
                  "value": 412
                },
                {
                  "label": "瓦尔帕莱索大区",
                  "value": 413
                },
                {
                  "label": "阿劳卡尼亚大区",
                  "value": 414
                },
                {
                  "label": "麦哲伦－智利南极大区",
                  "value": 415
                },
                {
                  "label": "圣地亚哥首都大区",
                  "value": 416
                },
                {
                  "label": "科金博大区",
                  "value": 417
                },
                {
                  "label": "湖大区",
                  "value": 418
                },
                {
                  "label": "纽布莱大区",
                  "value": 419
                },
                {
                  "label": "安托法加斯塔大区",
                  "value": 420
                },
                {
                  "label": "塔拉帕卡大区",
                  "value": 421
                },
                {
                  "label": "比奥比奥大区",
                  "value": 422
                },
                {
                  "label": "奥伊金斯将军解放者大区",
                  "value": 423
                },
                {
                  "label": "马乌莱大区",
                  "value": 424
                },
                {
                  "label": "河大区",
                  "value": 425
                },
                {
                  "label": "伊瓦涅斯将军的艾森大区",
                  "value": 426
                },
                {
                  "label": "智利",
                  "value": 427
                },
                {
                  "label": "阿塔卡马大区",
                  "value": 428
                }
              ]
            },
            {
              "country_code": 38,
              "country_name_ch": "也门",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Yemen.svg",
              "cityIds": [
                429,
                430,
                431
              ],
              "provinces": [
                {
                  "label": "也门",
                  "value": 429
                },
                {
                  "label": "萨那",
                  "value": 430
                },
                {
                  "label": "亚丁省",
                  "value": 431
                }
              ]
            },
            {
              "country_code": 39,
              "country_name_ch": "海地",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Haiti.svg",
              "cityIds": [
                432,
                433
              ],
              "provinces": [
                {
                  "label": "海地",
                  "value": 432
                },
                {
                  "label": "西部省",
                  "value": 433
                }
              ]
            },
            {
              "country_code": 40,
              "country_name_ch": "斐济",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Fiji.svg",
              "cityIds": [
                434
              ],
              "provinces": [
                {
                  "label": "斐济",
                  "value": 434
                }
              ]
            },
            {
              "country_code": 44,
              "country_name_ch": "瑞士",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Switzerland.svg",
              "cityIds": [
                443,
                444,
                445,
                446,
                447,
                448,
                449
              ],
              "provinces": [
                {
                  "label": "提契诺州",
                  "value": 443
                },
                {
                  "label": "日内瓦州",
                  "value": 444
                },
                {
                  "label": "巴塞尔城市州",
                  "value": 445
                },
                {
                  "label": "瑞士",
                  "value": 446
                },
                {
                  "label": "苏黎世州",
                  "value": 447
                },
                {
                  "label": "楚格州",
                  "value": 448
                },
                {
                  "label": "伯尔尼州",
                  "value": 449
                }
              ]
            },
            {
              "country_code": 45,
              "country_name_ch": "拉美地区",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "",
              "cityIds": [
                450
              ],
              "provinces": [
                {
                  "label": "拉美地区",
                  "value": 450
                }
              ]
            },
            {
              "country_code": 49,
              "country_name_ch": "吉尔吉斯斯坦",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Kyrgyzstan.svg",
              "cityIds": [
                546,
                547
              ],
              "provinces": [
                {
                  "label": "比什凯克",
                  "value": 546
                },
                {
                  "label": "吉尔吉斯斯坦",
                  "value": 547
                }
              ]
            },
            {
              "country_code": 50,
              "country_name_ch": "冈比亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Gambia.svg",
              "cityIds": [
                548
              ],
              "provinces": [
                {
                  "label": "班珠尔区",
                  "value": 548
                }
              ]
            },
            {
              "country_code": 51,
              "country_name_ch": "斯里兰卡",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/SriLanka.svg",
              "cityIds": [
                549
              ],
              "provinces": [
                {
                  "label": "西部省",
                  "value": 549
                }
              ]
            },
            {
              "country_code": 52,
              "country_name_ch": "加纳",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Ghana.svg",
              "cityIds": [
                550,
                551
              ],
              "provinces": [
                {
                  "label": "大阿克拉地区",
                  "value": 550
                },
                {
                  "label": "加纳",
                  "value": 551
                }
              ]
            },
            {
              "country_code": 53,
              "country_name_ch": "赞比亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Zambia.svg",
              "cityIds": [
                552
              ],
              "provinces": [
                {
                  "label": "铜带省",
                  "value": 552
                }
              ]
            },
            {
              "country_code": 55,
              "country_name_ch": "尼加拉瓜",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Nicaragua.svg",
              "cityIds": [
                574,
                575,
                576
              ],
              "provinces": [
                {
                  "label": "马那瓜省",
                  "value": 574
                },
                {
                  "label": "卡拉索省",
                  "value": 575
                },
                {
                  "label": "尼加拉瓜",
                  "value": 576
                }
              ]
            },
            {
              "country_code": 56,
              "country_name_ch": "阿富汗",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Afghanistan.svg",
              "cityIds": [
                577
              ],
              "provinces": [
                {
                  "label": "阿富汗",
                  "value": 577
                }
              ]
            },
            {
              "country_code": 57,
              "country_name_ch": "科威特",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Kuwait.svg",
              "cityIds": [
                578,
                579
              ],
              "provinces": [
                {
                  "label": "科威特",
                  "value": 578
                },
                {
                  "label": "首都省",
                  "value": 579
                }
              ]
            },
            {
              "country_code": 58,
              "country_name_ch": "加蓬",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Gabon.svg",
              "cityIds": [
                580
              ],
              "provinces": [
                {
                  "label": "河口省",
                  "value": 580
                }
              ]
            },
            {
              "country_code": 59,
              "country_name_ch": "马里",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Mali.svg",
              "cityIds": [
                581
              ],
              "provinces": [
                {
                  "label": "巴马科",
                  "value": 581
                }
              ]
            },
            {
              "country_code": 60,
              "country_name_ch": "阿塞拜疆",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Azerbaijan.svg",
              "cityIds": [
                582,
                583,
                584,
                585,
                586,
                587,
                588,
                589,
                590,
                591,
                592,
                593,
                594,
                595,
                596,
                597,
                598,
                599,
                600,
                601
              ],
              "provinces": [
                {
                  "label": "沙姆基尔区",
                  "value": 582
                },
                {
                  "label": "阿克斯塔法区",
                  "value": 583
                },
                {
                  "label": "乌贾雷区",
                  "value": 584
                },
                {
                  "label": "盖奥克恰伊区",
                  "value": 585
                },
                {
                  "label": "库萨雷区",
                  "value": 586
                },
                {
                  "label": "占贾",
                  "value": 587
                },
                {
                  "label": "盖贝莱区",
                  "value": 588
                },
                {
                  "label": "巴库",
                  "value": 589
                },
                {
                  "label": "阿布歇隆区",
                  "value": 590
                },
                {
                  "label": "苏姆盖特",
                  "value": 591
                },
                {
                  "label": "巴尔达区",
                  "value": 592
                },
                {
                  "label": "汉肯德",
                  "value": 593
                },
                {
                  "label": "扎卡塔雷区",
                  "value": 594
                },
                {
                  "label": "明盖恰乌尔",
                  "value": 595
                },
                {
                  "label": "阿格达什区",
                  "value": 596
                },
                {
                  "label": "阿格贾贝迪区",
                  "value": 597
                },
                {
                  "label": "阿塞拜疆",
                  "value": 598
                },
                {
                  "label": "菲祖利区",
                  "value": 599
                },
                {
                  "label": "希尔万",
                  "value": 600
                },
                {
                  "label": "纳希切万",
                  "value": 601
                }
              ]
            },
            {
              "country_code": 61,
              "country_name_ch": "斯洛伐克",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Slovakia.svg",
              "cityIds": [
                602,
                603,
                604,
                605,
                606,
                607,
                608,
                609
              ],
              "provinces": [
                {
                  "label": "布拉迪斯拉发州",
                  "value": 602
                },
                {
                  "label": "日利纳州",
                  "value": 603
                },
                {
                  "label": "班斯卡－比斯特里察州",
                  "value": 604
                },
                {
                  "label": "普列索夫州",
                  "value": 605
                },
                {
                  "label": "尼特拉州",
                  "value": 606
                },
                {
                  "label": "特尔纳瓦州",
                  "value": 607
                },
                {
                  "label": "科希策州",
                  "value": 608
                },
                {
                  "label": "斯洛伐克",
                  "value": 609
                }
              ]
            },
            {
              "country_code": 62,
              "country_name_ch": "基里巴斯",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Kiribati.svg",
              "cityIds": [
                610
              ],
              "provinces": [
                {
                  "label": "吉尔柏特群岛",
                  "value": 610
                }
              ]
            },
            {
              "country_code": 63,
              "country_name_ch": "卢森堡",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Luxembourg.svg",
              "cityIds": [
                611
              ],
              "provinces": [
                {
                  "label": "卢森堡",
                  "value": 611
                }
              ]
            },
            {
              "country_code": 67,
              "country_name_ch": "南非",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/SouthAfrica.svg",
              "cityIds": [
                717,
                718,
                719
              ],
              "provinces": [
                {
                  "label": "南非",
                  "value": 717
                },
                {
                  "label": "西开普省",
                  "value": 718
                },
                {
                  "label": "豪登省",
                  "value": 719
                }
              ]
            },
            {
              "country_code": 68,
              "country_name_ch": "克罗地亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Croatia.svg",
              "cityIds": [
                720,
                721,
                722,
                723,
                724
              ],
              "provinces": [
                {
                  "label": "奥西耶克－巴拉尼亚县",
                  "value": 720
                },
                {
                  "label": "萨格勒布县",
                  "value": 721
                },
                {
                  "label": "伊斯特拉县",
                  "value": 722
                },
                {
                  "label": "萨格勒布",
                  "value": 723
                },
                {
                  "label": "克罗地亚",
                  "value": 724
                }
              ]
            },
            {
              "country_code": 69,
              "country_name_ch": "北美地区",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "",
              "cityIds": [
                725
              ],
              "provinces": [
                {
                  "label": "北美地区",
                  "value": 725
                }
              ]
            },
            {
              "country_code": 72,
              "country_name_ch": "匈牙利",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Hungary.svg",
              "cityIds": [
                741,
                742,
                743,
                744,
                745,
                746,
                747,
                748,
                749,
                750,
                751,
                752,
                753,
                754,
                755,
                756,
                757,
                758,
                759,
                760,
                761
              ],
              "provinces": [
                {
                  "label": "费耶尔州",
                  "value": 741
                },
                {
                  "label": "索博尔奇－索特马尔－贝拉格州",
                  "value": 742
                },
                {
                  "label": "托尔瑙州",
                  "value": 743
                },
                {
                  "label": "沃什州",
                  "value": 744
                },
                {
                  "label": "巴兰尼亚州",
                  "value": 745
                },
                {
                  "label": "琼格拉德州",
                  "value": 746
                },
                {
                  "label": "包尔绍德－奥包乌伊－曾普伦州",
                  "value": 747
                },
                {
                  "label": "亚斯－大昆－索尔诺克州",
                  "value": 748
                },
                {
                  "label": "布达佩斯",
                  "value": 749
                },
                {
                  "label": "佐洛州",
                  "value": 750
                },
                {
                  "label": "诺格拉德州",
                  "value": 751
                },
                {
                  "label": "巴奇－基什孔州",
                  "value": 752
                },
                {
                  "label": "佩斯州",
                  "value": 753
                },
                {
                  "label": "科马罗姆－埃斯泰尔戈姆州",
                  "value": 754
                },
                {
                  "label": "杰尔－莫雄－肖普朗州",
                  "value": 755
                },
                {
                  "label": "匈牙利",
                  "value": 756
                },
                {
                  "label": "贝凯什州",
                  "value": 757
                },
                {
                  "label": "豪伊杜－比豪尔州",
                  "value": 758
                },
                {
                  "label": "绍莫吉州",
                  "value": 759
                },
                {
                  "label": "维斯普雷姆州",
                  "value": 760
                },
                {
                  "label": "赫维什州",
                  "value": 761
                }
              ]
            },
            {
              "country_code": 73,
              "country_name_ch": "挪威",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Norway.svg",
              "cityIds": [
                762,
                763,
                764,
                765,
                766,
                767,
                768
              ],
              "provinces": [
                {
                  "label": "西福尔郡",
                  "value": 762
                },
                {
                  "label": "默勒－鲁姆斯达尔郡",
                  "value": 763
                },
                {
                  "label": "韦斯特兰郡",
                  "value": 764
                },
                {
                  "label": "诺尔兰郡",
                  "value": 765
                },
                {
                  "label": "挪威",
                  "value": 766
                },
                {
                  "label": "奥斯陆郡",
                  "value": 767
                },
                {
                  "label": "罗加兰郡",
                  "value": 768
                }
              ]
            },
            {
              "country_code": 74,
              "country_name_ch": "拉脱维亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Latvia.svg",
              "cityIds": [
                769,
                770,
                771,
                772
              ],
              "provinces": [
                {
                  "label": "里加",
                  "value": 769
                },
                {
                  "label": "拉脱维亚",
                  "value": 770
                },
                {
                  "label": "利耶帕亚",
                  "value": 771
                },
                {
                  "label": "瓦尔米耶拉自治市",
                  "value": 772
                }
              ]
            },
            {
              "country_code": 75,
              "country_name_ch": "摩尔多瓦",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Moldova.svg",
              "cityIds": [
                773,
                774,
                775,
                776,
                777,
                778,
                779,
                780,
                781,
                782,
                783
              ],
              "provinces": [
                {
                  "label": "基希讷乌",
                  "value": 773
                },
                {
                  "label": "雷什卡内区",
                  "value": 774
                },
                {
                  "label": "克留莱尼区",
                  "value": 775
                },
                {
                  "label": "布里切尼区",
                  "value": 776
                },
                {
                  "label": "德涅斯特河沿岸",
                  "value": 777
                },
                {
                  "label": "加告兹自治区",
                  "value": 778
                },
                {
                  "label": "栋杜谢尼区",
                  "value": 779
                },
                {
                  "label": "德罗基亚区",
                  "value": 780
                },
                {
                  "label": "森杰雷区",
                  "value": 781
                },
                {
                  "label": "摩尔多瓦",
                  "value": 782
                },
                {
                  "label": "宾杰里",
                  "value": 783
                }
              ]
            },
            {
              "country_code": 76,
              "country_name_ch": "东帝汶",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Timor-Leste.svg",
              "cityIds": [
                784
              ],
              "provinces": [
                {
                  "label": "东帝汶",
                  "value": 784
                }
              ]
            },
            {
              "country_code": 78,
              "country_name_ch": "乌兹别克斯坦",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Uzbekistan.svg",
              "cityIds": [
                807,
                808,
                809,
                810,
                811,
                812,
                813,
                814,
                815,
                816,
                817,
                818,
                819
              ],
              "provinces": [
                {
                  "label": "撒马尔罕州",
                  "value": 807
                },
                {
                  "label": "卡什卡达里亚州",
                  "value": 808
                },
                {
                  "label": "费尔干纳州",
                  "value": 809
                },
                {
                  "label": "锡尔河州",
                  "value": 810
                },
                {
                  "label": "塔什干州",
                  "value": 811
                },
                {
                  "label": "吉扎克州",
                  "value": 812
                },
                {
                  "label": "卡拉卡尔帕克斯坦共和国",
                  "value": 813
                },
                {
                  "label": "乌兹别克斯坦",
                  "value": 814
                },
                {
                  "label": "塔什干",
                  "value": 815
                },
                {
                  "label": "纳曼干州",
                  "value": 816
                },
                {
                  "label": "布哈拉州",
                  "value": 817
                },
                {
                  "label": "安集延州",
                  "value": 818
                },
                {
                  "label": "纳沃伊州",
                  "value": 819
                }
              ]
            },
            {
              "country_code": 79,
              "country_name_ch": "GLOBALSECURELAYER.COM",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "",
              "cityIds": [
                820
              ],
              "provinces": [
                {
                  "label": "GLOBALSECURELAYER.COM",
                  "value": 820
                }
              ]
            },
            {
              "country_code": 82,
              "country_name_ch": "希腊",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Greece.svg",
              "cityIds": [
                859,
                860,
                861,
                862,
                863,
                864,
                865,
                866,
                867,
                868,
                869,
                870
              ],
              "provinces": [
                {
                  "label": "阿提卡大区",
                  "value": 859
                },
                {
                  "label": "南爱琴大区",
                  "value": 860
                },
                {
                  "label": "伯罗奔尼撒大区",
                  "value": 861
                },
                {
                  "label": "中希腊大区",
                  "value": 862
                },
                {
                  "label": "色萨利大区",
                  "value": 863
                },
                {
                  "label": "西希腊大区",
                  "value": 864
                },
                {
                  "label": "伊奥尼亚群岛区",
                  "value": 865
                },
                {
                  "label": "希腊",
                  "value": 866
                },
                {
                  "label": "中马其顿大区",
                  "value": 867
                },
                {
                  "label": "东马其顿和色雷斯大区",
                  "value": 868
                },
                {
                  "label": "西马其顿大区",
                  "value": 869
                },
                {
                  "label": "克里特大区",
                  "value": 870
                }
              ]
            },
            {
              "country_code": 83,
              "country_name_ch": "乍得",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Chad.svg",
              "cityIds": [
                871
              ],
              "provinces": [
                {
                  "label": "恩贾梅纳",
                  "value": 871
                }
              ]
            },
            {
              "country_code": 84,
              "country_name_ch": "肯尼亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Kenya.svg",
              "cityIds": [
                872,
                873
              ],
              "provinces": [
                {
                  "label": "内罗毕县",
                  "value": 872
                },
                {
                  "label": "肯尼亚",
                  "value": 873
                }
              ]
            },
            {
              "country_code": 85,
              "country_name_ch": "美属萨摩亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/AmericanSamoa.svg",
              "cityIds": [
                874
              ],
              "provinces": [
                {
                  "label": "东区",
                  "value": 874
                }
              ]
            },
            {
              "country_code": 88,
              "country_name_ch": "奥地利",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Austria.svg",
              "cityIds": [
                913,
                914,
                915,
                916
              ],
              "provinces": [
                {
                  "label": "上奥地利州",
                  "value": 913
                },
                {
                  "label": "维也纳州",
                  "value": 914
                },
                {
                  "label": "奥地利",
                  "value": 915
                },
                {
                  "label": "下奥地利州",
                  "value": 916
                }
              ]
            },
            {
              "country_code": 89,
              "country_name_ch": "科特迪瓦",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Coted'Ivoire.svg",
              "cityIds": [
                917,
                918
              ],
              "provinces": [
                {
                  "label": "阿比让",
                  "value": 917
                },
                {
                  "label": "邦达马河谷地区",
                  "value": 918
                }
              ]
            },
            {
              "country_code": 90,
              "country_name_ch": "布基纳法索",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/BurkinaFaso.svg",
              "cityIds": [
                919
              ],
              "provinces": [
                {
                  "label": "中央大区",
                  "value": 919
                }
              ]
            },
            {
              "country_code": 91,
              "country_name_ch": "百慕大",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Bermuda.svg",
              "cityIds": [
                920
              ],
              "provinces": [
                {
                  "label": "百慕大",
                  "value": 920
                }
              ]
            },
            {
              "country_code": 92,
              "country_name_ch": "瓜德罗普",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Guadeloupe.svg",
              "cityIds": [
                921
              ],
              "provinces": [
                {
                  "label": "瓜德罗普",
                  "value": 921
                }
              ]
            },
            {
              "country_code": 93,
              "country_name_ch": "伊朗",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Iran.svg",
              "cityIds": [
                922,
                923,
                924,
                925,
                926,
                927,
                928,
                929,
                930,
                931
              ],
              "provinces": [
                {
                  "label": "胡齐斯坦省",
                  "value": 922
                },
                {
                  "label": "东阿塞拜疆省",
                  "value": 923
                },
                {
                  "label": "伊朗",
                  "value": 924
                },
                {
                  "label": "库姆省",
                  "value": 925
                },
                {
                  "label": "伊斯法罕省",
                  "value": 926
                },
                {
                  "label": "厄尔布尔士省",
                  "value": 927
                },
                {
                  "label": "法尔斯省",
                  "value": 928
                },
                {
                  "label": "德黑兰省",
                  "value": 929
                },
                {
                  "label": "礼萨呼罗珊省",
                  "value": 930
                },
                {
                  "label": "加兹温省",
                  "value": 931
                }
              ]
            },
            {
              "country_code": 94,
              "country_name_ch": "圭亚那",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Guyana.svg",
              "cityIds": [
                932,
                933
              ],
              "provinces": [
                {
                  "label": "马海卡－伯比斯区",
                  "value": 932
                },
                {
                  "label": "德梅拉拉－马海卡区",
                  "value": 933
                }
              ]
            },
            {
              "country_code": 95,
              "country_name_ch": "法属圭亚那",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/FrenchGuiana.svg",
              "cityIds": [
                934
              ],
              "provinces": [
                {
                  "label": "卡宴区",
                  "value": 934
                }
              ]
            },
            {
              "country_code": 96,
              "country_name_ch": "非洲地区",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "",
              "cityIds": [
                935
              ],
              "provinces": [
                {
                  "label": "非洲地区",
                  "value": 935
                }
              ]
            },
            {
              "country_code": 98,
              "country_name_ch": "巴拿马",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Panama.svg",
              "cityIds": [
                955,
                956,
                957,
                958,
                959,
                960,
                961
              ],
              "provinces": [
                {
                  "label": "科克莱省",
                  "value": 955
                },
                {
                  "label": "巴拿马省",
                  "value": 956
                },
                {
                  "label": "巴拿马",
                  "value": 957
                },
                {
                  "label": "科隆省",
                  "value": 958
                },
                {
                  "label": "贝拉瓜斯省",
                  "value": 959
                },
                {
                  "label": "西巴拿马省",
                  "value": 960
                },
                {
                  "label": "奇里基省",
                  "value": 961
                }
              ]
            },
            {
              "country_code": 99,
              "country_name_ch": "巴拉圭",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Paraguay.svg",
              "cityIds": [
                962,
                963,
                964,
                965,
                966,
                967,
                968,
                969
              ],
              "provinces": [
                {
                  "label": "博克龙省",
                  "value": 962
                },
                {
                  "label": "上巴拉那省",
                  "value": 963
                },
                {
                  "label": "巴拉圭",
                  "value": 964
                },
                {
                  "label": "中央省",
                  "value": 965
                },
                {
                  "label": "圣佩德罗省",
                  "value": 966
                },
                {
                  "label": "巴拉瓜里省",
                  "value": 967
                },
                {
                  "label": "科迪勒拉省",
                  "value": 968
                },
                {
                  "label": "亚松森",
                  "value": 969
                }
              ]
            },
            {
              "country_code": 100,
              "country_name_ch": "芬兰",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Finland.svg",
              "cityIds": [
                970,
                971
              ],
              "provinces": [
                {
                  "label": "芬兰",
                  "value": 970
                },
                {
                  "label": "新地区",
                  "value": 971
                }
              ]
            },
            {
              "country_code": 101,
              "country_name_ch": "尼泊尔",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Nepal.svg",
              "cityIds": [
                972,
                973,
                974,
                975,
                976,
                977
              ],
              "provinces": [
                {
                  "label": "戈西省",
                  "value": 972
                },
                {
                  "label": "远西省",
                  "value": 973
                },
                {
                  "label": "尼泊尔",
                  "value": 974
                },
                {
                  "label": "蓝毗尼省",
                  "value": 975
                },
                {
                  "label": "巴格马蒂省",
                  "value": 976
                },
                {
                  "label": "甘达基省",
                  "value": 977
                }
              ]
            },
            {
              "country_code": 104,
              "country_name_ch": "葡萄牙",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Portugal.svg",
              "cityIds": [
                1023,
                1024,
                1025,
                1026
              ],
              "provinces": [
                {
                  "label": "波尔图区",
                  "value": 1023
                },
                {
                  "label": "葡萄牙",
                  "value": 1024
                },
                {
                  "label": "塞图巴尔区",
                  "value": 1025
                },
                {
                  "label": "里斯本区",
                  "value": 1026
                }
              ]
            },
            {
              "country_code": 105,
              "country_name_ch": "刚果民主共和国",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "",
              "cityIds": [
                1027,
                1028
              ],
              "provinces": [
                {
                  "label": "金沙萨",
                  "value": 1027
                },
                {
                  "label": "上加丹加省",
                  "value": 1028
                }
              ]
            },
            {
              "country_code": 106,
              "country_name_ch": "纳米比亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Namibia.svg",
              "cityIds": [
                1029
              ],
              "provinces": [
                {
                  "label": "霍马斯区",
                  "value": 1029
                }
              ]
            },
            {
              "country_code": 107,
              "country_name_ch": "索马里",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Somalia.svg",
              "cityIds": [
                1030,
                1031
              ],
              "provinces": [
                {
                  "label": "巴纳迪尔州",
                  "value": 1030
                },
                {
                  "label": "索马里",
                  "value": 1031
                }
              ]
            },
            {
              "country_code": 108,
              "country_name_ch": "蒙古",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Mongolia.svg",
              "cityIds": [
                1032
              ],
              "provinces": [
                {
                  "label": "乌兰巴托",
                  "value": 1032
                }
              ]
            },
            {
              "country_code": 111,
              "country_name_ch": "古巴",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Cuba.svg",
              "cityIds": [
                1083
              ],
              "provinces": [
                {
                  "label": "拉哈瓦那省",
                  "value": 1083
                }
              ]
            },
            {
              "country_code": 112,
              "country_name_ch": "牙买加",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Jamaica.svg",
              "cityIds": [
                1084,
                1085,
                1086,
                1087
              ],
              "provinces": [
                {
                  "label": "克雷伦敦区",
                  "value": 1084
                },
                {
                  "label": "圣凯瑟琳区",
                  "value": 1085
                },
                {
                  "label": "牙买加",
                  "value": 1086
                },
                {
                  "label": "金斯敦区",
                  "value": 1087
                }
              ]
            },
            {
              "country_code": 113,
              "country_name_ch": "坦桑尼亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Tanzania.svg",
              "cityIds": [
                1088,
                1089,
                1090
              ],
              "provinces": [
                {
                  "label": "坦桑尼亚",
                  "value": 1088
                },
                {
                  "label": "阿鲁沙区",
                  "value": 1089
                },
                {
                  "label": "乞力马扎罗区",
                  "value": 1090
                }
              ]
            },
            {
              "country_code": 114,
              "country_name_ch": "巴林",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Bahrain.svg",
              "cityIds": [
                1091,
                1092,
                1093
              ],
              "provinces": [
                {
                  "label": "首都省",
                  "value": 1091
                },
                {
                  "label": "巴林",
                  "value": 1092
                },
                {
                  "label": "穆哈拉格省",
                  "value": 1093
                }
              ]
            },
            {
              "country_code": 115,
              "country_name_ch": "黑山",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Montenegro.svg",
              "cityIds": [
                1094
              ],
              "provinces": [
                {
                  "label": "黑山",
                  "value": 1094
                }
              ]
            },
            {
              "country_code": 116,
              "country_name_ch": "新西兰",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/NewZealand.svg",
              "cityIds": [
                1095,
                1096
              ],
              "provinces": [
                {
                  "label": "坎特伯雷大区",
                  "value": 1095
                },
                {
                  "label": "奥克兰大区",
                  "value": 1096
                }
              ]
            },
            {
              "country_code": 121,
              "country_name_ch": "塞浦路斯",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Cyprus.svg",
              "cityIds": [
                1168,
                1169,
                1170,
                1171,
                1172,
                1173
              ],
              "provinces": [
                {
                  "label": "法马古斯塔区",
                  "value": 1168
                },
                {
                  "label": "尼科西亚区",
                  "value": 1169
                },
                {
                  "label": "塞浦路斯",
                  "value": 1170
                },
                {
                  "label": "凯里尼亚区",
                  "value": 1171
                },
                {
                  "label": "利马索尔区",
                  "value": 1172
                },
                {
                  "label": "帕福斯区",
                  "value": 1173
                }
              ]
            },
            {
              "country_code": 122,
              "country_name_ch": "文莱",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Brunei.svg",
              "cityIds": [
                1174,
                1175
              ],
              "provinces": [
                {
                  "label": "文莱",
                  "value": 1174
                },
                {
                  "label": "汶莱摩拉县",
                  "value": 1175
                }
              ]
            },
            {
              "country_code": 123,
              "country_name_ch": "圣卢西亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/SaintLucia.svg",
              "cityIds": [
                1176
              ],
              "provinces": [
                {
                  "label": "圣卢西亚",
                  "value": 1176
                }
              ]
            },
            {
              "country_code": 126,
              "country_name_ch": "洪都拉斯",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Honduras.svg",
              "cityIds": [
                1188,
                1189,
                1190,
                1191,
                1192,
                1193,
                1194,
                1195,
                1196,
                1197
              ],
              "provinces": [
                {
                  "label": "洪都拉斯",
                  "value": 1188
                },
                {
                  "label": "科马亚瓜省",
                  "value": 1189
                },
                {
                  "label": "约罗省",
                  "value": 1190
                },
                {
                  "label": "弗朗西斯科－莫拉桑省",
                  "value": 1191
                },
                {
                  "label": "科潘省",
                  "value": 1192
                },
                {
                  "label": "海湾群岛省",
                  "value": 1193
                },
                {
                  "label": "科尔特斯省",
                  "value": 1194
                },
                {
                  "label": "奥科特佩克省",
                  "value": 1195
                },
                {
                  "label": "科隆省",
                  "value": 1196
                },
                {
                  "label": "阿特兰蒂达省",
                  "value": 1197
                }
              ]
            },
            {
              "country_code": 127,
              "country_name_ch": "保加利亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Bulgaria.svg",
              "cityIds": [
                1198,
                1199,
                1200,
                1201,
                1202,
                1203,
                1204,
                1205,
                1206,
                1207,
                1208,
                1209,
                1210,
                1211,
                1212,
                1213,
                1214
              ],
              "provinces": [
                {
                  "label": "瓦尔纳州",
                  "value": 1198
                },
                {
                  "label": "斯利文州",
                  "value": 1199
                },
                {
                  "label": "布尔加斯州",
                  "value": 1200
                },
                {
                  "label": "帕扎尔吉克州",
                  "value": 1201
                },
                {
                  "label": "拉兹格勒州",
                  "value": 1202
                },
                {
                  "label": "鲁塞州",
                  "value": 1203
                },
                {
                  "label": "克尔贾利州",
                  "value": 1204
                },
                {
                  "label": "佩尔尼克州",
                  "value": 1205
                },
                {
                  "label": "保加利亚",
                  "value": 1206
                },
                {
                  "label": "锡利斯特拉州",
                  "value": 1207
                },
                {
                  "label": "普列文州",
                  "value": 1208
                },
                {
                  "label": "多布里奇州",
                  "value": 1209
                },
                {
                  "label": "索非亚",
                  "value": 1210
                },
                {
                  "label": "布拉戈耶夫格勒州",
                  "value": 1211
                },
                {
                  "label": "普罗夫迪夫州",
                  "value": 1212
                },
                {
                  "label": "哈斯科沃州",
                  "value": 1213
                },
                {
                  "label": "扬博尔州",
                  "value": 1214
                }
              ]
            },
            {
              "country_code": 128,
              "country_name_ch": "利比里亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Liberia.svg",
              "cityIds": [
                1215
              ],
              "provinces": [
                {
                  "label": "蒙特塞拉多县",
                  "value": 1215
                }
              ]
            },
            {
              "country_code": 129,
              "country_name_ch": "阿曼",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Oman.svg",
              "cityIds": [
                1216,
                1217,
                1218,
                1219,
                1220,
                1221,
                1222,
                1223,
                1224,
                1225
              ],
              "provinces": [
                {
                  "label": "佐法尔省",
                  "value": 1216
                },
                {
                  "label": "中部省",
                  "value": 1217
                },
                {
                  "label": "布赖米省",
                  "value": 1218
                },
                {
                  "label": "东南省",
                  "value": 1219
                },
                {
                  "label": "扎希拉省",
                  "value": 1220
                },
                {
                  "label": "马斯喀特省",
                  "value": 1221
                },
                {
                  "label": "北巴提奈省",
                  "value": 1222
                },
                {
                  "label": "阿曼",
                  "value": 1223
                },
                {
                  "label": "南巴提奈省",
                  "value": 1224
                },
                {
                  "label": "内地省",
                  "value": 1225
                }
              ]
            },
            {
              "country_code": 130,
              "country_name_ch": "危地马拉",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Guatemala.svg",
              "cityIds": [
                1226,
                1227,
                1228,
                1229,
                1230,
                1231,
                1232,
                1233,
                1234,
                1235
              ],
              "provinces": [
                {
                  "label": "韦韦特南戈省",
                  "value": 1226
                },
                {
                  "label": "萨卡特佩克斯省",
                  "value": 1227
                },
                {
                  "label": "克萨尔特南戈省",
                  "value": 1228
                },
                {
                  "label": "危地马拉省",
                  "value": 1229
                },
                {
                  "label": "危地马拉",
                  "value": 1230
                },
                {
                  "label": "贾拉普省",
                  "value": 1231
                },
                {
                  "label": "奇基穆拉省",
                  "value": 1232
                },
                {
                  "label": "基切省",
                  "value": 1233
                },
                {
                  "label": "上韦拉帕斯省",
                  "value": 1234
                },
                {
                  "label": "伊萨瓦尔省",
                  "value": 1235
                }
              ]
            },
            {
              "country_code": 132,
              "country_name_ch": "乌拉圭",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Uruguay.svg",
              "cityIds": [
                1237,
                1238,
                1239,
                1240
              ],
              "provinces": [
                {
                  "label": "卡内洛内斯省",
                  "value": 1237
                },
                {
                  "label": "马尔多纳多省",
                  "value": 1238
                },
                {
                  "label": "蒙得维的亚省",
                  "value": 1239
                },
                {
                  "label": "乌拉圭",
                  "value": 1240
                }
              ]
            },
            {
              "country_code": 133,
              "country_name_ch": "3BB.CO.TH",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "",
              "cityIds": [
                1241
              ],
              "provinces": [
                {
                  "label": "3BB.CO.TH",
                  "value": 1241
                }
              ]
            },
            {
              "country_code": 134,
              "country_name_ch": "埃塞俄比亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Ethiopia.svg",
              "cityIds": [
                1242,
                1243,
                1244
              ],
              "provinces": [
                {
                  "label": "亚的斯亚贝巴",
                  "value": 1242
                },
                {
                  "label": "索马里州",
                  "value": 1243
                },
                {
                  "label": "埃塞俄比亚",
                  "value": 1244
                }
              ]
            },
            {
              "country_code": 135,
              "country_name_ch": "圣皮埃尔和密克隆群岛",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "",
              "cityIds": [
                1245
              ],
              "provinces": [
                {
                  "label": "圣皮埃尔",
                  "value": 1245
                }
              ]
            },
            {
              "country_code": 139,
              "country_name_ch": "黎巴嫩",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Lebanon.svg",
              "cityIds": [
                1261,
                1262,
                1263,
                1264,
                1265,
                1266,
                1267,
                1268,
                1269,
                1270
              ],
              "provinces": [
                {
                  "label": "北黎巴嫩省",
                  "value": 1261
                },
                {
                  "label": "黎巴嫩山省",
                  "value": 1262
                },
                {
                  "label": "凯斯莱－朱拜勒省",
                  "value": 1263
                },
                {
                  "label": "贝鲁特省",
                  "value": 1264
                },
                {
                  "label": "贝卡省",
                  "value": 1265
                },
                {
                  "label": "阿卡省",
                  "value": 1266
                },
                {
                  "label": "南黎巴嫩省",
                  "value": 1267
                },
                {
                  "label": "黎巴嫩",
                  "value": 1268
                },
                {
                  "label": "纳巴泰省",
                  "value": 1269
                },
                {
                  "label": "巴勒贝克－希尔米勒省",
                  "value": 1270
                }
              ]
            },
            {
              "country_code": 140,
              "country_name_ch": "苏里南",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Suriname.svg",
              "cityIds": [
                1271,
                1272
              ],
              "provinces": [
                {
                  "label": "帕拉马里博区",
                  "value": 1271
                },
                {
                  "label": "苏里南",
                  "value": 1272
                }
              ]
            },
            {
              "country_code": 141,
              "country_name_ch": "毛里塔尼亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Mauritania.svg",
              "cityIds": [
                1273,
                1274
              ],
              "provinces": [
                {
                  "label": "毛里塔尼亚",
                  "value": 1273
                },
                {
                  "label": "努瓦克肖特",
                  "value": 1274
                }
              ]
            },
            {
              "country_code": 142,
              "country_name_ch": "M247.COM 骨干网",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "",
              "cityIds": [
                1275
              ],
              "provinces": [
                {
                  "label": "M247.COM 骨干网",
                  "value": 1275
                }
              ]
            },
            {
              "country_code": 144,
              "country_name_ch": "土库曼斯坦",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Turkmenistan.svg",
              "cityIds": [
                1284,
                1285
              ],
              "provinces": [
                {
                  "label": "阿什哈巴德",
                  "value": 1284
                },
                {
                  "label": "列巴普州",
                  "value": 1285
                }
              ]
            },
            {
              "country_code": 145,
              "country_name_ch": "老挝",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Laos.svg",
              "cityIds": [
                1286,
                1287,
                1288,
                1289,
                1290
              ],
              "provinces": [
                {
                  "label": "赛宋奔省",
                  "value": 1286
                },
                {
                  "label": "老挝",
                  "value": 1287
                },
                {
                  "label": "沙湾拿吉省",
                  "value": 1288
                },
                {
                  "label": "万象市",
                  "value": 1289
                },
                {
                  "label": "博胶省",
                  "value": 1290
                }
              ]
            },
            {
              "country_code": 146,
              "country_name_ch": "北马其顿",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Macedonia.svg",
              "cityIds": [
                1291,
                1292,
                1293,
                1294
              ],
              "provinces": [
                {
                  "label": "北马其顿",
                  "value": 1291
                },
                {
                  "label": "斯科普里",
                  "value": 1292
                },
                {
                  "label": "斯特鲁米察市镇",
                  "value": 1293
                },
                {
                  "label": "比托拉市镇",
                  "value": 1294
                }
              ]
            },
            {
              "country_code": 147,
              "country_name_ch": "巴勒斯坦",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Palestine.svg",
              "cityIds": [
                1295,
                1296,
                1297,
                1298,
                1299,
                1300,
                1301
              ],
              "provinces": [
                {
                  "label": "希布伦省",
                  "value": 1295
                },
                {
                  "label": "巴勒斯坦",
                  "value": 1296
                },
                {
                  "label": "纳布卢斯省",
                  "value": 1297
                },
                {
                  "label": "杰宁省",
                  "value": 1298
                },
                {
                  "label": "图勒凯尔姆省",
                  "value": 1299
                },
                {
                  "label": "萨尔费特省",
                  "value": 1300
                },
                {
                  "label": "拉马拉和比雷赫省",
                  "value": 1301
                }
              ]
            },
            {
              "country_code": 150,
              "country_name_ch": "乌克兰",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Ukraine.svg",
              "cityIds": [
                1328,
                1329,
                1330,
                1331,
                1332,
                1333,
                1334,
                1335,
                1336,
                1337,
                1338,
                1339,
                1340,
                1341,
                1342,
                1343,
                1344,
                1345,
                1346,
                1347,
                1348,
                1349,
                1350,
                1351,
                1352,
                1353
              ],
              "provinces": [
                {
                  "label": "哈尔科夫州",
                  "value": 1328
                },
                {
                  "label": "利沃夫州",
                  "value": 1329
                },
                {
                  "label": "波尔塔瓦州",
                  "value": 1330
                },
                {
                  "label": "切尔卡瑟州",
                  "value": 1331
                },
                {
                  "label": "基洛夫格勒州",
                  "value": 1332
                },
                {
                  "label": "罗夫诺州",
                  "value": 1333
                },
                {
                  "label": "外喀尔巴阡州",
                  "value": 1334
                },
                {
                  "label": "赫梅利尼茨基州",
                  "value": 1335
                },
                {
                  "label": "捷尔诺波尔州",
                  "value": 1336
                },
                {
                  "label": "切尔诺夫策州",
                  "value": 1337
                },
                {
                  "label": "日托米尔州",
                  "value": 1338
                },
                {
                  "label": "苏梅州",
                  "value": 1339
                },
                {
                  "label": "卢甘斯克州",
                  "value": 1340
                },
                {
                  "label": "切尔尼戈夫州",
                  "value": 1341
                },
                {
                  "label": "赫尔松州",
                  "value": 1342
                },
                {
                  "label": "第聂伯罗彼得罗夫斯克州",
                  "value": 1343
                },
                {
                  "label": "扎波罗热州",
                  "value": 1344
                },
                {
                  "label": "敖德萨州",
                  "value": 1345
                },
                {
                  "label": "顿涅茨克州",
                  "value": 1346
                },
                {
                  "label": "沃伦州",
                  "value": 1347
                },
                {
                  "label": "文尼察州",
                  "value": 1348
                },
                {
                  "label": "基辅",
                  "value": 1349
                },
                {
                  "label": "尼古拉耶夫州",
                  "value": 1350
                },
                {
                  "label": "乌克兰",
                  "value": 1351
                },
                {
                  "label": "基辅州",
                  "value": 1352
                },
                {
                  "label": "伊万诺－弗兰科夫斯克州",
                  "value": 1353
                }
              ]
            },
            {
              "country_code": 151,
              "country_name_ch": "沙特阿拉伯",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/SaudiArabia.svg",
              "cityIds": [
                1354,
                1355,
                1356,
                1357,
                1358,
                1359,
                1360,
                1361,
                1362,
                1363
              ],
              "provinces": [
                {
                  "label": "吉赞省",
                  "value": 1354
                },
                {
                  "label": "塔布克省",
                  "value": 1355
                },
                {
                  "label": "东部省",
                  "value": 1356
                },
                {
                  "label": "利雅得省",
                  "value": 1357
                },
                {
                  "label": "阿西尔省",
                  "value": 1358
                },
                {
                  "label": "麦加省",
                  "value": 1359
                },
                {
                  "label": "麦地那省",
                  "value": 1360
                },
                {
                  "label": "盖西姆省",
                  "value": 1361
                },
                {
                  "label": "北部边疆省",
                  "value": 1362
                },
                {
                  "label": "沙特阿拉伯",
                  "value": 1363
                }
              ]
            },
            {
              "country_code": 152,
              "country_name_ch": "所罗门群岛",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/SolomonIslands.svg",
              "cityIds": [
                1364
              ],
              "provinces": [
                {
                  "label": "霍尼亚拉",
                  "value": 1364
                }
              ]
            },
            {
              "country_code": 153,
              "country_name_ch": "爱沙尼亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Estonia.svg",
              "cityIds": [
                1365,
                1366,
                1367
              ],
              "provinces": [
                {
                  "label": "瓦尔加县",
                  "value": 1365
                },
                {
                  "label": "爱沙尼亚",
                  "value": 1366
                },
                {
                  "label": "哈尔尤县",
                  "value": 1367
                }
              ]
            },
            {
              "country_code": 154,
              "country_name_ch": "马尔代夫",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Maldives.svg",
              "cityIds": [
                1368
              ],
              "provinces": [
                {
                  "label": "马尔代夫",
                  "value": 1368
                }
              ]
            },
            {
              "country_code": 155,
              "country_name_ch": "塞拉利昂",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/SierraLeone.svg",
              "cityIds": [
                1369
              ],
              "provinces": [
                {
                  "label": "西部地区",
                  "value": 1369
                }
              ]
            },
            {
              "country_code": 159,
              "country_name_ch": "亚美尼亚",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Armenia.svg",
              "cityIds": [
                1432,
                1433,
                1434,
                1435,
                1436
              ],
              "provinces": [
                {
                  "label": "阿拉拉特省",
                  "value": 1432
                },
                {
                  "label": "亚美尼亚",
                  "value": 1433
                },
                {
                  "label": "格加尔库尼克省",
                  "value": 1434
                },
                {
                  "label": "埃里温",
                  "value": 1435
                },
                {
                  "label": "阿拉加措特恩省",
                  "value": 1436
                }
              ]
            },
            {
              "country_code": 160,
              "country_name_ch": "比利时",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Belgium.svg",
              "cityIds": [
                1437,
                1438,
                1439,
                1440
              ],
              "provinces": [
                {
                  "label": "布鲁塞尔－首都大区",
                  "value": 1437
                },
                {
                  "label": "瓦隆大区",
                  "value": 1438
                },
                {
                  "label": "比利时",
                  "value": 1439
                },
                {
                  "label": "弗拉芒大区",
                  "value": 1440
                }
              ]
            },
            {
              "country_code": 161,
              "country_name_ch": "波斯尼亚和黑塞哥维那",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/BosniaAndHerzegovina.svg",
              "cityIds": [
                1441,
                1442,
                1443,
                1444
              ],
              "provinces": [
                {
                  "label": "波斯尼亚和黑塞哥维那联邦",
                  "value": 1441
                },
                {
                  "label": "塞族共和国",
                  "value": 1442
                },
                {
                  "label": "布尔奇科特区",
                  "value": 1443
                },
                {
                  "label": "波斯尼亚和黑塞哥维那",
                  "value": 1444
                }
              ]
            },
            {
              "country_code": 162,
              "country_name_ch": "安提瓜和巴布达",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/AntiguaAndBarbuda.svg",
              "cityIds": [
                1445,
                1446
              ],
              "provinces": [
                {
                  "label": "圣约翰区",
                  "value": 1445
                },
                {
                  "label": "安提瓜和巴布达",
                  "value": 1446
                }
              ]
            },
            {
              "country_code": 163,
              "country_name_ch": "马达加斯加",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Madagascar.svg",
              "cityIds": [
                1447
              ],
              "provinces": [
                {
                  "label": "阿那拉芒加区",
                  "value": 1447
                }
              ]
            },
            {
              "country_code": 166,
              "country_name_ch": "哥斯达黎加",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/CostaRica.svg",
              "cityIds": [
                1510,
                1511,
                1512,
                1513,
                1514,
                1515,
                1516,
                1517
              ],
              "provinces": [
                {
                  "label": "利蒙省",
                  "value": 1510
                },
                {
                  "label": "卡塔戈省",
                  "value": 1511
                },
                {
                  "label": "埃雷迪亚省",
                  "value": 1512
                },
                {
                  "label": "圣何塞省",
                  "value": 1513
                },
                {
                  "label": "蓬塔雷纳斯省",
                  "value": 1514
                },
                {
                  "label": "哥斯达黎加",
                  "value": 1515
                },
                {
                  "label": "阿拉胡埃拉省",
                  "value": 1516
                },
                {
                  "label": "瓜纳卡斯特省",
                  "value": 1517
                }
              ]
            },
            {
              "country_code": 167,
              "country_name_ch": "科索沃",
              "country_name_en": "",
              "deviation": "",
              "countryFlag": "https://perfsight-cdn-1308074696.cos.accelerate.myqcloud.com/cdn/flags/Kosovo.svg",
              "cityIds": [
                1518,
                1519,
                1520,
                1521
              ],
              "provinces": [
                {
                  "label": "科索沃",
                  "value": 1518
                },
                {
                  "label": "格尼拉内区",
                  "value": 1519
                },
                {
                  "label": "普里什蒂纳区",
                  "value": 1520
                },
                {
                  "label": "普里兹伦区",
                  "value": 1521
                }
              ]
            }
          ],
          componentList: [
            {
              name: 'NetworkLatencyService',
              type: 'view',
              props: {
                requestParams: {
                  AggType: 'country',
                  Platform: 1,
                  _province: ['全部'],
                  _city: ['全部'],
                  cityIds: [],
                  app_version: ['1.0.0.0.409'],
                  _scene: [],
                  RequestID: 'performance_ios',
                  userName: 'judymao',
                  CountrySplit: 1,
                  projectId: 5120,
                  apmEnv: 'sgp',
                  projVersionIds: [1010323],
                  timezoneOffset: 0,
                  convertTodayToUtc: false,
                  todayLookbackHours: 11,
                  excludeVpn: false,
                  excludeCross: false,
                  netLables: [],
                },
                formatBeforeRequest: "function(data) {\n  data = data || {};\n  var filterValue = data.filterVal || data.filterValue || {};\n  var countryRegionOptions = data.countryRegionOptions || [];\n  var gameCode = data.gameCode;\n  var requestParams = data.requestParams || {};\n  var rangeTime = filterValue.rangeTime || filterValue.rangeDaily || [];\n  var countryValue = filterValue.country;\n  var isAllCountry = countryValue === undefined || countryValue === null || Number(countryValue) === -1;\n  var countryRegionOption;\n  for (var i = 0; i < countryRegionOptions.length; i++) {\n    if (Number(countryRegionOptions[i].country_code) === Number(countryValue)) {\n      countryRegionOption = countryRegionOptions[i];\n      break;\n    }\n  }\n  var regionName = String((countryRegionOption && (countryRegionOption.country_name_ch || countryRegionOption.country_name_en)) || '');\n  var isRegion = regionName.indexOf('地区') !== -1;\n  var countryName = isAllCountry\n    ? '全部'\n    : ((countryRegionOption && (countryRegionOption.country_name_en || countryRegionOption.country_name_ch)) || '');\n  var cityValue = (isAllCountry || isRegion)\n    ? []\n    : ((countryRegionOption && countryRegionOption.request_city) || []);\n  var normalizeDateStr = function(value) {\n    if (value === undefined || value === null || value === '') return '';\n    if (value && typeof value.format === 'function') return value.format('YYYY-MM-DD');\n    var str = String(value).trim();\n    return /^\\d{4}-\\d{2}-\\d{2}/.test(str) ? str.slice(0, 10) : '';\n  };\n  var startDate = normalizeDateStr(rangeTime[0]);\n  var endDate = normalizeDateStr(rangeTime[1]);\n  var timezoneOffset = Number(requestParams.timezoneOffset);\n  if (!isFinite(timezoneOffset)) timezoneOffset = 0;\n  var convertTodayToUtc = requestParams.convertTodayToUtc === true;\n  var lookbackHours = Number(requestParams.todayLookbackHours);\n  if (!isFinite(lookbackHours) || lookbackHours <= 0) lookbackHours = 11;\n  var pad = function(n) { return n < 10 ? '0' + n : '' + n; };\n  var formatUtc = function(date) {\n    return date.getUTCFullYear() + '-' + pad(date.getUTCMonth() + 1) + '-' + pad(date.getUTCDate()) + ' ' + pad(date.getUTCHours()) + ':' + pad(date.getUTCMinutes()) + ':' + pad(date.getUTCSeconds());\n  };\n  var todayUtcMs = Date.now() + timezoneOffset * 3600000;\n  var todayDate = new Date(todayUtcMs);\n  var today = todayDate.getUTCFullYear() + '-' + pad(todayDate.getUTCMonth() + 1) + '-' + pad(todayDate.getUTCDate());\n  var isToday = startDate && startDate === endDate && startDate === today;\n  var start;\n  var end;\n  if (convertTodayToUtc && isToday) {\n    var endDateTime = new Date();\n    endDateTime.setUTCMinutes(0, 0, 0);\n    endDateTime = new Date(endDateTime.getTime() - 3600000);\n    var startDateTime = new Date(endDateTime.getTime() - lookbackHours * 3600000);\n    start = formatUtc(startDateTime);\n    end = formatUtc(endDateTime);\n  } else {\n    start = startDate ? startDate + ' 00:00:00' : '';\n    end = endDate ? endDate + ' 23:59:59' : '';\n  }\n  var result = Object.assign({}, requestParams, {\n    game_code: gameCode,\n    start: start,\n    end: end,\n    timezoneOffset: timezoneOffset,\n    _country: [countryName],\n    _city: cityValue,\n    countryId: isAllCountry ? -1 : Number((countryRegionOption && countryRegionOption.country_code) || countryValue || -1),\n    cityIds: [],\n    AggType: (isAllCountry || isRegion) ? (requestParams.AggType || 'country') : 'province'\n  });\n  if (isAllCountry) {\n    result.IsCityAll = true;\n    result._province = [];\n  } else {\n    result._province = requestParams._province || ['全部'];\n  }\n  delete result.convertTodayToUtc;\n  delete result.todayLookbackHours;\n  return result;\n}",
                formatData: "function(response, filterVal) {\n  var payload = (response && response.data && response.data.ret) || (response && response.ret) || (response && response.data) || response || {};\n  var normalizeNetworkType = function(item) {\n    var next = Object.assign({}, item);\n    next.NetworkType = Number(item && item.NetworkType) === 6 ? 5 : (item && item.NetworkType);\n    return next;\n  };\n  var hasZoneMetric = function(item) {\n    return Number(item && item.MergeCount) > 0 || Number(item && item.Value) > 0 || Number(item && item.CountRatio) > 0;\n  };\n  var flattenHoursToTable = function(hoursData, times) {\n    var orderedTimes = (times && times.length) ? times.slice().reverse() : Object.keys(hoursData || {}).reverse();\n    var rows = [];\n    for (var i = 0; i < orderedTimes.length; i++) {\n      var items = hoursData && hoursData[orderedTimes[i]];\n      if (Array.isArray(items) && items.length) rows = rows.concat(items);\n    }\n    return rows;\n  };\n  var trendKeys = [\n    { networkType: 1, valueKey: 'dataWifi', countKey: 'battleDataWifi' },\n    { networkType: 2, valueKey: 'data2g', countKey: 'battleData2g' },\n    { networkType: 3, valueKey: 'data3g', countKey: 'battleData3g' },\n    { networkType: 4, valueKey: 'data4g', countKey: 'battleData4g' },\n    { networkType: 5, valueKey: 'data5g', countKey: 'battleData5g' }\n  ];\n  var buildHoursFromTrend = function(source) {\n    var trend = (source && source.netDelayTrend) || {};\n    var netDataTimes = (Array.isArray(trend.xData) && trend.xData.length ? trend.xData : source && source.netDelayTime) || [];\n    var netHoursData = {};\n    for (var i = 0; i < netDataTimes.length; i++) {\n      var time = netDataTimes[i];\n      var row = [];\n      for (var j = 0; j < trendKeys.length; j++) {\n        row.push({\n          CalendarTime: time,\n          NetworkType: trendKeys[j].networkType,\n          Value: trend[trendKeys[j].valueKey] && trend[trendKeys[j].valueKey][i],\n          MergeCount: trend[trendKeys[j].countKey] && trend[trendKeys[j].countKey][i]\n        });\n      }\n      row.push({\n        CalendarTime: time,\n        NetworkType: 0,\n        Value: trend.dataCommon && trend.dataCommon[i],\n        MergeCount: trend.count && trend.count[i]\n      });\n      netHoursData[time] = row;\n    }\n    return { netDataTimes: netDataTimes, netHoursData: netHoursData };\n  };\n  var flattenZoneAgg = function(zoneRows) {\n    if (Array.isArray(zoneRows)) return zoneRows;\n    if (!zoneRows || typeof zoneRows !== 'object') return [];\n    var rows = [];\n    var keys = Object.keys(zoneRows);\n    for (var z = 0; z < keys.length; z++) {\n      var key = keys[z];\n      var list = zoneRows[key];\n      if (!Array.isArray(list)) continue;\n      for (var r = 0; r < list.length; r++) {\n        var item = Object.assign({}, list[r] || {});\n        if (!item.CountryName) item.CountryName = key;\n        rows.push(item);\n      }\n    }\n    return rows;\n  };\n  var unwrapCountryValue = function(value) {\n    if (value === undefined || value === null || value === '') return value;\n    if (Array.isArray(value)) return unwrapCountryValue(value[0]);\n    if (value && typeof value === 'object') {\n      if (value.country_code !== undefined && value.country_code !== null) return value.country_code;\n      if (value.value !== undefined && value.value !== null) return value.value;\n    }\n    return value;\n  };\n  var countryValue = unwrapCountryValue(filterVal && filterVal.country);\n  var isAllCountry = countryValue === undefined || countryValue === null || countryValue === '' || Number(countryValue) === -1;\n  var pickFallbackZoneRows = function(zoneRows, ispRows, networkAgg, networkType) {\n    var flattened = flattenZoneAgg(zoneRows);\n    if (flattened.length) return flattened;\n    if (!isAllCountry) return [];\n    var ispTotals = [];\n    for (var i = 0; i < (ispRows || []).length; i++) {\n      var ispItem = ispRows[i];\n      if (!String((ispItem && ispItem.IspName) || '').trim() && hasZoneMetric(ispItem)) ispTotals.push(ispItem);\n    }\n    if (ispTotals.length) return ispTotals;\n    var normalized = [];\n    for (var n = 0; n < (networkAgg || []).length; n++) normalized.push(normalizeNetworkType(networkAgg[n]));\n    if (networkType === 0) {\n      var allType = [];\n      for (var a = 0; a < normalized.length; a++) {\n        if (Number(normalized[a].NetworkType) === 0 && hasZoneMetric(normalized[a])) allType.push(normalized[a]);\n      }\n      if (allType.length) return allType;\n      var ranked = normalized.filter(hasZoneMetric).sort(function(a, b) { return (b.CountRatio || 0) - (a.CountRatio || 0); });\n      return ranked[0] ? [ranked[0]] : [];\n    }\n    return normalized.filter(function(item) {\n      return Number(item.NetworkType) === networkType && hasZoneMetric(item);\n    });\n  };\n  var isNewFormat = Boolean((payload && payload.netHoursData) || (payload && payload.networkAgg) || (payload && payload.zoneAggAll));\n  var hours;\n  if (isNewFormat) {\n    var netHoursData = {};\n    var hourKeys = Object.keys((payload && payload.netHoursData) || {});\n    for (var h = 0; h < hourKeys.length; h++) {\n      netHoursData[hourKeys[h]] = ((payload.netHoursData[hourKeys[h]]) || []).map(normalizeNetworkType);\n    }\n    hours = {\n      netDataTimes: (Array.isArray(payload.netDataTimes) && payload.netDataTimes.length ? payload.netDataTimes : hourKeys) || [],\n      netHoursData: netHoursData\n    };\n  } else {\n    hours = buildHoursFromTrend(payload);\n  }\n  var networkAgg = ((payload && payload.networkAgg) || (payload && payload.netDistribution) || []).map(normalizeNetworkType);\n  return Object.assign({}, payload, {\n    netDataTimes: hours.netDataTimes,\n    netHoursData: hours.netHoursData,\n    netDelayTable: (payload && payload.netDelayTable) || flattenHoursToTable(hours.netHoursData, hours.netDataTimes),\n    networkAgg: networkAgg,\n    zoneAggAll: pickFallbackZoneRows((payload && payload.zoneAggAll) || (payload && payload.zoneAll) || [], payload && payload.ispAggAll, networkAgg, 0),\n    zoneAggWifi: pickFallbackZoneRows((payload && payload.zoneAggWifi) || (payload && payload.zoneWifi) || [], payload && payload.ispAggWifi, networkAgg, 1),\n    zoneAgg5G: pickFallbackZoneRows((payload && payload.zoneAgg5G) || (payload && payload.zone5G) || [], payload && payload.ispAgg5G, networkAgg, 5),\n    zoneAgg4G: pickFallbackZoneRows((payload && payload.zoneAgg4G) || (payload && payload.zone4G) || [], payload && payload.ispAgg4G, networkAgg, 4),\n    zoneAgg3G: pickFallbackZoneRows((payload && payload.zoneAgg3G) || (payload && payload.zone3G) || [], payload && payload.ispAgg3G, networkAgg, 3),\n    zoneAgg2G: pickFallbackZoneRows((payload && payload.zoneAgg2G) || (payload && payload.zone2G) || [], payload && payload.ispAgg2G, networkAgg, 2)\n  });\n}",
              },
              children: [
                {
                  name: 'NetworkLatencyTrend',
                  type: 'view',
                  className: 'dbd-network-latency-trend',
                  props: {
                    platform: 'ios',
                    config: {
                      titleCn: '网络延迟趋势',
                      titleEn: 'Network Latency Trend',
                      height: 280,
                      tableHeight: 350,
                      pageSize: 5,
                      unselectedLegendKeys: ['2g_latency', '3g_latency'],
                      yAxis: [
                        {
                          nameCn: '网络延迟(ms)',
                          nameEn: 'Network Latency(ms)',
                          formatRule: 'oneDecimal',
                        },
                      ],
                      componentMetrics: [
                        {
                          metricKey: 'wifi_latency',
                          nameCn: 'WiFi网络延迟',
                          nameEn: 'WiFi Latency',
                          formatRule: 'twoDecimal',
                          yAxisIndex: 0,
                          color: '#5B6CFF',
                        },
                        {
                          metricKey: '2g_latency',
                          nameCn: '2G网络延迟',
                          nameEn: '2G Latency',
                          formatRule: 'twoDecimal',
                          yAxisIndex: 0,
                          color: '#8C9AAF',
                        },
                        {
                          metricKey: '3g_latency',
                          nameCn: '3G网络延迟',
                          nameEn: '3G Latency',
                          formatRule: 'twoDecimal',
                          yAxisIndex: 0,
                          color: '#A78BFA',
                        },
                        {
                          metricKey: '4g_latency',
                          nameCn: '4G网络延迟',
                          nameEn: '4G Latency',
                          formatRule: 'twoDecimal',
                          yAxisIndex: 0,
                          color: '#FF7961',
                        },
                        {
                          metricKey: '5g_latency',
                          nameCn: '5G网络延迟',
                          nameEn: '5G Latency',
                          formatRule: 'twoDecimal',
                          yAxisIndex: 0,
                          color: '#00B8BF',
                        },
                      ],
                    },
                  },
                },
                {
                  name: 'NetworkLatencyDistribution',
                  type: 'view',
                  props: {
                    platform: 'ios',
                    config: {
                      titleCn: '网络延迟分布',
                      titleEn: 'Network Latency Distribution',
                      titleInfoCn: '数据为所选时间段内累计数据的分布',
                      titleInfoEn:
                        'The data shows the cumulative distribution within the selected time range.',
                      pieMetricKey: 'share',
                      chartPercentDecimal: 2,
                      chartHeight: 290,
                      tableHeight: 310,
                      mapRanges: [0, 99, 301],
                      tableGroup: {
                        nameCn: '网络状态分布占比',
                        nameEn: 'Network Status Distribution',
                        align: 'center',
                        metricKeys: ['p0', 'p30', 'p60'],
                      },
                      colors: [
                        '#5B6CFF',
                        '#F0A33A',
                        '#B6BDCC',
                        '#8C9AAF',
                        '#F1749C',
                      ],
                      componentMetrics: [
                        {
                          metricKey: 'network',
                          nameCn: '网络类型',
                          nameEn: 'Network Type',
                          width: 110,
                          align: 'left',
                          lock: true,
                        },
                        {
                          metricKey: 'share',
                          nameCn: '占比(%)',
                          nameEn: 'Share(%)',
                          width: 130,
                          formatRule: 'percent2Decimal',
                          downLoadFormat: '0.00%',
                          showProgressBar: true,
                        },
                        {
                          metricKey: 'latency',
                          nameCn: '平均网络延时(ms)',
                          nameEn: 'Average Latency(ms)',
                          width: 160,
                          formatRule: 'twoDecimal',
                          downLoadFormat: '0.00',
                        },
                        {
                          metricKey: 'p0',
                          nameCn: '0-99(ms) 占比(%)',
                          nameEn: '0-99(ms) Share(%)',
                          width: 155,
                          formatRule: 'percent2Decimal',
                          downLoadFormat: '0.00%',
                          showProgressBar: true,
                        },
                        {
                          metricKey: 'p30',
                          nameCn: '99-301(ms) 占比(%)',
                          nameEn: '99-301(ms) Share(%)',
                          width: 165,
                          formatRule: 'percent2Decimal',
                          downLoadFormat: '0.00%',
                          showProgressBar: true,
                        },
                        {
                          metricKey: 'p60',
                          nameCn: '>301(ms) 占比(%)',
                          nameEn: '>301(ms) Share(%)',
                          width: 175,
                          formatRule: 'percent2Decimal',
                          downLoadFormat: '0.00%',
                          showProgressBar: true,
                        },
                      ],
                    },
                  },
                },
                {
                  name: 'CountryLatencyDistribution',
                  type: 'view',
                  props: {
                    platform: 'ios',
                    config: {
                      titleCn: '国家/地区网络延迟分布',
                      titleEn: 'Country/Region Network Latency Distribution',
                      titleInfoCn:
                        '数据为所选时间段内累计数据的分布，国家/地区信息来自IP解析。',
                      titleInfoEn:
                        'The data shows the cumulative distribution within the selected time range. Country/region information is parsed from IP.',
                      mapHeight: 350,
                      tableHeight: 350,
                      tableGroup: {
                        nameCn: '网络延迟分段占比',
                        nameEn: 'Network Latency Distribution',
                        align: 'center',
                        metricKeys: ['p0', 'p30', 'p60'],
                      },
                      networkOptions: [
                        { text: '全部', value: 'all' },
                        { text: 'WIFI', value: 'wifi' },
                        { text: '5G', value: '5g' },
                        { text: '4G', value: '4g' },
                        { text: '3G', value: '3g' },
                        { text: '2G', value: '2g' },
                      ],
                      mapMetric: {
                        metricKey: 'latency',
                        nameCn: '平均网络延迟',
                        nameEn: 'Average Network Latency',
                        unitCn: 'ms',
                        unitEn: 'ms',
                        formatRule: 'twoDecimal',
                      },
                      mapColors: ['#26C477', '#F3B800', '#F26322'],
                      mapLegendMinMs: 0,
                      mapLegendMidMs: 99,
                      mapLegendMaxMs: 301,
                      mapLegendUnit: 'ms',
                      mapRanges: [0, 99, 301],
                      mapLegend: [
                        { label: '301+', colorIndex: 2 },
                        { label: '99-301', colorIndex: 1 },
                        { label: '0-99', colorIndex: 0 },
                      ],
                      componentMetrics: [
                        {
                          metricKey: 'country',
                          nameCn: '国家/地区',
                          nameEn: 'Country/Region',
                          width: 150,
                          align: 'left',
                          lock: true,
                          showCountryFlag: false,
                        },
                        {
                          metricKey: 'network',
                          nameCn: '网络类型',
                          nameEn: 'Network Type',
                          width: 100,
                          align: 'left',
                        },
                        {
                          metricKey: 'share',
                          nameCn: '占比(%)',
                          nameEn: 'Share(%)',
                          width: 130,
                          formatRule: 'percent2Decimal',
                          downLoadFormat: '0.00%',
                          showProgressBar: true,
                        },
                        {
                          metricKey: 'latency',
                          nameCn: '平均网络延时(ms)',
                          nameEn: 'Average Latency(ms)',
                          width: 160,
                          formatRule: 'twoDecimal',
                          downLoadFormat: '0.00',
                        },
                        {
                          metricKey: 'p0',
                          nameCn: '0-99(ms) 占比(%)',
                          nameEn: '0-99(ms) Share(%)',
                          width: 155,
                          formatRule: 'percent2Decimal',
                          downLoadFormat: '0.00%',
                          showProgressBar: true,
                        },
                        {
                          metricKey: 'p30',
                          nameCn: '99-301(ms) 占比(%)',
                          nameEn: '99-301(ms) Share(%)',
                          width: 165,
                          formatRule: 'percent2Decimal',
                          downLoadFormat: '0.00%',
                          showProgressBar: true,
                        },
                        {
                          metricKey: 'p60',
                          nameCn: '>301(ms) 占比(%)',
                          nameEn: '>301(ms) Share(%)',
                          width: 175,
                          formatRule: 'percent2Decimal',
                          downLoadFormat: '0.00%',
                          showProgressBar: true,
                        },
                      ],
                    },
                  },
                },

              ],
            },
          ],
        },
      ],
    },
  ],
};

